// ==============================================
// CUET (DU) College Data - Complete Dataset
// Source: afterboards.in/cuet-course-eligibility
// Auto-generated on 2026-03-04
// Total Programs: 79
// Total Unique Colleges: 72
// Total Cutoff Entries: 1528
// ==============================================

export const seatCategories = [
  "UR",
  "OBC_NCL",
  "SC",
  "ST",
  "EWS",
  "Sikh",
  "Christian",
  "PwBD",
  "CW",
  "KM",
];

export const collegeData = {
  "B.A. (Hons.) Arabic": [
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
  ],
  "B.A. (Hons.) Bengali": [
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 3,
        OBC_NCL: 3,
        SC: 2,
        ST: 1,
        EWS: 1,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
  ],
  "B.A. (Hons.) English": [
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 42,
        OBC_NCL: 28,
        SC: 16,
        ST: 8,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 5,
        KM: 4,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Delhi College of Arts and Commerce",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dyal Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 14,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 27,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 27,
        OBC_NCL: 19,
        SC: 10,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 50,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 50,
        PwBD: 5,
        CW: 5,
        KM: 4,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 22,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 43,
        OBC_NCL: 29,
        SC: 16,
        ST: 8,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maharaja Agrasen College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 30,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 30,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Motilal Nehru College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 0,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 4,
        KM: 0,
      },
    },
    {
      name: "Satyawati College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Shaheed Bhagat Singh College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 32,
        SC: 18,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Sri Aurobindo College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Sri Aurobindo College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 15,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "St. Stephen's College",
      campus: "North Campus",
      seats: {
        UR: 12,
        OBC_NCL: 0,
        SC: 2,
        ST: 1,
        EWS: 0,
        Sikh: 0,
        Christian: 15,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 35,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Zakir Husain Delhi College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.A. (Hons.) French": [
    {
      name: "Department of Germanic and Romance Studies",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Hons.) German": [
    {
      name: "Department of Germanic and Romance Studies",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Hons.) Hindi": [
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 21,
        OBC_NCL: 14,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Bhagini Nivedita College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 9,
        ST: 5,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 27,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 22,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maharaja Agrasen College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 58,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 58,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Motilal Nehru College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "P.G.D.A.V. College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Satyawati College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Shaheed Bhagat Singh College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyam Lal College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Sri Aurobindo College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Sri Aurobindo College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 15,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 35,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Zakir Husain Delhi College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 8,
        OBC_NCL: 5,
        SC: 3,
        ST: 1,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
  ],
  "B.A. (Hons.) Italian": [
    {
      name: "Department of Germanic and Romance Studies",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Hons.) Persian": [
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Zakir Husain Delhi College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 8,
        OBC_NCL: 5,
        SC: 3,
        ST: 1,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
  ],
  "B.A. (Hons.) Punjabi": [
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 15,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Gobind Singh College of Commerce",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 23,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 15,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Hons.) Russian": [
    {
      name: "Department of Slavonic & Finno-Ugrian Studies",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Hons.) Sanskrit": [
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 12,
        SC: 7,
        ST: 3,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 3,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 9,
        OBC_NCL: 6,
        SC: 4,
        ST: 2,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 12,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 12,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 15,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "P.G.D.A.V. College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 5,
        ST: 2,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyama Prasad Mukherji College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "St. Stephen's College",
      campus: "North Campus",
      seats: {
        UR: 3,
        OBC_NCL: 0,
        SC: 1,
        ST: 1,
        EWS: 0,
        Sikh: 0,
        Christian: 5,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Zakir Husain Delhi College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 8,
        OBC_NCL: 5,
        SC: 3,
        ST: 1,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
  ],
  "B.A. (Hons.) Spanish": [
    {
      name: "Department of Germanic and Romance Studies",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Hons.) Urdu": [
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 9,
        OBC_NCL: 6,
        SC: 4,
        ST: 2,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Zakir Husain Delhi College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 8,
        OBC_NCL: 5,
        SC: 3,
        ST: 1,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
  ],
  "B.A. (Hons.) Applied Psychology": [
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 3,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 2,
        KM: 3,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Sri Aurobindo College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Hons.) Psychology": [
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 21,
        OBC_NCL: 14,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 12,
        SC: 7,
        ST: 3,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Keshav Mahavidyalaya",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 52,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 53,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.A. (Hons.) Economics": [
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 21,
        OBC_NCL: 14,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 38,
        OBC_NCL: 26,
        SC: 14,
        ST: 7,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Delhi College of Arts and Commerce",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 9,
        ST: 5,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 55,
        OBC_NCL: 36,
        SC: 20,
        ST: 10,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 28,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 27,
        OBC_NCL: 19,
        SC: 10,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 43,
        OBC_NCL: 29,
        SC: 16,
        ST: 8,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 2,
        KM: 3,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 0,
      },
    },
    {
      name: "Satyawati College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Shaheed Bhagat Singh College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shri Ram College of Commerce",
      campus: "North Campus",
      seats: {
        UR: 63,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 32,
        SC: 18,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Shyam Lal College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Sri Aurobindo College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Sri Guru Gobind Singh College of Commerce",
      campus: "South Campus",
      seats: {
        UR: 40,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 40,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "St. Stephen's College",
      campus: "North Campus",
      seats: {
        UR: 21,
        OBC_NCL: 0,
        SC: 3,
        ST: 1,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Hons.) Geography": [
    {
      name: "Aditi Mahavidyalaya (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 22,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shaheed Bhagat Singh College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shaheed Bhagat Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyama Prasad Mukherji College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 35,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 4,
        KM: 1,
      },
    },
  ],
  "B.A. (Hons.) Hindi Patrakarita": [
    {
      name: "Aditi Mahavidyalaya (W)",
      campus: "South Campus",
      seats: {
        UR: 22,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 11,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 10,
        OBC_NCL: 7,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Hons.) History": [
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 42,
        OBC_NCL: 28,
        SC: 16,
        ST: 8,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Bhagini Nivedita College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Delhi College of Arts and Commerce",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 32,
        SC: 18,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 9,
        ST: 5,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dyal Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 21,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 27,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 14,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 22,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 43,
        OBC_NCL: 29,
        SC: 16,
        ST: 8,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 30,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 30,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Motilal Nehru College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 43,
        OBC_NCL: 29,
        SC: 16,
        ST: 8,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 0,
      },
    },
    {
      name: "Satyawati College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Shaheed Bhagat Singh College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 15,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "St. Stephen's College",
      campus: "North Campus",
      seats: {
        UR: 24,
        OBC_NCL: 0,
        SC: 4,
        ST: 2,
        EWS: 0,
        Sikh: 0,
        Christian: 30,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 35,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Zakir Husain Delhi College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.A. (Hons.) Humanities & Social Sciences": [
    {
      name: "Cluster Innovation Centre",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 14,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
  ],
  "B.A. (Hons.) Journalism": [
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Delhi College of Arts and Commerce",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Institute of Home Economics (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 14,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 0,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Maharaja Agrasen College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "Five Year Integrated Program in Journalism": [
    {
      name: "Delhi School of Journalism",
      campus: "North Campus",
      seats: {
        UR: 40,
        OBC_NCL: 27,
        SC: 15,
        ST: 8,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 0,
      },
    },
  ],
  "B.A. (Hons.) Multimedia and Mass Communication": [
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.A. (Hons.) Philosophy": [
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 22,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 22,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 2,
        KM: 3,
      },
    },
    {
      name: "Shyama Prasad Mukherji College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "St. Stephen's College",
      campus: "North Campus",
      seats: {
        UR: 3,
        OBC_NCL: 0,
        SC: 1,
        ST: 1,
        EWS: 0,
        Sikh: 0,
        Christian: 5,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Hons.) Political Science": [
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 42,
        OBC_NCL: 28,
        SC: 16,
        ST: 8,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 38,
        OBC_NCL: 26,
        SC: 14,
        ST: 7,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Bhagini Nivedita College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 7,
      },
    },
    {
      name: "Delhi College of Arts and Commerce",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 62,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dyal Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 14,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 2,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 57,
        OBC_NCL: 38,
        SC: 21,
        ST: 11,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 62,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 2,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 1,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 43,
        OBC_NCL: 29,
        SC: 16,
        ST: 8,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Maharaja Agrasen College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 60,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 60,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 28,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Motilal Nehru College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "P.G.D.A.V. College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 0,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 0,
      },
    },
    {
      name: "Satyawati College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Shaheed Bhagat Singh College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shaheed Bhagat Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyam Lal College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Sri Aurobindo College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 5,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 15,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 54,
        OBC_NCL: 37,
        SC: 21,
        ST: 11,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 6,
      },
    },
    {
      name: "Zakir Husain Delhi College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.A. (Hons.) Social Work": [
    {
      name: "Aditi Mahavidyalaya (W)",
      campus: "South Campus",
      seats: {
        UR: 22,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 11,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
  ],
  "B.A. (Hons.) Sociology": [
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.A. (Program)": [
    {
      name: "Aditi Mahavidyalaya (W)",
      campus: "South Campus",
      seats: {
        UR: 272,
        OBC_NCL: 181,
        SC: 101,
        ST: 50,
        EWS: 68,
        Sikh: 0,
        Christian: 0,
        PwBD: 34,
        CW: 34,
        KM: 34,
      },
    },
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 63,
        OBC_NCL: 42,
        SC: 24,
        ST: 12,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 9,
        CW: 9,
        KM: 9,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 45,
        OBC_NCL: 32,
        SC: 18,
        ST: 9,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Bhagini Nivedita College (W)",
      campus: "South Campus",
      seats: {
        UR: 203,
        OBC_NCL: 136,
        SC: 79,
        ST: 41,
        EWS: 51,
        Sikh: 0,
        Christian: 0,
        PwBD: 26,
        CW: 26,
        KM: 17,
      },
    },
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 62,
        SC: 36,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 85,
        OBC_NCL: 57,
        SC: 32,
        ST: 16,
        EWS: 21,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 10,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 48,
        OBC_NCL: 33,
        SC: 18,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Delhi College of Arts and Commerce",
      campus: "South Campus",
      seats: {
        UR: 69,
        OBC_NCL: 46,
        SC: 26,
        ST: 13,
        EWS: 17,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 96,
        OBC_NCL: 64,
        SC: 35,
        ST: 18,
        EWS: 24,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 164,
        OBC_NCL: 109,
        SC: 61,
        ST: 32,
        EWS: 39,
        Sikh: 0,
        Christian: 0,
        PwBD: 19,
        CW: 18,
        KM: 19,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 62,
        SC: 36,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 11,
        KM: 12,
      },
    },
    {
      name: "Dyal Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 170,
        OBC_NCL: 115,
        SC: 65,
        ST: 31,
        EWS: 43,
        Sikh: 0,
        Christian: 0,
        PwBD: 21,
        CW: 21,
        KM: 21,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 62,
        SC: 35,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 11,
        CW: 10,
        KM: 4,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 100,
        OBC_NCL: 70,
        SC: 40,
        ST: 20,
        EWS: 20,
        Sikh: 0,
        Christian: 0,
        PwBD: 15,
        CW: 15,
        KM: 15,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 14,
        SC: 8,
        ST: 4,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 115,
        OBC_NCL: 77,
        SC: 45,
        ST: 24,
        EWS: 24,
        Sikh: 0,
        Christian: 0,
        PwBD: 22,
        CW: 14,
        KM: 14,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 116,
        OBC_NCL: 71,
        SC: 41,
        ST: 29,
        EWS: 32,
        Sikh: 0,
        Christian: 0,
        PwBD: 13,
        CW: 13,
        KM: 13,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 273,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 273,
        PwBD: 21,
        CW: 21,
        KM: 21,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 119,
        OBC_NCL: 77,
        SC: 41,
        ST: 22,
        EWS: 30,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 62,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 16,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 12,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 43,
        OBC_NCL: 26,
        SC: 17,
        ST: 10,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 34,
        OBC_NCL: 19,
        SC: 10,
        ST: 9,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 214,
        OBC_NCL: 144,
        SC: 80,
        ST: 40,
        EWS: 53,
        Sikh: 0,
        Christian: 0,
        PwBD: 27,
        CW: 27,
        KM: 27,
      },
    },
    {
      name: "Maharaja Agrasen College",
      campus: "South Campus",
      seats: {
        UR: 77,
        OBC_NCL: 52,
        SC: 29,
        ST: 15,
        EWS: 20,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 10,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 95,
        OBC_NCL: 62,
        SC: 34,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 11,
        CW: 11,
        KM: 11,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 126,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 126,
        Christian: 0,
        PwBD: 18,
        CW: 18,
        KM: 18,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 93,
        OBC_NCL: 65,
        SC: 35,
        ST: 12,
        EWS: 26,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 140,
        OBC_NCL: 93,
        SC: 52,
        ST: 26,
        EWS: 35,
        Sikh: 0,
        Christian: 0,
        PwBD: 16,
        CW: 17,
        KM: 9,
      },
    },
    {
      name: "Motilal Nehru College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 186,
        OBC_NCL: 124,
        SC: 69,
        ST: 35,
        EWS: 46,
        Sikh: 0,
        Christian: 0,
        PwBD: 23,
        CW: 23,
        KM: 23,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 94,
        OBC_NCL: 62,
        SC: 35,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 13,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "P.G.D.A.V. College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 140,
        OBC_NCL: 93,
        SC: 50,
        ST: 27,
        EWS: 37,
        Sikh: 0,
        Christian: 0,
        PwBD: 17,
        CW: 17,
        KM: 17,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 95,
        OBC_NCL: 62,
        SC: 34,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 11,
        CW: 11,
        KM: 11,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 15,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 50,
        OBC_NCL: 33,
        SC: 20,
        ST: 9,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 11,
        CW: 11,
        KM: 10,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 56,
        OBC_NCL: 38,
        SC: 21,
        ST: 10,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 169,
        OBC_NCL: 93,
        SC: 46,
        ST: 29,
        EWS: 32,
        Sikh: 0,
        Christian: 0,
        PwBD: 16,
        CW: 19,
        KM: 0,
      },
    },
    {
      name: "Satyawati College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 145,
        OBC_NCL: 95,
        SC: 52,
        ST: 27,
        EWS: 35,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Shaheed Bhagat Singh College",
      campus: "South Campus",
      seats: {
        UR: 42,
        OBC_NCL: 30,
        SC: 18,
        ST: 12,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Shaheed Bhagat Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 95,
        OBC_NCL: 62,
        SC: 34,
        ST: 16,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 11,
        KM: 10,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 63,
        SC: 35,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 78,
        OBC_NCL: 52,
        SC: 30,
        ST: 14,
        EWS: 19,
        Sikh: 0,
        Christian: 0,
        PwBD: 9,
        CW: 9,
        KM: 9,
      },
    },
    {
      name: "Shyam Lal College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 94,
        OBC_NCL: 65,
        SC: 38,
        ST: 16,
        EWS: 25,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 193,
        OBC_NCL: 129,
        SC: 70,
        ST: 41,
        EWS: 47,
        Sikh: 0,
        Christian: 0,
        PwBD: 20,
        CW: 20,
        KM: 20,
      },
    },
    {
      name: "Sri Aurobindo College (Day)",
      campus: "South Campus",
      seats: {
        UR: 153,
        OBC_NCL: 105,
        SC: 59,
        ST: 29,
        EWS: 39,
        Sikh: 0,
        Christian: 0,
        PwBD: 19,
        CW: 19,
        KM: 10,
      },
    },
    {
      name: "Sri Aurobindo College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 117,
        OBC_NCL: 78,
        SC: 43,
        ST: 22,
        EWS: 29,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 15,
        KM: 0,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 60,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 60,
        Christian: 0,
        PwBD: 6,
        CW: 9,
        KM: 9,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 30,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 30,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "St. Stephen's College",
      campus: "North Campus",
      seats: {
        UR: 21,
        OBC_NCL: 0,
        SC: 3,
        ST: 1,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 157,
        OBC_NCL: 91,
        SC: 51,
        ST: 27,
        EWS: 20,
        Sikh: 0,
        Christian: 0,
        PwBD: 11,
        CW: 17,
        KM: 6,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 78,
        OBC_NCL: 53,
        SC: 30,
        ST: 16,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 15,
        CW: 10,
        KM: 15,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 156,
        OBC_NCL: 104,
        SC: 58,
        ST: 28,
        EWS: 38,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 19,
        KM: 0,
      },
    },
    {
      name: "Zakir Husain Delhi College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 63,
        SC: 35,
        ST: 16,
        EWS: 24,
        Sikh: 0,
        Christian: 0,
        PwBD: 14,
        CW: 12,
        KM: 3,
      },
    },
  ],
  "B.Sc. (Hons.) Anthropology": [
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Biological Science": [
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.Sc. (Hons.) Biomedical Science": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Biochemistry": [
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Institute of Home Economics (W)",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Botany": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 11,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 14,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 15,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 18,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 17,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Chemistry": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 35,
        OBC_NCL: 23,
        SC: 13,
        ST: 6,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 35,
        OBC_NCL: 23,
        SC: 13,
        ST: 7,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 32,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 58,
        OBC_NCL: 39,
        SC: 22,
        ST: 11,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 3,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 13,
        OBC_NCL: 9,
        SC: 5,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 10,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 10,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "St. Stephen's College",
      campus: "North Campus",
      seats: {
        UR: 21,
        OBC_NCL: 0,
        SC: 3,
        ST: 1,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 18,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 35,
        OBC_NCL: 23,
        SC: 13,
        ST: 6,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
  ],
  "B.Sc. (Hons.) Computer Science": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 21,
        OBC_NCL: 14,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Keshav Mahavidyalaya",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 23,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 2,
        KM: 3,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Shaheed Sukhdev College Business Studies",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 28,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Sri Guru Gobind Singh College of Commerce",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 23,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 23,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Electronics": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Keshav Mahavidyalaya",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Maharaja Agrasen College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Aurobindo College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 10,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 10,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Environmental Science": [
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Food Technology": [
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Institute of Home Economics (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Lady Irwin College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Geology": [
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Home Science": [
    {
      name: "Bhagini Nivedita College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Institute of Home Economics (W)",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Lady Irwin College (W)",
      campus: "South Campus",
      seats: {
        UR: 51,
        OBC_NCL: 34,
        SC: 19,
        ST: 10,
        EWS: 13,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 12,
        OBC_NCL: 8,
        SC: 5,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Instrumentation": [
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Mathematics": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 21,
        OBC_NCL: 14,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 38,
        OBC_NCL: 26,
        SC: 14,
        ST: 7,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 3,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 32,
        SC: 18,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 32,
        SC: 18,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 51,
        OBC_NCL: 34,
        SC: 19,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 14,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Keshav Mahavidyalaya",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 33,
        OBC_NCL: 23,
        SC: 13,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 30,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 30,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 35,
        OBC_NCL: 24,
        SC: 13,
        ST: 7,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 22,
        SC: 11,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 2,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "P.G.D.A.V. College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 2,
        KM: 3,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Shaheed Bhagat Singh College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 12,
        SC: 7,
        ST: 3,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 23,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "St. Stephen's College",
      campus: "North Campus",
      seats: {
        UR: 21,
        OBC_NCL: 0,
        SC: 3,
        ST: 1,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 15,
        ST: 7,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 4,
      },
    },
  ],
  "B.Sc. (Hons.) Microbiology": [
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Institute of Home Economics (W)",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 18,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 2,
        KM: 1,
      },
    },
  ],
  "B.Sc. (Hons.) Physics": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 35,
        OBC_NCL: 23,
        SC: 13,
        ST: 6,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Bhagini Nivedita College (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 35,
        OBC_NCL: 23,
        SC: 13,
        ST: 7,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 32,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Keshav Mahavidyalaya",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 58,
        OBC_NCL: 39,
        SC: 22,
        ST: 11,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 35,
        OBC_NCL: 23,
        SC: 13,
        ST: 6,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 22,
        SC: 11,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 2,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "St. Stephen's College",
      campus: "North Campus",
      seats: {
        UR: 21,
        OBC_NCL: 0,
        SC: 3,
        ST: 1,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 18,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 2,
        KM: 1,
      },
    },
  ],
  "B.Sc. (Hons.) Polymer Science": [
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.Sc. (Hons.) Statistics": [
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 14,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 23,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "P.G.D.A.V College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 2,
        KM: 3,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Hons.) Zoology": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Bhaskaracharya College of Applied Sciences",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 11,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 19,
        OBC_NCL: 14,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 15,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 18,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 19,
        OBC_NCL: 13,
        SC: 7,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Tech. Information Technology and Mathematical Innovation": [
    {
      name: "Cluster Innovation Centre",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 14,
        SC: 7,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
  ],
  "B.Sc. (Prog.) Applied Life Science": [
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 18,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 2,
        KM: 1,
      },
    },
  ],
  "B.Sc. (Prog.) Applied Physical Science with Analytical Methods in Chemistry & Biochemistry":
    [
      {
        name: "Kirori Mal College",
        campus: "North Campus",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  "B.Sc. (Prog.) Applied Physical Science with Industrial Chemistry": [
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Sc. (Pass) Home Science": [
    {
      name: "Institute of Home Economics (W)",
      campus: "South Campus",
      seats: {
        UR: 109,
        OBC_NCL: 73,
        SC: 41,
        ST: 20,
        EWS: 27,
        Sikh: 0,
        Christian: 0,
        PwBD: 14,
        CW: 14,
        KM: 14,
      },
    },
    {
      name: "Lady Irwin College (W)",
      campus: "South Campus",
      seats: {
        UR: 111,
        OBC_NCL: 75,
        SC: 42,
        ST: 21,
        EWS: 28,
        Sikh: 0,
        Christian: 0,
        PwBD: 14,
        CW: 14,
        KM: 14,
      },
    },
  ],
  "B.Sc. (Prog.) Life Science": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 2,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 17,
        OBC_NCL: 12,
        SC: 6,
        ST: 4,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 13,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 18,
        OBC_NCL: 12,
        SC: 7,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 58,
        OBC_NCL: 39,
        SC: 22,
        ST: 11,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Sri Aurobindo College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 62,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 9,
        CW: 9,
        KM: 9,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 53,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 6,
        KM: 1,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 35,
        OBC_NCL: 23,
        SC: 13,
        ST: 6,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
  ],
  "B.Sc. (Prog.) Mathematical Science": [
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Keshav Mahavidyalaya",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Maharaja Agrasen College",
      campus: "South Campus",
      seats: {
        UR: 27,
        OBC_NCL: 19,
        SC: 10,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "P.G.D.A.V College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.Sc. In Physical Education, Health Education & Sports": [
    {
      name: "Indira Gandhi Institute of Physical Education and Sports Sciences",
      campus: "South Campus",
      seats: {
        UR: 54,
        OBC_NCL: 36,
        SC: 20,
        ST: 10,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
  ],
  "B.Sc. (Prog.) Physical Science with Chemistry": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Bhagini Nivedita College (W)",
      campus: "South Campus",
      seats: {
        UR: 18,
        OBC_NCL: 12,
        SC: 7,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 1,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 62,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 62,
        OBC_NCL: 42,
        SC: 24,
        ST: 11,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 7,
        KM: 8,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 11,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 1,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 58,
        OBC_NCL: 39,
        SC: 22,
        ST: 11,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Maharaja Agrasen College",
      campus: "South Campus",
      seats: {
        UR: 8,
        OBC_NCL: 5,
        SC: 3,
        ST: 2,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 22,
        SC: 11,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 2,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 63,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 16,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 61,
        OBC_NCL: 41,
        SC: 23,
        ST: 11,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "Sri Aurobindo College",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "St. Stephen's College",
      campus: "North Campus",
      seats: {
        UR: 11,
        OBC_NCL: 0,
        SC: 1,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 12,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 53,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 6,
        KM: 1,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 35,
        OBC_NCL: 23,
        SC: 13,
        ST: 6,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
  ],
  "B.Sc. (Prog.) Physical Science with Electronics": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 16,
        OBC_NCL: 11,
        SC: 6,
        ST: 3,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 30,
        OBC_NCL: 21,
        SC: 12,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 28,
        OBC_NCL: 19,
        SC: 10,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.Sc. (Prog.) Physical Science with Computer Science/Informatics Practices":
    [
      {
        name: "Acharya Narendra Dev College",
        campus: "South Campus",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        campus: "South Campus",
        seats: {
          UR: 31,
          OBC_NCL: 20,
          SC: 12,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Bhagini Nivedita College (W)",
        campus: "South Campus",
        seats: {
          UR: 18,
          OBC_NCL: 12,
          SC: 7,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        campus: "South Campus",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Deshbandhu College",
        campus: "South Campus",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College",
        campus: "South Campus",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Hansraj College",
        campus: "North Campus",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        campus: "South Campus",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Keshav Mahavidyalaya",
        campus: "South Campus",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Kirori Mal College",
        campus: "North Campus",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Maharaja Agrasen College",
        campus: "South Campus",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Maitreyi College (W)",
        campus: "South Campus",
        seats: {
          UR: 15,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Miranda House (W)",
        campus: "North Campus",
        seats: {
          UR: 18,
          OBC_NCL: 12,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Motilal Nehru College",
        campus: "South Campus",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Rajdhani College",
        campus: "South Campus",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 2,
          KM: 3,
        },
      },
      {
        name: "Shivaji College",
        campus: "South Campus",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Shyam Lal College",
        campus: "South Campus",
        seats: {
          UR: 28,
          OBC_NCL: 19,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        campus: "North Campus",
        seats: {
          UR: 10,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 10,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "St. Stephen's College",
        campus: "North Campus",
        seats: {
          UR: 10,
          OBC_NCL: 0,
          SC: 2,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 13,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
    ],
  "B.Com. (Hons.)": [
    {
      name: "Acharya Narendra Dev College",
      campus: "South Campus",
      seats: {
        UR: 50,
        OBC_NCL: 34,
        SC: 19,
        ST: 9,
        EWS: 13,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Aditi Mahavidyalaya (W)",
      campus: "South Campus",
      seats: {
        UR: 27,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 21,
        OBC_NCL: 14,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 71,
        OBC_NCL: 47,
        SC: 26,
        ST: 13,
        EWS: 17,
        Sikh: 0,
        Christian: 0,
        PwBD: 9,
        CW: 9,
        KM: 9,
      },
    },
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 61,
        OBC_NCL: 41,
        SC: 23,
        ST: 11,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 14,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 56,
        OBC_NCL: 38,
        SC: 21,
        ST: 10,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 62,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 7,
      },
    },
    {
      name: "Delhi College of Arts and Commerce",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Deshbandhu College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 63,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 62,
        SC: 36,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "Dyal Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 14,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 63,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 16,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 2,
      },
    },
    {
      name: "Hansraj College",
      campus: "North Campus",
      seats: {
        UR: 105,
        OBC_NCL: 70,
        SC: 39,
        ST: 20,
        EWS: 26,
        Sikh: 0,
        Christian: 0,
        PwBD: 13,
        CW: 13,
        KM: 13,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 32,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 57,
        OBC_NCL: 38,
        SC: 21,
        ST: 11,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 70,
        OBC_NCL: 46,
        SC: 26,
        ST: 13,
        EWS: 17,
        Sikh: 0,
        Christian: 0,
        PwBD: 9,
        CW: 9,
        KM: 9,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 50,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 50,
        PwBD: 5,
        CW: 5,
        KM: 4,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 1,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 27,
        OBC_NCL: 19,
        SC: 10,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Keshav Mahavidyalaya",
      campus: "South Campus",
      seats: {
        UR: 77,
        OBC_NCL: 52,
        SC: 29,
        ST: 15,
        EWS: 19,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 10,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 43,
        OBC_NCL: 29,
        SC: 16,
        ST: 8,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 27,
        OBC_NCL: 18,
        SC: 10,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Maharaja Agrasen College",
      campus: "South Campus",
      seats: {
        UR: 77,
        OBC_NCL: 52,
        SC: 29,
        ST: 15,
        EWS: 20,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 10,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 11,
        ST: 6,
        EWS: 9,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 90,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 90,
        Christian: 0,
        PwBD: 9,
        CW: 9,
        KM: 9,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 78,
        OBC_NCL: 52,
        SC: 29,
        ST: 14,
        EWS: 20,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 6,
      },
    },
    {
      name: "Motilal Nehru College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 94,
        OBC_NCL: 62,
        SC: 35,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "P.G.D.A.V. College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 15,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Rajdhani College",
      campus: "South Campus",
      seats: {
        UR: 62,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 76,
        OBC_NCL: 51,
        SC: 28,
        ST: 14,
        EWS: 19,
        Sikh: 0,
        Christian: 0,
        PwBD: 9,
        CW: 9,
        KM: 9,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 50,
        OBC_NCL: 34,
        SC: 19,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 78,
        OBC_NCL: 52,
        SC: 29,
        ST: 14,
        EWS: 20,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 0,
      },
    },
    {
      name: "Satyawati College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 63,
        OBC_NCL: 41,
        SC: 23,
        ST: 13,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Shaheed Bhagat Singh College",
      campus: "South Campus",
      seats: {
        UR: 194,
        OBC_NCL: 129,
        SC: 71,
        ST: 35,
        EWS: 51,
        Sikh: 0,
        Christian: 0,
        PwBD: 24,
        CW: 24,
        KM: 24,
      },
    },
    {
      name: "Shaheed Bhagat Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Shri Ram College of Commerce",
      campus: "North Campus",
      seats: {
        UR: 253,
        OBC_NCL: 169,
        SC: 94,
        ST: 47,
        EWS: 63,
        Sikh: 0,
        Christian: 0,
        PwBD: 31,
        CW: 31,
        KM: 31,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 62,
        SC: 35,
        ST: 17,
        EWS: 24,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "Shyam Lal College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Sri Aurobindo College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 5,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 2,
      },
    },
    {
      name: "Sri Aurobindo College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 14,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 14,
        KM: 0,
      },
    },
    {
      name: "Sri Guru Gobind Singh College of Commerce",
      campus: "South Campus",
      seats: {
        UR: 100,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 100,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 10,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 40,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 40,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 60,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 60,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 53,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 6,
        KM: 1,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 40,
        OBC_NCL: 26,
        SC: 15,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 85,
        OBC_NCL: 57,
        SC: 32,
        ST: 16,
        EWS: 21,
        Sikh: 0,
        Christian: 0,
        PwBD: 11,
        CW: 11,
        KM: 9,
      },
    },
    {
      name: "Zakir Husain Delhi College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 3,
      },
    },
  ],
  "B.Com.": [
    {
      name: "Aditi Mahavidyalaya (W)",
      campus: "South Campus",
      seats: {
        UR: 22,
        OBC_NCL: 15,
        SC: 8,
        ST: 4,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 21,
        OBC_NCL: 14,
        SC: 8,
        ST: 4,
        EWS: 5,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Atma Ram Sanatan Dharma College",
      campus: "South Campus",
      seats: {
        UR: 77,
        OBC_NCL: 52,
        SC: 29,
        ST: 14,
        EWS: 21,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 10,
      },
    },
    {
      name: "Bhagini Nivedita College (W)",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 3,
      },
    },
    {
      name: "Bharati College (W)",
      campus: "South Campus",
      seats: {
        UR: 78,
        OBC_NCL: 52,
        SC: 29,
        ST: 14,
        EWS: 19,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 10,
      },
    },
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 14,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Delhi College of Arts and Commerce",
      campus: "South Campus",
      seats: {
        UR: 69,
        OBC_NCL: 46,
        SC: 26,
        ST: 13,
        EWS: 17,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 8,
      },
    },
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 62,
        SC: 35,
        ST: 18,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "Dyal Singh College",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 62,
        SC: 36,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 11,
        KM: 12,
      },
    },
    {
      name: "Dyal Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 77,
        OBC_NCL: 52,
        SC: 29,
        ST: 15,
        EWS: 20,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 10,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 62,
        SC: 35,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 11,
        CW: 11,
        KM: 4,
      },
    },
    {
      name: "Janki Devi Memorial College (W)",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Kalindi College (W)",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 1,
      },
    },
    {
      name: "Kamala Nehru College (W)",
      campus: "South Campus",
      seats: {
        UR: 62,
        OBC_NCL: 42,
        SC: 23,
        ST: 12,
        EWS: 16,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 1,
      },
    },
    {
      name: "Kirori Mal College",
      campus: "North Campus",
      seats: {
        UR: 43,
        OBC_NCL: 29,
        SC: 16,
        ST: 8,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 94,
        OBC_NCL: 62,
        SC: 35,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "Maitreyi College (W)",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 60,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 60,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Motilal Nehru College",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 63,
        SC: 35,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 11,
        CW: 12,
        KM: 8,
      },
    },
    {
      name: "Motilal Nehru College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "P.G.D.A.V. College",
      campus: "South Campus",
      seats: {
        UR: 140,
        OBC_NCL: 94,
        SC: 52,
        ST: 26,
        EWS: 34,
        Sikh: 0,
        Christian: 0,
        PwBD: 17,
        CW: 17,
        KM: 17,
      },
    },
    {
      name: "P.G.D.A.V. College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 94,
        OBC_NCL: 62,
        SC: 35,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 11,
        CW: 11,
        KM: 11,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 39,
        OBC_NCL: 26,
        SC: 15,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 50,
        OBC_NCL: 34,
        SC: 19,
        ST: 9,
        EWS: 13,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 37,
        OBC_NCL: 25,
        SC: 14,
        ST: 7,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "Satyawati College",
      campus: "South Campus",
      seats: {
        UR: 78,
        OBC_NCL: 52,
        SC: 29,
        ST: 14,
        EWS: 20,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 0,
      },
    },
    {
      name: "Satyawati College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 96,
        OBC_NCL: 63,
        SC: 35,
        ST: 18,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Shaheed Bhagat Singh College",
      campus: "South Campus",
      seats: {
        UR: 78,
        OBC_NCL: 51,
        SC: 28,
        ST: 14,
        EWS: 21,
        Sikh: 0,
        Christian: 0,
        PwBD: 10,
        CW: 10,
        KM: 10,
      },
    },
    {
      name: "Shaheed Bhagat Singh College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 187,
        OBC_NCL: 125,
        SC: 69,
        ST: 35,
        EWS: 46,
        Sikh: 0,
        Christian: 0,
        PwBD: 23,
        CW: 23,
        KM: 23,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 12,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
    {
      name: "Shyam Lal College",
      campus: "South Campus",
      seats: {
        UR: 103,
        OBC_NCL: 68,
        SC: 38,
        ST: 19,
        EWS: 25,
        Sikh: 0,
        Christian: 0,
        PwBD: 13,
        CW: 13,
        KM: 13,
      },
    },
    {
      name: "Shyam Lal College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 94,
        OBC_NCL: 62,
        SC: 35,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 61,
        OBC_NCL: 40,
        SC: 22,
        ST: 11,
        EWS: 15,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Sri Aurobindo College",
      campus: "South Campus",
      seats: {
        UR: 140,
        OBC_NCL: 94,
        SC: 52,
        ST: 26,
        EWS: 35,
        Sikh: 0,
        Christian: 0,
        PwBD: 17,
        CW: 17,
        KM: 7,
      },
    },
    {
      name: "Sri Aurobindo College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 117,
        OBC_NCL: 78,
        SC: 43,
        ST: 22,
        EWS: 29,
        Sikh: 0,
        Christian: 0,
        PwBD: 11,
        CW: 4,
        KM: 0,
      },
    },
    {
      name: "Sri Guru Gobind Singh College of Commerce",
      campus: "South Campus",
      seats: {
        UR: 70,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 70,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 90,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 90,
        Christian: 0,
        PwBD: 9,
        CW: 9,
        KM: 9,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 30,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 30,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Sri Venkateswara College",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Swami Shardhanand College",
      campus: "South Campus",
      seats: {
        UR: 214,
        OBC_NCL: 125,
        SC: 69,
        ST: 34,
        EWS: 21,
        Sikh: 0,
        Christian: 0,
        PwBD: 18,
        CW: 23,
        KM: 5,
      },
    },
    {
      name: "Vivekananda College (W)",
      campus: "South Campus",
      seats: {
        UR: 58,
        OBC_NCL: 39,
        SC: 22,
        ST: 11,
        EWS: 14,
        Sikh: 0,
        Christian: 0,
        PwBD: 7,
        CW: 7,
        KM: 7,
      },
    },
    {
      name: "Zakir Husain Delhi College",
      campus: "South Campus",
      seats: {
        UR: 47,
        OBC_NCL: 31,
        SC: 17,
        ST: 9,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 5,
      },
    },
    {
      name: "Zakir Husain Delhi College (Evening)",
      campus: "South Campus",
      seats: {
        UR: 62,
        OBC_NCL: 41,
        SC: 23,
        ST: 11,
        EWS: 16,
        Sikh: 0,
        Christian: 0,
        PwBD: 8,
        CW: 8,
        KM: 7,
      },
    },
  ],
  "Bachelor of Business Administration (Financial Investment Analysis)": [
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Shaheed Sukhdev College Business Studies",
      campus: "South Campus",
      seats: {
        UR: 46,
        OBC_NCL: 31,
        SC: 17,
        ST: 8,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
  ],
  "B.A. (Hons.) Business Economics": [
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 42,
        OBC_NCL: 28,
        SC: 16,
        ST: 8,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Dr. Bhim Rao Ambedkar College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 11,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 0,
        KM: 1,
      },
    },
    {
      name: "Lakshmibai College (W)",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 10,
        SC: 6,
        ST: 3,
        EWS: 4,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Maharaja Agrasen College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shivaji College",
      campus: "South Campus",
      seats: {
        UR: 31,
        OBC_NCL: 21,
        SC: 12,
        ST: 6,
        EWS: 8,
        Sikh: 0,
        Christian: 0,
        PwBD: 4,
        CW: 4,
        KM: 4,
      },
    },
    {
      name: "Sri Guru Gobind Singh College of Commerce",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Nanak Dev Khalsa College",
      campus: "South Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
    {
      name: "Sri Guru Tegh Bahadur Khalsa College",
      campus: "North Campus",
      seats: {
        UR: 20,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 20,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "Bachelor of Management Studies": [
    {
      name: "Aryabhatta College",
      campus: "South Campus",
      seats: {
        UR: 42,
        OBC_NCL: 28,
        SC: 16,
        ST: 8,
        EWS: 10,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Deen Dayal Upadhyaya College",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Keshav Mahavidyalaya",
      campus: "South Campus",
      seats: {
        UR: 24,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Ram Lal Anand College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 2,
        KM: 3,
      },
    },
    {
      name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 16,
        SC: 9,
        ST: 4,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
    {
      name: "Shaheed Sukhdev College Business Studies",
      campus: "South Campus",
      seats: {
        UR: 93,
        OBC_NCL: 63,
        SC: 35,
        ST: 17,
        EWS: 23,
        Sikh: 0,
        Christian: 0,
        PwBD: 12,
        CW: 12,
        KM: 12,
      },
    },
    {
      name: "Sri Guru Gobind Singh College of Commerce",
      campus: "South Campus",
      seats: {
        UR: 23,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 23,
        Christian: 0,
        PwBD: 2,
        CW: 2,
        KM: 2,
      },
    },
  ],
  "B.Voc. Banking Operations": [
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.Voc. Health Care Management": [
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
  ],
  "B.Voc. Retail Management and IT": [
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 2,
      },
    },
  ],
  "B.Voc. Software Development": [
    {
      name: "Ramanujan College",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.A. (Vocational Studies) Human Resource Management": [
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 51,
        OBC_NCL: 34,
        SC: 19,
        ST: 9,
        EWS: 13,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
  ],
  "B.A. (Vocational Studies) Management and Marketing of Insurance": [
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.A. (Vocational Studies) Marketing Management and Retail Business": [
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 51,
        OBC_NCL: 34,
        SC: 19,
        ST: 9,
        EWS: 13,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
  ],
  "B.A. (Vocational Studies) Material Management": [
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.A. (Vocational Studies) Office Management and Secretarial Practice": [
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 45,
        OBC_NCL: 30,
        SC: 17,
        ST: 8,
        EWS: 11,
        Sikh: 0,
        Christian: 0,
        PwBD: 5,
        CW: 5,
        KM: 5,
      },
    },
  ],
  "B.A. (Vocational Studies) Small and Medium Enterprises": [
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
  "B.A. (Vocational Studies) Tourism Management": [
    {
      name: "College of Vocational Studies",
      campus: "South Campus",
      seats: {
        UR: 51,
        OBC_NCL: 34,
        SC: 19,
        ST: 9,
        EWS: 13,
        Sikh: 0,
        Christian: 0,
        PwBD: 6,
        CW: 6,
        KM: 6,
      },
    },
  ],
  "B.A. (Hons.) Hindustani Music: Vocal/Instrumental": [
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 8,
        OBC_NCL: 5,
        SC: 3,
        ST: 1,
        EWS: 2,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 5,
        OBC_NCL: 3,
        SC: 2,
        ST: 0,
        EWS: 1,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 15,
        OBC_NCL: 8,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 2,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 5,
        OBC_NCL: 3,
        SC: 2,
        ST: 0,
        EWS: 1,
        Sikh: 0,
        Christian: 0,
        PwBD: 1,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 10,
        OBC_NCL: 6,
        SC: 4,
        ST: 2,
        EWS: 3,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
  ],
  "B.A. (Hons.) Hindustani Music: Percussion": [
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 2,
        OBC_NCL: 2,
        SC: 1,
        ST: 1,
        EWS: 1,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 2,
        OBC_NCL: 1,
        SC: 1,
        ST: 0,
        EWS: 1,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 2,
        OBC_NCL: 3,
        SC: 2,
        ST: 1,
        EWS: 1,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 2,
        OBC_NCL: 1,
        SC: 1,
        ST: 0,
        EWS: 1,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 4,
        OBC_NCL: 3,
        SC: 1,
        ST: 1,
        EWS: 1,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
  ],
  "B.A. (Hons.) Karnataka Music: Vocal/Instrumental": [
    {
      name: "Daulat Ram College (W)",
      campus: "North Campus",
      seats: {
        UR: 2,
        OBC_NCL: 1,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Hindu College",
      campus: "North Campus",
      seats: {
        UR: 1,
        OBC_NCL: 1,
        SC: 0,
        ST: 1,
        EWS: 0,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Indraprastha College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 2,
        OBC_NCL: 2,
        SC: 1,
        ST: 0,
        EWS: 1,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 1,
        OBC_NCL: 1,
        SC: 0,
        ST: 1,
        EWS: 0,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
    {
      name: "Ramjas College",
      campus: "North Campus",
      seats: {
        UR: 2,
        OBC_NCL: 1,
        SC: 1,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
  ],
  "Bachelor of Fine Arts": [
    {
      name: "College of Art",
      campus: "South Campus",
      seats: {
        UR: 83,
        OBC_NCL: 56,
        SC: 31,
        ST: 15,
        EWS: 21,
        Sikh: 0,
        Christian: 0,
        PwBD: 0,
        CW: 0,
        KM: 0,
      },
    },
  ],
  "Bachelor of Elementary Education": [
    {
      name: "Aditi Mahavidyalaya (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Gargi College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 1,
        KM: 1,
      },
    },
    {
      name: "Institute of Home Economics (W)",
      campus: "South Campus",
      seats: {
        UR: 26,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 6,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Jesus & Mary College (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 0,
        Christian: 25,
        PwBD: 3,
        CW: 3,
        KM: 0,
      },
    },
    {
      name: "Lady Shri Ram College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Mata Sundri College for Women (W)",
      campus: "South Campus",
      seats: {
        UR: 27,
        OBC_NCL: 0,
        SC: 0,
        ST: 0,
        EWS: 0,
        Sikh: 27,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Miranda House (W)",
      campus: "North Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
    {
      name: "Shyama Prasad Mukherji College For Women (W)",
      campus: "South Campus",
      seats: {
        UR: 25,
        OBC_NCL: 17,
        SC: 9,
        ST: 5,
        EWS: 7,
        Sikh: 0,
        Christian: 0,
        PwBD: 3,
        CW: 3,
        KM: 3,
      },
    },
  ],
};

export const cutoffData = [
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 741.7355297,
      OBC: 591.5148212,
      SC: 509.738252,
      ST: 269.3621434,
      EWS: 629.8035234,
      PwBD: 364.8609327,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc. (Hons.) Biomedical Science",
    cutoffs: {
      UR: 591.1422895,
      OBC: 512.3533607,
      SC: 438.5571106,
      ST: 369.6123935,
      EWS: 493.3660477,
      PwBD: 112.407306,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 501.6979696,
      OBC: 431.6434362,
      SC: 356.8961674,
      ST: 322.4662411,
      EWS: 403.6422262,
      PwBD: 278.561065,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 349.4427252,
      OBC: 292.6822182,
      SC: 155.4991055,
      ST: 56.1108895,
      EWS: 257.4853388,
      PwBD: null,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 631.5657585,
      OBC: 533.1901404,
      SC: 454.720755,
      ST: 331.1577395,
      EWS: 548.8684346,
      PwBD: 172.6171434,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 332.8557566,
      OBC: 256.6817726,
      SC: 134.4522192,
      ST: 45.6737544,
      EWS: 266.8689102,
      PwBD: null,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 352.4922942,
      OBC: 291.1084245,
      SC: 191.6542578,
      ST: 120.8794726,
      EWS: 285.8641285,
      PwBD: null,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 523.6516554,
      OBC: 446.4990562,
      SC: 394.4412948,
      ST: 340.2113417,
      EWS: 443.5846988,
      PwBD: 139.8129263,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 499.2162732,
      OBC: 434.6788915,
      SC: 352.6017453,
      ST: 227.6565309,
      EWS: 418.0775336,
      PwBD: null,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 561.69673,
      OBC: 452.3274302,
      SC: 361.0569172,
      ST: 138.259921,
      EWS: 471.8297179,
      PwBD: null,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 267.0248347,
      OBC: 206.6802882,
      SC: 93.5028788,
      ST: 88.2529836,
      EWS: 93.5199893,
      PwBD: null,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 315.0105612,
      OBC: 243.9169762,
      SC: 182.2831052,
      ST: 83.0490943,
      EWS: 236.7085807,
      PwBD: null,
    },
  },
  {
    collegeName: "Acharya Narendra Dev College",
    programName: "B.Sc (Prog.) Physical Science with Electronics",
    cutoffs: {
      UR: 238.2216038,
      OBC: 188.8439807,
      SC: 3.4992002,
      ST: 75.630203,
      EWS: 92.2853981,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 606.5481067,
      OBC: 497.3980943,
      SC: 440.0809732,
      ST: 291.5913707,
      EWS: 384.6108605,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A. (Hons.) Hindi Patrakarita",
    cutoffs: {
      UR: 290.2998016,
      OBC: 145.0906576,
      SC: 177.4488718,
      ST: 343.8518048,
      EWS: 262.1529676,
      PwBD: 186.312188,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A. (Hons.) Social Work",
    cutoffs: {
      UR: 528.4188715,
      OBC: 342.7302672,
      SC: 211.5752184,
      ST: 172.9752028,
      EWS: 226.8693359,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 692.9472833,
      OBC: 521.3742681,
      SC: 442.9726416,
      ST: 115.5306851,
      EWS: 518.1780844,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 661.5646331,
      OBC: 495.7887506,
      SC: 401.5991705,
      ST: 367.6105384,
      EWS: 493.3593493,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "Bachelor of Elementary Education",
    cutoffs: {
      UR: 581.8751708,
      OBC: 464.0997331,
      SC: 466.2025219,
      ST: 292.6660698,
      EWS: 425.4226655,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Hindi + NHE)",
    cutoffs: {
      UR: 453.8150953,
      OBC: 260.2085735,
      SC: 185.6082121,
      ST: 171.344125,
      EWS: 266.7337351,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Hindi + OMSP)",
    cutoffs: {
      UR: 440.8493657,
      OBC: 264.9569579,
      SC: 153.0161608,
      ST: null,
      EWS: 254.3564053,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 503.8999208,
      OBC: 354.7585943,
      SC: 361.9685056,
      ST: null,
      EWS: 260.6587839,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 140.4306566,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Sanskrit + Music)",
    cutoffs: {
      UR: 278.6261288,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 162.9035247,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName:
      "B.A Program (Advertising, Sales Promotion and Sales Management (ASPSM) + Economics)",
    cutoffs: {
      UR: 629.3511503,
      OBC: 461.4640249,
      SC: 365.1941231,
      ST: 243.7924321,
      EWS: 421.2619529,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName:
      "B.A Program (Advertising, Sales Promotion and Sales Management (ASPSM) + Mathematics)",
    cutoffs: {
      UR: 537.6780967,
      OBC: 233.177669,
      SC: 153.0662875,
      ST: null,
      EWS: 185.8066,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 621.3893874,
      OBC: 372.9395995,
      SC: 140.7013364,
      ST: null,
      EWS: 279.7130723,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Economics + Psychology)",
    cutoffs: {
      UR: 681.1083012,
      OBC: 510.0905329,
      SC: 491.9167063,
      ST: 323.9372681,
      EWS: 421.6100116,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Food Technology (FT) + Geography)",
    cutoffs: {
      UR: 547.0675796,
      OBC: 364.0509757,
      SC: 318.5872523,
      ST: 230.4380239,
      EWS: 319.6188063,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Geography + History)",
    cutoffs: {
      UR: 568.0282126,
      OBC: 411.9570184,
      SC: 390.6810206,
      ST: 460.645658,
      EWS: 403.4859095,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Political Science)",
    cutoffs: {
      UR: 495.5766573,
      OBC: 182.1736441,
      SC: 173.6312556,
      ST: 264.2982915,
      EWS: 152.0848096,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Mathematics + Psychology)",
    cutoffs: {
      UR: 528.7661713,
      OBC: 270.1865641,
      SC: 186.8923947,
      ST: 326.2172463,
      EWS: 261.4845751,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Music + Sociology)",
    cutoffs: {
      UR: 445.9442697,
      OBC: 132.5369588,
      SC: 188.3740391,
      ST: 430.0387587,
      EWS: 338.0067004,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (NHE + Sociology)",
    cutoffs: {
      UR: 489.9040944,
      OBC: 186.1000508,
      SC: 181.1835524,
      ST: 101.44522,
      EWS: 267.9676119,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName:
      "B.A Program (Office Management & Secretarial Practice (OMSP) + Sociology)",
    cutoffs: {
      UR: 521.7835941,
      OBC: 227.9255013,
      SC: 191.9621593,
      ST: null,
      EWS: 362.2970285,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Political Science + Sociology)",
    cutoffs: {
      UR: 578.6224785,
      OBC: 392.0896088,
      SC: 356.7356331,
      ST: 343.1914463,
      EWS: 277.1507885,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Economics + Food Technology)",
    cutoffs: {
      UR: 566.4791447,
      OBC: 416.411098,
      SC: 325.7878504,
      ST: 321.6555445,
      EWS: 374.9495692,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Education + Political Science)",
    cutoffs: {
      UR: 507.8075237,
      OBC: 286.5661765,
      SC: 293.5136828,
      ST: 99.8379655,
      EWS: 193.3465742,
      PwBD: null,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName:
      "B.A Program (Education + Human Development and Family Empowerment (HDFE))",
    cutoffs: {
      UR: 529.6278565,
      OBC: 366.6999306,
      SC: 235.5311644,
      ST: 181.1264663,
      EWS: 211.1700127,
      PwBD: 304.9637464,
    },
  },
  {
    collegeName: "Aditi Mahavidyalaya (W)",
    programName: "B.A Program (Education + Geography)",
    cutoffs: {
      UR: 529.7885764,
      OBC: 333.5963558,
      SC: 263.0219058,
      ST: 215.8012796,
      EWS: 165.8893627,
      PwBD: null,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 729.4580212,
      OBC: 524.1016624,
      SC: 429.5124663,
      ST: 158.5561849,
      EWS: 548.3391355,
      PwBD: null,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 696.0251072,
      OBC: 557.1106869,
      SC: 501.5460235,
      ST: 495.8567054,
      EWS: 547.6397831,
      PwBD: 253.3399333,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 439.6417952,
      OBC: 288.8141115,
      SC: 312.9011132,
      ST: null,
      EWS: 166.393981,
      PwBD: null,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 707.3178897,
      OBC: 582.6234141,
      SC: 515.1187791,
      ST: 498.492209,
      EWS: 571.1924308,
      PwBD: 334.2990854,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 741.6835005,
      OBC: 668.5927556,
      SC: 585.4438979,
      ST: 554.6465181,
      EWS: 656.492797,
      PwBD: 36.8324183,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 613.0972368,
      OBC: 540.2728371,
      SC: 439.089366,
      ST: 354.8924749,
      EWS: 552.0544452,
      PwBD: 270.6149229,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 601.5368209,
      OBC: 471.3909592,
      SC: 355.7121152,
      ST: 237.1602412,
      EWS: 469.7180471,
      PwBD: null,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 837.8774286,
      OBC: 671.5607672,
      SC: 662.9209463,
      ST: 618.3476057,
      EWS: 656.4160407,
      PwBD: 558.5698966,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.Com.",
    cutoffs: {
      UR: 780.3800532,
      OBC: 659.9296459,
      SC: 564.8122788,
      ST: 468.1014363,
      EWS: 706.4496812,
      PwBD: 188.2857616,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 808.2489095,
      OBC: 702.1935647,
      SC: 614.6217594,
      ST: 570.8070108,
      EWS: 753.8134026,
      PwBD: null,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "Bachelor of Management Studies",
    cutoffs: {
      UR: 458.910568,
      OBC: 355.3127795,
      SC: 299.5415075,
      ST: 118.2239469,
      EWS: 383.8039074,
      PwBD: 193.5323387,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.A. (Hons.) Business Economics",
    cutoffs: {
      UR: 445.5407278,
      OBC: 300.2689167,
      SC: 229.1248952,
      ST: 270.3784384,
      EWS: 323.7993497,
      PwBD: 403.05766,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 676.9578034,
      OBC: 574.186892,
      SC: 527.3622517,
      ST: 506.2263395,
      EWS: null,
      PwBD: 432.227006,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 692.2267136,
      OBC: 460.290958,
      SC: 343.1998991,
      ST: 267.6328623,
      EWS: 456.9138483,
      PwBD: null,
    },
  },
  {
    collegeName: "Aryabhatta College",
    programName: "B.A Program (English + Psychology)",
    cutoffs: {
      UR: 748.4387162,
      OBC: 586.6683431,
      SC: 566.9524895,
      ST: 560.1635145,
      EWS: 594.8287052,
      PwBD: 275.3427751,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.Com.",
    cutoffs: {
      UR: 821.0671847,
      OBC: 726.0004349,
      SC: 654.6489055,
      ST: 529.2424344,
      EWS: 771.4477784,
      PwBD: 189.0046528,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 846.3707484,
      OBC: 768.1747922,
      SC: 697.7635776,
      ST: 600.64235,
      EWS: 814.205762,
      PwBD: 195.8144642,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 776.7158472,
      OBC: 675.4473671,
      SC: 614.2814611,
      ST: 598.3820301,
      EWS: 700.9623772,
      PwBD: 364.7852448,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 444.0941563,
      OBC: 356.4833355,
      SC: 364.7483807,
      ST: 181.3078124,
      EWS: 173.9801669,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 798.0344317,
      OBC: 747.0459261,
      SC: 677.2841909,
      ST: 630.6087726,
      EWS: 737.9460058,
      PwBD: 426.9062768,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 823.8564962,
      OBC: 770.8587347,
      SC: 705.7440615,
      ST: 685.6727177,
      EWS: 781.8972586,
      PwBD: 533.4405498,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 793.9463506,
      OBC: 604.9181377,
      SC: 510.2503534,
      ST: 315.8721212,
      EWS: 650.3229808,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 415.1010037,
      OBC: 360.0316339,
      SC: 235.1812512,
      ST: 113.5638407,
      EWS: 359.040128,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 398.6968947,
      OBC: 342.6086872,
      SC: 245.7075247,
      ST: 92.6779885,
      EWS: 337.3626217,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 666.1571336,
      OBC: 532.0654905,
      SC: 432.3089341,
      ST: 288.0497328,
      EWS: 524.7027492,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 405.7542638,
      OBC: 338.0456716,
      SC: 253.1077996,
      ST: 124.1071455,
      EWS: 329.8072338,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 647.6940628,
      OBC: 627.4229857,
      SC: 513.7045049,
      ST: 395.0361093,
      EWS: 629.2231452,
      PwBD: 241.2398306,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 306.9273601,
      OBC: 264.221276,
      SC: 161.1216429,
      ST: 179.4602764,
      EWS: 272.250127,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName: "B.Sc (Prog.) Physical Science with Electronics",
    cutoffs: {
      UR: 305.4049112,
      OBC: 253.6317492,
      SC: 68.8090192,
      ST: 29.2130746,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 383.4174827,
      OBC: 315.8036518,
      SC: 225.7395241,
      ST: 118.3325721,
      EWS: 328.9092701,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName:
      "B.Sc (Prog.) Applied Physical Sciences with Industrial Chemistry",
    cutoffs: {
      UR: 289.0193778,
      OBC: 232.0630119,
      SC: 133.3786005,
      ST: 90.7791446,
      EWS: 233.2820523,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName:
      "B.A Program (Sanskrit + Any other discipline subject from (English/Hindi/Sanskrit/Political Sc./Economics/Mathematics/Comp. App./History))",
    cutoffs: {
      UR: 634.7489449,
      OBC: 475.0541409,
      SC: 378.2988192,
      ST: null,
      EWS: 372.0923372,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName:
      "B.A Program (Computer Applications + Any other discipline subject from (English/Hindi/Sanskrit/Political Sc./Economics/Mathematics/Comp. App./History))",
    cutoffs: {
      UR: 778.5067124,
      OBC: 635.7669253,
      SC: 571.8644257,
      ST: 552.67611,
      EWS: 670.2151748,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName:
      "B.A Program (Mathematics + Any other discipline subject from (English/Hindi/Sanskrit/Political Sc./Economics/Mathematics/Comp. App./History))",
    cutoffs: {
      UR: 780.8334175,
      OBC: 619.4206327,
      SC: 470.030623,
      ST: 483.3076409,
      EWS: 535.5466167,
      PwBD: null,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName:
      "B.A Program (English + Any other discipline subject from (English/Hindi/Sanskrit/Political Sc./Economics/Mathematics/Comp. App./History))",
    cutoffs: {
      UR: 799.3849957,
      OBC: 729.3297133,
      SC: 629.6454396,
      ST: 594.0699013,
      EWS: 710.3340105,
      PwBD: 644.4162905,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName:
      "B.A Program (Hindi + Any other discipline subject from (English/Hindi/Sanskrit/Political Sc./Economics/Mathematics/Comp. App./History))",
    cutoffs: {
      UR: 737.5001061,
      OBC: 663.6525568,
      SC: 610.3694999,
      ST: 478.2934297,
      EWS: 653.9538636,
      PwBD: 315.0527648,
    },
  },
  {
    collegeName: "Atma Ram Sanatan Dharma College",
    programName:
      "B.A Program (Any two disciplines from (History/Political Sc./Economics))",
    cutoffs: {
      UR: 780.334444,
      OBC: 699.8010356,
      SC: 632.7641301,
      ST: 605.5198901,
      EWS: 743.1396511,
      PwBD: 448.2468871,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 648.4989875,
      OBC: 470.1390736,
      SC: 366.6926772,
      ST: null,
      EWS: 482.6961717,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 307.459805,
      OBC: 156.9014316,
      SC: 111.7276374,
      ST: null,
      EWS: 214.6820708,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 572.9085827,
      OBC: 413.1377505,
      SC: 383.3064578,
      ST: 286.8506379,
      EWS: 288.7511205,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 234.4721267,
      OBC: 130.848009,
      SC: 105.5239147,
      ST: null,
      EWS: 119.3254403,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.Sc. (Hons.) Home Science",
    cutoffs: {
      UR: 385.0705235,
      OBC: 313.4952955,
      SC: 247.7059579,
      ST: 161.4483668,
      EWS: 261.9090081,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 237.1267272,
      OBC: 128.7068473,
      SC: 93.1823851,
      ST: null,
      EWS: 123.7130206,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 182.3251374,
      OBC: 52.4028768,
      SC: 10.629529,
      ST: null,
      EWS: 157.1003532,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 612.3817449,
      OBC: 468.7493354,
      SC: 426.125082,
      ST: 361.7991556,
      EWS: 95.4834778,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 557.057032,
      OBC: 406.6846454,
      SC: 375.0056786,
      ST: 316.8080364,
      EWS: 340.4960665,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 554.1294193,
      OBC: 373.8093612,
      SC: 327.0900044,
      ST: 169.9745348,
      EWS: 249.6915564,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 252.6996244,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (Food Technology (FT) + Political Science)",
    cutoffs: {
      UR: 500.6668141,
      OBC: 329.5460425,
      SC: 258.062421,
      ST: null,
      EWS: 241.2326372,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Political Science)",
    cutoffs: {
      UR: 489.1181822,
      OBC: 167.5428491,
      SC: 146.4760764,
      ST: null,
      EWS: 294.9956915,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (Computer Applications + Political Science)",
    cutoffs: {
      UR: 508.4141196,
      OBC: 278.9817592,
      SC: 194.0552072,
      ST: 272.3064345,
      EWS: 241.0653907,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName:
      "B.A Program (Office Management & Secretarial Practice (OMSP) + Political Science)",
    cutoffs: {
      UR: 532.022708,
      OBC: 377.0901793,
      SC: 391.6993677,
      ST: null,
      EWS: 213.8083144,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (Music + Political Science)",
    cutoffs: {
      UR: 469.2304931,
      OBC: 263.1588365,
      SC: 107.5778439,
      ST: null,
      EWS: 230.0367067,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 548.9202805,
      OBC: 344.7125545,
      SC: 302.7940225,
      ST: 357.7718707,
      EWS: 261.0953601,
      PwBD: 370.96325,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 187.2739479,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (Food Technology (FT) + History)",
    cutoffs: {
      UR: 502.9799455,
      OBC: 333.0501488,
      SC: 264.5928828,
      ST: null,
      EWS: 203.8211875,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (History + Music)",
    cutoffs: {
      UR: 450.6304225,
      OBC: 190.2989824,
      SC: 160.0035919,
      ST: 344.0575511,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 565.2040906,
      OBC: 298.6205746,
      SC: 163.6564939,
      ST: null,
      EWS: 212.9648896,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (Economics + OMSP)",
    cutoffs: {
      UR: 584.107558,
      OBC: 361.0858803,
      SC: 315.7222553,
      ST: null,
      EWS: 247.6861062,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName:
      "B.A Program (Political Science + Nutrition and Health Education (NHE))",
    cutoffs: {
      UR: 505.2636691,
      OBC: 265.5665559,
      SC: 178.030832,
      ST: 331.6320297,
      EWS: 188.7399588,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName:
      "B.A Program (Political Science + Apparel Design & Construction (ADC))",
    cutoffs: {
      UR: 503.8780953,
      OBC: 166.0409236,
      SC: 104.4963383,
      ST: 330.9392248,
      EWS: 288.4059964,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (History + Nutrition and Health Education (NHE))",
    cutoffs: {
      UR: 485.1405092,
      OBC: 286.5661765,
      SC: 256.3271939,
      ST: 224.2578747,
      EWS: 322.5023955,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName: "B.A Program (History + Apparel Design & Construction (ADC))",
    cutoffs: {
      UR: 489.0725557,
      OBC: 300.1834326,
      SC: 271.9085343,
      ST: 273.9352306,
      EWS: 129.7756681,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhagini Nivedita College (W)",
    programName:
      "B.A Program (History + Human Development and Family Empowerment (HDFE))",
    cutoffs: {
      UR: 482.0110113,
      OBC: 175.7751925,
      SC: 270.6049384,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 643.3123202,
      OBC: 473.0246407,
      SC: 445.3555589,
      ST: 365.2424247,
      EWS: 454.3193044,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 270.7533247,
      OBC: 237.6849941,
      SC: 173.003956,
      ST: null,
      EWS: 149.6599527,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 228.6977706,
      OBC: 126.5792975,
      SC: 128.2389557,
      ST: null,
      EWS: 142.2349561,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 606.5178088,
      OBC: 439.3183221,
      SC: 411.1905636,
      ST: 366.3488189,
      EWS: 312.4827684,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 643.6512482,
      OBC: 531.1528419,
      SC: 451.5680195,
      ST: 405.0129101,
      EWS: 351.2957496,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 707.3784743,
      OBC: 541.6653207,
      SC: 448.6542885,
      ST: 269.001399,
      EWS: 565.169264,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 665.90146,
      OBC: 482.3355375,
      SC: 384.9207245,
      ST: 241.6906651,
      EWS: 506.141267,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A. (Hons.) Journalism",
    cutoffs: {
      UR: 663.4266007,
      OBC: 509.5434735,
      SC: 458.5963828,
      ST: 181.6483818,
      EWS: 510.0607187,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 496.1511788,
      OBC: 318.9170466,
      SC: 144.0373143,
      ST: 216.1741252,
      EWS: 225.7428844,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 767.0108611,
      OBC: 606.7572452,
      SC: 576.1686913,
      ST: 407.7083123,
      EWS: 558.7213535,
      PwBD: 318.0783381,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 633.4311587,
      OBC: 472.2950323,
      SC: 345.7858908,
      ST: 209.8089726,
      EWS: 252.0250839,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 591.8498313,
      OBC: 501.8967616,
      SC: 419.8883282,
      ST: 380.9473458,
      EWS: 369.9059238,
      PwBD: 408.6283228,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 138.8612587,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (Music + Political Science)",
    cutoffs: {
      UR: 472.4021542,
      OBC: 267.64696,
      SC: 257.9294176,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (History + Music)",
    cutoffs: {
      UR: 480.7102475,
      OBC: 247.6534684,
      SC: 201.8704743,
      ST: null,
      EWS: 311.7989384,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Political Science)",
    cutoffs: {
      UR: 528.5065928,
      OBC: 346.3435235,
      SC: 263.1732773,
      ST: 243.3192044,
      EWS: 230.3744284,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 612.9041474,
      OBC: 434.0819556,
      SC: 384.5335661,
      ST: 218.5530435,
      EWS: 262.5489817,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (Punjabi + History)",
    cutoffs: {
      UR: 340.6030089,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (Economics + OMSP)",
    cutoffs: {
      UR: 611.0708158,
      OBC: 402.3716038,
      SC: 369.8146264,
      ST: 418.2502552,
      EWS: 430.572017,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (History + OMSP)",
    cutoffs: {
      UR: 529.0804918,
      OBC: 366.9990602,
      SC: 282.9979664,
      ST: null,
      EWS: 255.0560787,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 609.2564245,
      OBC: 409.3489247,
      SC: 285.5895215,
      ST: 158.9500431,
      EWS: 381.2891729,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (Computer Applications + Political Science)",
    cutoffs: {
      UR: 515.7636631,
      OBC: 309.9734329,
      SC: 130.4733619,
      ST: null,
      EWS: 286.1656495,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (Sanskrit + Economics)",
    cutoffs: {
      UR: 370.3542515,
      OBC: 294.0784239,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Bharati College (W)",
    programName: "B.A Program (Punjabi + Economics)",
    cutoffs: {
      UR: 393.0843728,
      OBC: null,
      SC: 261.6754377,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Biomedical Science",
    cutoffs: {
      UR: 575.933873,
      OBC: 492.4744882,
      SC: 418.3449499,
      ST: 353.49252,
      EWS: 473.5427523,
      PwBD: 200.470029,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 496.6327984,
      OBC: 426.6857331,
      SC: 355.3356902,
      ST: 317.5652752,
      EWS: 422.098042,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 313.8402531,
      OBC: 258.2982276,
      SC: 182.0555432,
      ST: 38.9022507,
      EWS: 268.2577514,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 609.6479867,
      OBC: 508.9437069,
      SC: 426.7668139,
      ST: 303.4543314,
      EWS: 523.6710862,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 313.2955878,
      OBC: 234.1419913,
      SC: 110.5386229,
      ST: 87.1155878,
      EWS: 236.2746429,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Food Technology",
    cutoffs: {
      UR: 521.8945393,
      OBC: 459.6862014,
      SC: 366.0827864,
      ST: 324.8157901,
      EWS: 451.4536402,
      PwBD: 210.5085073,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Instrumentation",
    cutoffs: {
      UR: 214.5000959,
      OBC: 124.7506776,
      SC: 107.8779156,
      ST: null,
      EWS: 179.8763233,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Microbiology",
    cutoffs: {
      UR: 571.614138,
      OBC: 495.0085262,
      SC: 438.2788986,
      ST: 390.8212189,
      EWS: 500.2612217,
      PwBD: 213.4982787,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 348.9675989,
      OBC: 237.34552,
      SC: 177.067044,
      ST: 98.3612849,
      EWS: 279.4043058,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Polymer Science",
    cutoffs: {
      UR: 216.8176753,
      OBC: 121.7813512,
      SC: 99.6232156,
      ST: 50.9090163,
      EWS: 181.2086703,
      PwBD: null,
    },
  },
  {
    collegeName: "Bhaskaracharya College of Applied Sciences",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 493.8457385,
      OBC: 455.5069769,
      SC: 316.4948989,
      ST: 337.0189605,
      EWS: 442.2563867,
      PwBD: null,
    },
  },
  {
    collegeName: "Cluster Innovation Centre",
    programName: "B.A. (Hons.) Humanities and Social Sciences",
    cutoffs: {
      UR: 710.5082193,
      OBC: 551.431721,
      SC: 439.0136349,
      ST: 446.363014,
      EWS: 548.922286,
      PwBD: 149.7438865,
    },
  },
  {
    collegeName: "Cluster Innovation Centre",
    programName: "B.Tech. Information Technology and Mathematical Innovation",
    cutoffs: {
      UR: 535.5371716,
      OBC: 497.0068459,
      SC: 432.238587,
      ST: 356.6994119,
      EWS: 514.7736092,
      PwBD: 374.0410653,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 816.6193179,
      OBC: 717.3504481,
      SC: 637.2622881,
      ST: 508.1220244,
      EWS: 760.8443443,
      PwBD: null,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 762.8670282,
      OBC: 533.7419512,
      SC: 417.4273284,
      ST: null,
      EWS: 593.622933,
      PwBD: null,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 693.976604,
      OBC: 578.7036183,
      SC: 485.023875,
      ST: 476.6759288,
      EWS: 547.0563816,
      PwBD: null,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 632.4802557,
      OBC: 539.773313,
      SC: 427.2599924,
      ST: 242.623596,
      EWS: 516.517611,
      PwBD: null,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 345.1193919,
      OBC: 216.619283,
      SC: 184.573362,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 708.6783009,
      OBC: 584.2899782,
      SC: 506.8410759,
      ST: 472.5196677,
      EWS: 553.5283706,
      PwBD: null,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.A. (Hons.) Business Economics",
    cutoffs: {
      UR: 464.6983255,
      OBC: 321.1296672,
      SC: 254.5443306,
      ST: 233.3381972,
      EWS: 342.7248688,
      PwBD: null,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "Bachelor of Management Studies",
    cutoffs: {
      UR: 498.1127243,
      OBC: 373.5685478,
      SC: 322.6201304,
      ST: 133.1534823,
      EWS: 404.0719802,
      PwBD: 217.507727,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName:
      "B.A. (Vocational Studies) Office Management and Secretarial Practice",
    cutoffs: {
      UR: 631.2592943,
      OBC: 458.1292157,
      SC: 401.1792935,
      ST: 173.8168544,
      EWS: 470.4157846,
      PwBD: 120.0210409,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName:
      "B.A. (Vocational Studies) Marketing Management and Retail Business",
    cutoffs: {
      UR: 666.0279689,
      OBC: 499.4213114,
      SC: 433.0116716,
      ST: 222.7675197,
      EWS: 521.7473533,
      PwBD: 365.5181276,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.A. (Vocational Studies) Human Resource Management",
    cutoffs: {
      UR: 681.00051,
      OBC: 532.7120879,
      SC: 460.7974627,
      ST: 262.0688628,
      EWS: 552.2524048,
      PwBD: 99.5552972,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.A. (Vocational Studies) Small and Medium Enterprises",
    cutoffs: {
      UR: 642.0833429,
      OBC: 481.5593694,
      SC: 402.0492155,
      ST: 147.1875379,
      EWS: 489.2412184,
      PwBD: 374.4564655,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName:
      "B.A. (Vocational Studies) Management and Marketing of Insurance",
    cutoffs: {
      UR: 662.9975771,
      OBC: 493.2615596,
      SC: 438.1278236,
      ST: 214.2213852,
      EWS: 545.5865535,
      PwBD: null,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.A. (Vocational Studies) Material Management",
    cutoffs: {
      UR: 630.3143432,
      OBC: 457.5900425,
      SC: 392.5717936,
      ST: 113.2419383,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "College of Vocational Studies",
    programName: "B.A. (Vocational Studies) Tourism Management",
    cutoffs: {
      UR: 631.3677422,
      OBC: 482.3292456,
      SC: 418.4494009,
      ST: 373.5485168,
      EWS: 472.2178264,
      PwBD: 302.6579781,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 794.6840099,
      OBC: 613.9440623,
      SC: 525.2076315,
      ST: 283.394345,
      EWS: 656.7136223,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 782.1261215,
      OBC: 681.4810257,
      SC: 635.8860446,
      ST: 612.8133333,
      EWS: 708.5246279,
      PwBD: 201.0176554,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 412.1559888,
      OBC: 242.2929601,
      SC: 277.6979631,
      ST: 259.9144407,
      EWS: 251.0735999,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 818.1843702,
      OBC: 755.5463143,
      SC: 662.7580748,
      ST: 685.9184183,
      EWS: 736.4940182,
      PwBD: 171.8740889,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 748.5192699,
      OBC: 630.77661,
      SC: 571.4050625,
      ST: 463.4998047,
      EWS: 644.6265499,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 843.3316209,
      OBC: 800.6360433,
      SC: 710.0639993,
      ST: 723.7726397,
      EWS: 804.3252767,
      PwBD: 522.6868064,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 874.15898,
      OBC: 767.7367439,
      SC: 744.5551208,
      ST: 750.6911295,
      EWS: 776.1895866,
      PwBD: 595.098143,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 146.0145037,
      OBC: 138.6837249,
      SC: 222.5951083,
      ST: null,
      EWS: 164.1595371,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.Sc. (Hons.) Biochemistry",
    cutoffs: {
      UR: 607.8157061,
      OBC: 544.4898695,
      SC: 484.4300039,
      ST: 430.3048239,
      EWS: 555.8578986,
      PwBD: 392.4598503,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 510.5685588,
      OBC: 503.9957416,
      SC: 422.9945461,
      ST: 385.4355586,
      EWS: 433.9928597,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 429.7361714,
      OBC: 335.3165427,
      SC: 248.9297201,
      ST: 149.9533018,
      EWS: 325.5997954,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 364.7165192,
      OBC: 280.9142736,
      SC: 232.3044571,
      ST: 108.0270485,
      EWS: 362.6299907,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 685.3732885,
      OBC: 538.0328412,
      SC: 454.1407531,
      ST: 333.4115586,
      EWS: 571.5542562,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 522.1848136,
      OBC: 488.4860213,
      SC: 391.5419781,
      ST: 427.2968433,
      EWS: 551.8381168,
      PwBD: 200.0880313,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 548.6423934,
      OBC: 497.7788725,
      SC: 401.2467146,
      ST: 343.389713,
      EWS: 463.1570486,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 855.4462636,
      OBC: 785.359697,
      SC: 702.6020886,
      ST: 636.3563419,
      EWS: 818.877395,
      PwBD: 190.5184234,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 840.7634507,
      OBC: 753.971387,
      SC: 667.7269019,
      ST: 543.8657934,
      EWS: 802.1612803,
      PwBD: 316.8400426,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A Program (Sanskrit + Music)",
    cutoffs: {
      UR: 327.7569557,
      OBC: 281.70139,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 797.1807104,
      OBC: 624.0220033,
      SC: 481.5452455,
      ST: 540.6858652,
      EWS: 689.2226862,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 811.6317749,
      OBC: 747.3789925,
      SC: 666.8612893,
      ST: 661.8534251,
      EWS: 743.0233748,
      PwBD: 444.4303765,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A Program (Music + Nutrition And Health Education(NHE))",
    cutoffs: {
      UR: 650.6309531,
      OBC: 501.0753511,
      SC: 429.2309984,
      ST: 299.9492292,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A Program (Philosophy + Psychology)",
    cutoffs: {
      UR: 791.7407451,
      OBC: 669.431802,
      SC: 603.2606646,
      ST: 526.912008,
      EWS: 652.6214851,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A Program (Physical Education + Political Science)",
    cutoffs: {
      UR: 734.8626325,
      OBC: 605.089994,
      SC: 538.7200606,
      ST: 520.156573,
      EWS: 529.9515593,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A Program (Hindi + Physical Education)",
    cutoffs: {
      UR: 579.9741929,
      OBC: 455.3070901,
      SC: 425.6794295,
      ST: 322.8540774,
      EWS: 369.4476499,
      PwBD: null,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 775.527496,
      OBC: 722.096736,
      SC: 565.8090541,
      ST: 671.5735373,
      EWS: 698.7208582,
      PwBD: 279.4262527,
    },
  },
  {
    collegeName: "Daulat Ram College (W)",
    programName:
      "B.A Program (Entrepreneurship And Small Business + Nutrition And Health Education)",
    cutoffs: {
      UR: 720.0480486,
      OBC: 592.1138959,
      SC: 515.0464496,
      ST: 496.4954895,
      EWS: 614.614933,
      PwBD: 373.9562591,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 707.0563388,
      OBC: 568.0262074,
      SC: 521.078755,
      ST: 510.7420082,
      EWS: 555.0192184,
      PwBD: 175.8784863,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "Bachelor of Management Studies",
    cutoffs: {
      UR: 525.0402941,
      OBC: 385.2586559,
      SC: 344.7879247,
      ST: 208.2420734,
      EWS: 462.3756691,
      PwBD: 189.1853841,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 803.4899547,
      OBC: 690.5912875,
      SC: 597.812197,
      ST: 463.0837236,
      EWS: 733.6024824,
      PwBD: 248.7756922,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 485.0897419,
      OBC: 455.6080526,
      SC: 384.7674268,
      ST: 329.3989017,
      EWS: 461.480565,
      PwBD: null,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 377.6180515,
      OBC: 320.3021128,
      SC: 233.1004292,
      ST: 59.9490623,
      EWS: 322.1814064,
      PwBD: null,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 675.7272677,
      OBC: 590.9934663,
      SC: 496.6307675,
      ST: 402.7345926,
      EWS: 614.3234529,
      PwBD: 177.7683389,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 344.1266043,
      OBC: 261.9183225,
      SC: 170.136309,
      ST: 66.5888657,
      EWS: 268.5463938,
      PwBD: null,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 605.4854521,
      OBC: 472.4880261,
      SC: 367.9649259,
      ST: 159.5679198,
      EWS: 501.2646464,
      PwBD: null,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 357.4658321,
      OBC: 308.2095728,
      SC: 214.0538988,
      ST: 102.5536553,
      EWS: 324.0657746,
      PwBD: null,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 553.2988203,
      OBC: 505.3208454,
      SC: 419.3921826,
      ST: 407.9579661,
      EWS: 484.1068946,
      PwBD: null,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 524.6054358,
      OBC: 460.0726868,
      SC: 373.7555348,
      ST: 302.1708377,
      EWS: 464.6532608,
      PwBD: null,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Sc. (Prog.) Mathematical Sciences",
    cutoffs: {
      UR: 564.5349676,
      OBC: 409.5390847,
      SC: 328.9323439,
      ST: 366.7674185,
      EWS: 431.3863521,
      PwBD: null,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 284.5359192,
      OBC: 227.6253903,
      SC: 137.2587108,
      ST: 100.8338688,
      EWS: 229.3520978,
      PwBD: null,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 354.5696742,
      OBC: 271.7269384,
      SC: 196.0658628,
      ST: 76.0041793,
      EWS: 310.2545455,
      PwBD: null,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 666.8415572,
      OBC: 531.6172329,
      SC: 447.7438729,
      ST: 436.8623747,
      EWS: 499.9532016,
      PwBD: 510.8015662,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 682.1852108,
      OBC: 559.1210489,
      SC: 494.2196815,
      ST: 459.1865752,
      EWS: 533.2752027,
      PwBD: 328.5428019,
    },
  },
  {
    collegeName: "Deen Dayal Upadhyaya College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 697.2521494,
      OBC: 589.7884519,
      SC: 505.074881,
      ST: 549.452573,
      EWS: 535.1059627,
      PwBD: 285.6482796,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.Com.",
    cutoffs: {
      UR: 811.332681,
      OBC: 715.730193,
      SC: 621.6099664,
      ST: 516.211593,
      EWS: 761.2531752,
      PwBD: 242.4501961,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 823.8389181,
      OBC: 748.5556425,
      SC: 669.2085619,
      ST: 610.7278567,
      EWS: 788.6817647,
      PwBD: 355.9199953,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 776.0703048,
      OBC: 595.2722759,
      SC: 501.6355187,
      ST: 336.0059273,
      EWS: 635.5835246,
      PwBD: null,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 743.0426277,
      OBC: 618.2770994,
      SC: 575.0562679,
      ST: 560.2774248,
      EWS: 643.7618958,
      PwBD: 170.6760354,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 760.309633,
      OBC: 692.1200716,
      SC: 605.7279822,
      ST: 597.8755287,
      EWS: 685.7758467,
      PwBD: 349.734797,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 793.3562422,
      OBC: 733.7281516,
      SC: 666.4241581,
      ST: 674.7209287,
      EWS: 745.943045,
      PwBD: 430.8781484,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A. (Hons.) Journalism",
    cutoffs: {
      UR: 779.3648179,
      OBC: 642.3224311,
      SC: 596.0885669,
      ST: 549.9513462,
      EWS: 694.5900178,
      PwBD: 553.091446,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 643.9927917,
      OBC: 561.1300205,
      SC: 471.1600839,
      ST: 445.8094993,
      EWS: 492.3853267,
      PwBD: 348.7201366,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 660.996804,
      OBC: 568.4347324,
      SC: 518.8237536,
      ST: 370.7072135,
      EWS: 580.3550244,
      PwBD: null,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName:
      "B.A Program (Advertising, Sales Promotion and Sales Management (ASPSM) + Economics)",
    cutoffs: {
      UR: 765.9402409,
      OBC: 670.5724673,
      SC: 603.4393865,
      ST: 535.3985097,
      EWS: 670.0220274,
      PwBD: 391.5074036,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A Program (Economics + Human Resource Management (HRM))",
    cutoffs: {
      UR: 787.2351596,
      OBC: 659.670452,
      SC: 571.385054,
      ST: 493.281769,
      EWS: null,
      PwBD: 391.2191135,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 765.3684727,
      OBC: 677.6387049,
      SC: 634.6356953,
      ST: 589.7557078,
      EWS: 666.8866276,
      PwBD: 481.2774288,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A Program (English + German)",
    cutoffs: {
      UR: 617.2551204,
      OBC: 443.1065772,
      SC: 437.6284457,
      ST: null,
      EWS: 424.0201337,
      PwBD: null,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A Program (Hindi + Physical Education)",
    cutoffs: {
      UR: 596.3083572,
      OBC: 488.3098859,
      SC: 468.5976133,
      ST: 349.4680589,
      EWS: 439.6514632,
      PwBD: null,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 774.2058291,
      OBC: 591.7360896,
      SC: 474.9280385,
      ST: 421.4171268,
      EWS: 702.7335658,
      PwBD: null,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A Program (English + Spanish)",
    cutoffs: {
      UR: 583.9029725,
      OBC: 375.0749611,
      SC: 399.5227334,
      ST: 164.9616505,
      EWS: 381.2775525,
      PwBD: null,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 642.0061973,
      OBC: 597.3230914,
      SC: 456.6062937,
      ST: 420.6821866,
      EWS: 564.2798031,
      PwBD: 102.2506352,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName:
      "B.A Program (Operational Research (OR) + Computer Applications)",
    cutoffs: {
      UR: 703.4084969,
      OBC: 520.7826553,
      SC: 462.8037124,
      ST: 178.8979561,
      EWS: 492.2999471,
      PwBD: 272.3711993,
    },
  },
  {
    collegeName: "Delhi College of Arts and Commerce",
    programName: "B.A Program (Accounting and Finance + Computer Applications)",
    cutoffs: {
      UR: 774.3738156,
      OBC: 625.1529147,
      SC: 602.7047098,
      ST: 465.8780947,
      EWS: 620.2978811,
      PwBD: 177.7803325,
    },
  },
  {
    collegeName: "Delhi School of Journalism",
    programName: "Five Year Integrated Program in Journalism",
    cutoffs: {
      UR: 468.6739752,
      OBC: 369.120521,
      SC: 362.424245,
      ST: 262.9468997,
      EWS: 373.336469,
      PwBD: 191.1540861,
    },
  },
  {
    collegeName: "Department of Germanic and Romance Studies",
    programName: "B.A. (Hons.) French",
    cutoffs: {
      UR: 673.9078415,
      OBC: 512.5134682,
      SC: 482.4281983,
      ST: 347.9980692,
      EWS: 547.838389,
      PwBD: null,
    },
  },
  {
    collegeName: "Department of Germanic and Romance Studies",
    programName: "B.A. (Hons.) German",
    cutoffs: {
      UR: 664.6883602,
      OBC: 515.7122264,
      SC: 585.4056046,
      ST: 223.0242037,
      EWS: 519.1307932,
      PwBD: 371.6066027,
    },
  },
  {
    collegeName: "Department of Germanic and Romance Studies",
    programName: "B.A. (Hons.) Italian",
    cutoffs: {
      UR: 617.8258379,
      OBC: 431.1950127,
      SC: 427.7164764,
      ST: 235.2765426,
      EWS: 455.4667108,
      PwBD: null,
    },
  },
  {
    collegeName: "Department of Germanic and Romance Studies",
    programName: "B.A. (Hons.) Spanish",
    cutoffs: {
      UR: 625.4836333,
      OBC: 479.2553044,
      SC: 474.1192886,
      ST: 347.4008987,
      EWS: 495.5337448,
      PwBD: 539.2836336,
    },
  },
  {
    collegeName: "Department of Slavonic & Finno-Ugrian Studies",
    programName: "B.A. (Hons.) Russian",
    cutoffs: {
      UR: 575.2737819,
      OBC: 398.0831137,
      SC: 388.3778915,
      ST: 117.3831251,
      EWS: 376.5339318,
      PwBD: 192.535204,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 722.9098625,
      OBC: 472.6567588,
      SC: 359.8521533,
      ST: 285.3248315,
      EWS: 504.3063682,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 667.7617844,
      OBC: 533.3191587,
      SC: 476.6171954,
      ST: 471.0529787,
      EWS: 500.3192155,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 335.8252343,
      OBC: 87.0202906,
      SC: 119.9254878,
      ST: null,
      EWS: 304.6936948,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 665.5248518,
      OBC: 534.5591675,
      SC: 466.053641,
      ST: 453.2144115,
      EWS: 497.1257114,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 718.0796859,
      OBC: 616.0495423,
      SC: 536.879277,
      ST: 519.6556216,
      EWS: 539.0333026,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 109.1316419,
      OBC: 188.7917544,
      SC: 101.7990521,
      ST: 368.1599928,
      EWS: 111.4814829,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 785.4280103,
      OBC: 652.9811069,
      SC: 564.505568,
      ST: 389.8784845,
      EWS: 713.979847,
      PwBD: 201.2934838,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 495.9208536,
      OBC: 421.5088014,
      SC: 337.1560995,
      ST: 197.6983505,
      EWS: 418.7829096,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.Sc. (Hons.) Biochemistry",
    cutoffs: {
      UR: 513.807202,
      OBC: 484.363004,
      SC: 364.7491011,
      ST: 404.4316918,
      EWS: 514.7886232,
      PwBD: 142.078107,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 466.1572505,
      OBC: 415.7338815,
      SC: 355.5245096,
      ST: 272.7552168,
      EWS: 391.191137,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 367.1970449,
      OBC: 292.050058,
      SC: 200.026894,
      ST: 134.7258438,
      EWS: 321.6342273,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 550.313412,
      OBC: 431.9498788,
      SC: 307.2128212,
      ST: 135.1696457,
      EWS: 439.1098913,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 349.8441937,
      OBC: 278.3646944,
      SC: 132.5014381,
      ST: 68.33727,
      EWS: 264.2616926,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 493.3009169,
      OBC: 443.4437768,
      SC: 389.1832739,
      ST: 353.7501859,
      EWS: 450.8452809,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 247.9960183,
      OBC: 140.5776751,
      SC: 82.1244292,
      ST: null,
      EWS: 144.1188203,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 306.8389445,
      OBC: 235.4920476,
      SC: 173.8639692,
      ST: 154.0785898,
      EWS: 239.4448883,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName:
      "B.Sc (Prog.) Applied Physical Sciences with Industrial Chemistry",
    cutoffs: {
      UR: 203.0374769,
      OBC: 116.0855854,
      SC: 88.616416,
      ST: null,
      EWS: 174.5756283,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 733.8913212,
      OBC: 624.0030085,
      SC: 589.5829816,
      ST: 521.5959195,
      EWS: 616.7486748,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 697.5144856,
      OBC: 592.1679383,
      SC: 553.1012777,
      ST: null,
      EWS: 528.4999957,
      PwBD: 239.7624775,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (English + Mathematics)",
    cutoffs: {
      UR: 656.9124304,
      OBC: 509.6042456,
      SC: 428.892184,
      ST: null,
      EWS: 491.8124715,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 705.5537953,
      OBC: 595.7687038,
      SC: 544.7627742,
      ST: 556.637754,
      EWS: 524.5365321,
      PwBD: 288.2769215,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (English + Philosophy)",
    cutoffs: {
      UR: 654.4458681,
      OBC: 528.8904041,
      SC: 500.8723932,
      ST: 484.6682468,
      EWS: 481.0357827,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 606.5265104,
      OBC: 517.5062841,
      SC: 459.7738521,
      ST: 408.2852227,
      EWS: 448.0562233,
      PwBD: 235.8969964,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Hindi + Philosophy)",
    cutoffs: {
      UR: 611.1418191,
      OBC: 457.9928936,
      SC: 427.9029079,
      ST: null,
      EWS: 454.4497228,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 614.548601,
      OBC: 516.0984832,
      SC: 517.6789859,
      ST: 282.7964208,
      EWS: 448.5356177,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 412.4899777,
      OBC: 226.9858965,
      SC: 275.6036184,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Sanskrit + Philosophy)",
    cutoffs: {
      UR: 467.5125679,
      OBC: 178.73912,
      SC: 256.2811285,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 708.1032139,
      OBC: 664.7362521,
      SC: 557.7317347,
      ST: null,
      EWS: 579.9684679,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 722.8369072,
      OBC: 550.65492,
      SC: 426.4401135,
      ST: null,
      EWS: 470.9020372,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Economics + Philosophy)",
    cutoffs: {
      UR: 686.1092175,
      OBC: 540.9901089,
      SC: 462.206891,
      ST: null,
      EWS: 524.8468048,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 726.9759034,
      OBC: 650.2718087,
      SC: 536.98067,
      ST: 448.1118873,
      EWS: 538.1633299,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (History + Mathematics)",
    cutoffs: {
      UR: 622.0030491,
      OBC: 502.1454004,
      SC: 397.8048484,
      ST: null,
      EWS: 419.7620217,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (History + Philosophy)",
    cutoffs: {
      UR: 654.2349099,
      OBC: 520.023604,
      SC: 463.3767977,
      ST: 438.887471,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 667.1899292,
      OBC: 553.5440707,
      SC: 479.3841943,
      ST: 493.2478208,
      EWS: 511.5547317,
      PwBD: 451.0932896,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Mathematics + Philosophy)",
    cutoffs: {
      UR: 615.4223623,
      OBC: 486.1911565,
      SC: 289.1682452,
      ST: null,
      EWS: 380.5047193,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Mathematics + Political Science)",
    cutoffs: {
      UR: 630.4020079,
      OBC: 553.2385911,
      SC: 376.1620947,
      ST: null,
      EWS: 360.7617148,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 660.0930927,
      OBC: 491.8551793,
      SC: 472.4481195,
      ST: 459.1865752,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Bengali + History)",
    cutoffs: {
      UR: 361.3217051,
      OBC: 278.5437631,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Bengali + Political Science)",
    cutoffs: {
      UR: 226.6057257,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Punjabi + History)",
    cutoffs: {
      UR: 437.3934015,
      OBC: 281.4969535,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Hindi + Economics)",
    cutoffs: {
      UR: 639.6393218,
      OBC: 497.4134573,
      SC: 455.0301275,
      ST: 198.6001636,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Sanskrit + Economics)",
    cutoffs: {
      UR: 498.2504652,
      OBC: 196.7400058,
      SC: 132.1437656,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Punjabi + Political Science)",
    cutoffs: {
      UR: 518.8825977,
      OBC: 212.4126952,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Sindhi + History)",
    cutoffs: {
      UR: 315.0093869,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Deshbandhu College",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 422.5607017,
      OBC: 348.0228022,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A. (Hons.) Applied Psychology",
    cutoffs: {
      UR: 762.9876047,
      OBC: 579.2932646,
      SC: 558.4671701,
      ST: 466.8098825,
      EWS: 521.983578,
      PwBD: 312.6968245,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 635.1920591,
      OBC: 533.5831975,
      SC: 483.8910257,
      ST: 493.9571256,
      EWS: 445.8960983,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A. (Hons.) Hindi Patrakarita",
    cutoffs: {
      UR: 425.682273,
      OBC: 127.495746,
      SC: 299.4074626,
      ST: 240.6382252,
      EWS: 255.0570006,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 620.5639262,
      OBC: 500.3080426,
      SC: 456.9871831,
      ST: 418.2971345,
      EWS: 428.080264,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A. (Hons.) Social Work",
    cutoffs: {
      UR: 572.4181339,
      OBC: 406.4508791,
      SC: 373.0017225,
      ST: 192.5498773,
      EWS: 263.1308295,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.Com.",
    cutoffs: {
      UR: 697.4086545,
      OBC: 539.6032726,
      SC: 451.7010626,
      ST: 208.1706136,
      EWS: 572.1442882,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 729.4892983,
      OBC: 576.0361531,
      SC: 500.9313883,
      ST: 319.6555535,
      EWS: 608.4873395,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 686.0822721,
      OBC: 411.5479863,
      SC: 345.9800438,
      ST: 155.5880203,
      EWS: 409.9203072,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 320.2952592,
      OBC: 77.1864384,
      SC: 104.2673179,
      ST: null,
      EWS: 237.9399225,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A. (Hons.) Business Economics",
    cutoffs: {
      UR: 413.3080606,
      OBC: 274.8090651,
      SC: 195.2328362,
      ST: null,
      EWS: 285.8109476,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 620.0721186,
      OBC: 486.4075314,
      SC: 491.4865952,
      ST: 450.0921716,
      EWS: 420.4261388,
      PwBD: 254.4612747,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (English + Psychology)",
    cutoffs: {
      UR: 738.6079956,
      OBC: 584.5880615,
      SC: 563.4784893,
      ST: 536.648433,
      EWS: 551.9208064,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 531.4903545,
      OBC: 394.7954498,
      SC: 389.1631019,
      ST: 312.0216576,
      EWS: 321.8369609,
      PwBD: 270.5568333,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 531.6759323,
      OBC: 402.5589428,
      SC: 400.6144216,
      ST: 185.8107665,
      EWS: null,
      PwBD: 477.0213527,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Sanskrit + OMSP)",
    cutoffs: {
      UR: 282.3854829,
      OBC: 70.984279,
      SC: 115.3803416,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 315.0067883,
      OBC: 163.224619,
      SC: 242.2798001,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Urdu + History)",
    cutoffs: {
      UR: 372.4150872,
      OBC: 125.1853665,
      SC: null,
      ST: 133.8560419,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Urdu + Political Science)",
    cutoffs: {
      UR: 399.4748284,
      OBC: 52.4746987,
      SC: null,
      ST: 258.7021248,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Economics + Geography)",
    cutoffs: {
      UR: 607.2076468,
      OBC: 480.2877429,
      SC: 499.3731552,
      ST: 427.3730509,
      EWS: 444.569594,
      PwBD: 372.0625767,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Economics + Human Resource Management (HRM))",
    cutoffs: {
      UR: 665.5023569,
      OBC: 522.6633918,
      SC: 437.3852033,
      ST: 382.5364543,
      EWS: 559.3129679,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 642.3780931,
      OBC: 395.1921772,
      SC: 300.5747529,
      ST: 238.3497149,
      EWS: 237.4046348,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Economics + OMSP)",
    cutoffs: {
      UR: 618.4467577,
      OBC: 451.8168126,
      SC: 381.9326706,
      ST: 100.6986105,
      EWS: 411.0198144,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Geography + Psychology)",
    cutoffs: {
      UR: 712.6707873,
      OBC: 505.1117803,
      SC: 492.5758833,
      ST: 480.1417496,
      EWS: 514.5760434,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 604.1188047,
      OBC: 474.8721615,
      SC: 453.8737709,
      ST: 470.0770444,
      EWS: 424.9308624,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Human Resource Management (HRM) + Mathematics)",
    cutoffs: {
      UR: 628.4515124,
      OBC: 449.6381777,
      SC: 329.0355131,
      ST: 195.6702123,
      EWS: 445.4941387,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName: "B.A Program (Human Resource Management (HRM) + Psychology)",
    cutoffs: {
      UR: 733.8500817,
      OBC: 572.2097745,
      SC: 551.1416215,
      ST: 435.070826,
      EWS: 647.8738215,
      PwBD: null,
    },
  },
  {
    collegeName: "Dr. Bhim Rao Ambedkar College",
    programName:
      "B.A Program (Office Management & Secretarial Practice (OMSP) + Political Science)",
    cutoffs: {
      UR: 599.1780529,
      OBC: 436.9984915,
      SC: 426.838,
      ST: 378.8537204,
      EWS: 466.8703778,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 332.6015181,
      OBC: 150.3717337,
      SC: 129.9299042,
      ST: 238.7436726,
      EWS: 245.6407954,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 758.683169,
      OBC: 522.1989635,
      SC: 404.826165,
      ST: 273.1582175,
      EWS: 581.6627894,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 721.3381799,
      OBC: 612.9400136,
      SC: 545.1691607,
      ST: 521.3436115,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 758.4903719,
      OBC: 692.0922594,
      SC: 621.042583,
      ST: 610.9314626,
      EWS: 696.1470083,
      PwBD: 282.7171906,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 738.5963187,
      OBC: 678.9351321,
      SC: 553.3618967,
      ST: 576.9488685,
      EWS: 579.072377,
      PwBD: 552.0192276,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 685.9202331,
      OBC: 567.7115577,
      SC: 501.7387835,
      ST: 503.7799153,
      EWS: 565.8719545,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.Com.",
    cutoffs: {
      UR: 793.6284157,
      OBC: 679.441376,
      SC: 573.2881541,
      ST: 396.8327336,
      EWS: 724.3381989,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 810.4570288,
      OBC: 709.5379275,
      SC: 616.9562303,
      ST: 463.408702,
      EWS: 754.6622275,
      PwBD: 184.4665469,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 571.5841367,
      OBC: 443.3613222,
      SC: 338.0126561,
      ST: 140.2268269,
      EWS: 443.5524132,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 511.3355281,
      OBC: 439.3912212,
      SC: 376.9282058,
      ST: 325.4556416,
      EWS: 465.2632286,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 338.8851172,
      OBC: 311.7199063,
      SC: 164.991236,
      ST: 82.8837794,
      EWS: 307.4772663,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 361.9228294,
      OBC: 286.7231185,
      SC: 191.6059359,
      ST: 52.4822934,
      EWS: 280.7470501,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 504.4263233,
      OBC: 492.9482875,
      SC: 400.2239791,
      ST: 383.4340192,
      EWS: 494.8275204,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 249.5614844,
      OBC: 159.4426446,
      SC: 87.6482274,
      ST: 102.7682048,
      EWS: 63.1286767,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 317.9990846,
      OBC: 241.4973257,
      SC: 172.1539246,
      ST: 40.2292503,
      EWS: 262.4064043,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 496.5198307,
      OBC: 434.821517,
      SC: 348.220221,
      ST: 293.3188858,
      EWS: 431.9737041,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 630.0691136,
      OBC: 540.6071517,
      SC: 467.8263904,
      ST: 310.097479,
      EWS: 587.407676,
      PwBD: 445.9594579,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 652.0787128,
      OBC: 502.7910795,
      SC: 452.7170288,
      ST: 338.341503,
      EWS: 457.5159819,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A. (Hons.) Punjabi",
    cutoffs: {
      UR: 391.7314949,
      OBC: 231.7475465,
      SC: 116.5591484,
      ST: 176.6919522,
      EWS: 92.3569524,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A. (Hons.) Urdu",
    cutoffs: {
      UR: 186.1991627,
      OBC: 147.5010054,
      SC: 238.1420836,
      ST: 238.7244709,
      EWS: 195.1290948,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 382.3219242,
      OBC: 205.0965492,
      SC: 95.8576817,
      ST: null,
      EWS: 225.7948612,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Bengali + Geography)",
    cutoffs: {
      UR: 464.5066716,
      OBC: null,
      SC: 213.247326,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Bengali + History)",
    cutoffs: {
      UR: 300.3687305,
      OBC: null,
      SC: 234.7774744,
      ST: 186.1163412,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Bengali + Political Science)",
    cutoffs: {
      UR: 239.0149152,
      OBC: null,
      SC: 218.9420117,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 753.7977281,
      OBC: 613.125151,
      SC: 545.2798172,
      ST: null,
      EWS: 621.8813257,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 715.4440072,
      OBC: 587.6619904,
      SC: 568.6702724,
      ST: null,
      EWS: 601.7731709,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 739.8100233,
      OBC: 647.1009393,
      SC: 593.223295,
      ST: 599.1627476,
      EWS: 625.720558,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Hindi + Geography)",
    cutoffs: {
      UR: 645.931146,
      OBC: 547.7393928,
      SC: 537.1252934,
      ST: null,
      EWS: 616.7603099,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 628.0321738,
      OBC: 541.7948584,
      SC: 457.2831185,
      ST: null,
      EWS: 449.4989477,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 644.4902083,
      OBC: 544.3375925,
      SC: 562.2739508,
      ST: 340.6019259,
      EWS: 469.3851679,
      PwBD: 237.3715581,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Punjabi + Economics)",
    cutoffs: {
      UR: 566.5807848,
      OBC: 405.2418034,
      SC: 349.0903014,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Punjabi + History)",
    cutoffs: {
      UR: 421.1077797,
      OBC: 243.1514109,
      SC: 216.704071,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Punjabi + Political Science)",
    cutoffs: {
      UR: 531.3392286,
      OBC: 147.6249643,
      SC: 226.6211169,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Sanskrit + Geography)",
    cutoffs: {
      UR: 487.3008827,
      OBC: 235.2111747,
      SC: 248.4119757,
      ST: null,
      EWS: 228.7203367,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 451.0719689,
      OBC: 363.949321,
      SC: 141.9397329,
      ST: null,
      EWS: 168.0968884,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 469.5899582,
      OBC: 348.337557,
      SC: 172.3450857,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Urdu + Economics)",
    cutoffs: {
      UR: 574.2633783,
      OBC: 367.8239771,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Urdu + History)",
    cutoffs: {
      UR: 485.5976524,
      OBC: 292.9405638,
      SC: 363.6787219,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Urdu + Political Science)",
    cutoffs: {
      UR: 496.0963647,
      OBC: 358.8104636,
      SC: 255.5764707,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Commerce + Economics)",
    cutoffs: {
      UR: 766.6764226,
      OBC: 644.4665229,
      SC: 538.9795244,
      ST: 429.7386989,
      EWS: 716.3018853,
      PwBD: 227.2215415,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Economics + Geography)",
    cutoffs: {
      UR: 726.2938049,
      OBC: 644.7047826,
      SC: 635.3163808,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 726.6258721,
      OBC: 644.7413981,
      SC: 556.9117881,
      ST: null,
      EWS: 618.8299822,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 733.3531724,
      OBC: 505.0130932,
      SC: 388.5572834,
      ST: 84.1173803,
      EWS: 548.3571251,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Economics + Philosophy)",
    cutoffs: {
      UR: 722.0704998,
      OBC: 621.1239503,
      SC: 506.8114545,
      ST: null,
      EWS: 556.0160776,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 735.8351047,
      OBC: 676.7975776,
      SC: 589.6825711,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Geography + History)",
    cutoffs: {
      UR: 720.2377612,
      OBC: 644.1674219,
      SC: 615.4038228,
      ST: 619.7881533,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Geography + Mathematics)",
    cutoffs: {
      UR: 604.6613129,
      OBC: 515.7539725,
      SC: 229.5118115,
      ST: null,
      EWS: 393.7179069,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Geography + Political Science)",
    cutoffs: {
      UR: 726.7362356,
      OBC: 675.5700475,
      SC: 580.1324537,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (History + Philosophy)",
    cutoffs: {
      UR: 695.613065,
      OBC: 547.8832177,
      SC: 494.2928168,
      ST: 425.6971071,
      EWS: 513.5060853,
      PwBD: 383.4761246,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 743.1105585,
      OBC: 658.7113764,
      SC: 562.4755067,
      ST: 561.2287316,
      EWS: null,
      PwBD: 314.4904262,
    },
  },
  {
    collegeName: "Dyal Singh College",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 691.7304906,
      OBC: 577.7982205,
      SC: 506.1223743,
      ST: 468.7409481,
      EWS: 536.841138,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 610.1452457,
      OBC: 445.884027,
      SC: 407.1289387,
      ST: 350.9708894,
      EWS: 421.8005796,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 603.1278106,
      OBC: 489.394411,
      SC: 422.2772967,
      ST: 397.5313352,
      EWS: 369.9493593,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.Com.",
    cutoffs: {
      UR: 705.0929143,
      OBC: 549.0893651,
      SC: 427.9710191,
      ST: 134.2796391,
      EWS: 593.4829409,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 740.7174935,
      OBC: 613.5749948,
      SC: 508.7953385,
      ST: 162.0235965,
      EWS: 649.0345948,
      PwBD: 371.5260618,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 587.880858,
      OBC: 416.9152405,
      SC: 299.4212281,
      ST: 123.4456348,
      EWS: 376.6128363,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A Program (Human Resource Management (HRM) + Economics)",
    cutoffs: {
      UR: 628.8395153,
      OBC: 446.3425504,
      SC: 368.0668968,
      ST: 181.2444537,
      EWS: 474.3949194,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 577.9794931,
      OBC: 444.9935573,
      SC: 412.9324945,
      ST: 354.2514894,
      EWS: 375.6133585,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName:
      "B.A Program (Entrepreneurship and Small Business (ESB) + History)",
    cutoffs: {
      UR: 577.4405727,
      OBC: 413.8940809,
      SC: 329.8957536,
      ST: 311.4222242,
      EWS: 386.8106083,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName:
      "B.A Program (Entrepreneurship and Small Business (ESB) + Political Science)",
    cutoffs: {
      UR: 574.8654084,
      OBC: 436.4044447,
      SC: 355.3930676,
      ST: 163.1960383,
      EWS: 371.0441077,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 609.3538449,
      OBC: 437.5441751,
      SC: 391.5285204,
      ST: 269.1099031,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 584.8901824,
      OBC: 459.4310061,
      SC: 413.3572423,
      ST: 447.4544753,
      EWS: 370.9633632,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A Program (Tamil + Political Science)",
    cutoffs: {
      UR: 111.5643827,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A Program (Punjabi + History)",
    cutoffs: {
      UR: 232.8687451,
      OBC: 211.0360079,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 298.4399693,
      OBC: 142.9535988,
      SC: null,
      ST: null,
      EWS: 195.7081375,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A Program (Urdu + History)",
    cutoffs: {
      UR: 330.8297172,
      OBC: 157.7972159,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Dyal Singh College (Evening)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 592.3423948,
      OBC: 357.4380831,
      SC: 222.3799291,
      ST: null,
      EWS: 180.173758,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A. (Hons.) Applied Psychology",
    cutoffs: {
      UR: 860.9297228,
      OBC: 732.311755,
      SC: 677.5866901,
      ST: 656.6009731,
      EWS: 724.10368,
      PwBD: 574.4936307,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 776.5645688,
      OBC: 662.6851512,
      SC: 605.2911885,
      ST: 606.6583857,
      EWS: 670.51376,
      PwBD: 218.519606,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 398.7564162,
      OBC: 242.3876669,
      SC: 273.9416542,
      ST: null,
      EWS: 200.6636913,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 776.2605393,
      OBC: 709.1814299,
      SC: 624.1405996,
      ST: 603.8640267,
      EWS: 693.8905978,
      PwBD: 238.3276172,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 726.1837424,
      OBC: 575.4608659,
      SC: 464.3907782,
      ST: 370.3230784,
      EWS: 549.79834,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 818.8215928,
      OBC: 742.207318,
      SC: 663.7930247,
      ST: 623.024296,
      EWS: 740.991201,
      PwBD: 215.8871823,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 311.4261719,
      OBC: 126.8794003,
      SC: 186.2112299,
      ST: null,
      EWS: 174.9673288,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 807.3364405,
      OBC: 692.1219244,
      SC: 592.4093804,
      ST: 435.147542,
      EWS: 737.9404677,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 831.1977965,
      OBC: 745.8621065,
      SC: 653.4699498,
      ST: 539.9484754,
      EWS: 782.5046183,
      PwBD: 466.1758184,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 482.6648123,
      OBC: 459.8575715,
      SC: 391.8512764,
      ST: 252.87058,
      EWS: 481.7988889,
      PwBD: 210.3668266,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 370.9903139,
      OBC: 341.4072456,
      SC: 236.4747283,
      ST: 122.5408675,
      EWS: 327.5628099,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.Sc. (Hons.) Microbiology",
    cutoffs: {
      UR: 590.9155691,
      OBC: 536.6752093,
      SC: 483.3728957,
      ST: 436.133342,
      EWS: 557.5094441,
      PwBD: 354.1065332,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 661.4791589,
      OBC: 479.8471093,
      SC: 325.4822961,
      ST: 158.2507296,
      EWS: 510.7056705,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 341.37609,
      OBC: 330.2194793,
      SC: 217.1765809,
      ST: 146.0532234,
      EWS: 329.6192405,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 512.6412963,
      OBC: 471.7858583,
      SC: 445.8388745,
      ST: 387.6608474,
      EWS: 508.9006886,
      PwBD: 269.7699098,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 490.5331037,
      OBC: 464.2851156,
      SC: 374.4251285,
      ST: 313.3740697,
      EWS: null,
      PwBD: 78.0014647,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 301.7302703,
      OBC: 224.82946,
      SC: 125.2954523,
      ST: 101.0531202,
      EWS: 255.2813446,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 799.7742581,
      OBC: 581.8363326,
      SC: 467.6070602,
      ST: 177.3825102,
      EWS: 631.7824815,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A. (Hons.) Business Economics",
    cutoffs: {
      UR: 479.7122254,
      OBC: 334.4423764,
      SC: 271.8733971,
      ST: 221.1344103,
      EWS: 362.2625952,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "Bachelor of Elementary Education",
    cutoffs: {
      UR: 679.4887608,
      OBC: 560.8687536,
      SC: 581.3337493,
      ST: 435.9226316,
      EWS: 502.299987,
      PwBD: 119.5292357,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (English + German)",
    cutoffs: {
      UR: 628.1619096,
      OBC: 428.3446269,
      SC: 435.5981557,
      ST: 198.7055497,
      EWS: 326.3261691,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 767.5648435,
      OBC: 673.5720475,
      SC: 627.9590671,
      ST: 565.3329976,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (English + Philosophy)",
    cutoffs: {
      UR: 737.6075761,
      OBC: 630.4839217,
      SC: 548.295803,
      ST: null,
      EWS: 622.1433527,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (English + Psychology)",
    cutoffs: {
      UR: 822.7394955,
      OBC: 694.3979318,
      SC: 678.9806584,
      ST: 635.1537154,
      EWS: 685.6711292,
      PwBD: 256.2454837,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (German + History)",
    cutoffs: {
      UR: 569.9294854,
      OBC: 389.6253657,
      SC: 344.2019425,
      ST: null,
      EWS: 307.0023136,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (German + Political Science)",
    cutoffs: {
      UR: 624.1779143,
      OBC: 296.9195163,
      SC: 324.4688907,
      ST: 440.6977225,
      EWS: 436.1249857,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 656.198996,
      OBC: 582.1332474,
      SC: 497.1938286,
      ST: 393.4149561,
      EWS: 554.1064481,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 674.066505,
      OBC: 572.8597877,
      SC: 485.0475,
      ST: 323.7555671,
      EWS: 582.810722,
      PwBD: 427.573202,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 796.4264626,
      OBC: 601.2705959,
      SC: 592.9263651,
      ST: null,
      EWS: 605.4374701,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName:
      "B.A Program (Computer Applications + Entrepreneurship and Small Business (ESB))",
    cutoffs: {
      UR: 713.4839266,
      OBC: 496.3230125,
      SC: 436.435074,
      ST: 323.0996053,
      EWS: 486.4754267,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 702.67838,
      OBC: 504.1762197,
      SC: 478.427048,
      ST: null,
      EWS: 547.6613422,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName:
      "B.A Program (Economics + Entrepreneurship and Small Business (ESB))",
    cutoffs: {
      UR: 777.2282926,
      OBC: 645.0196831,
      SC: 621.3083189,
      ST: 484.3314951,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 781.9921182,
      OBC: 575.3756268,
      SC: null,
      ST: null,
      EWS: 648.0240872,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 796.1869713,
      OBC: 720.768711,
      SC: 639.2159741,
      ST: 610.4130366,
      EWS: 707.5788729,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (Economics + Psychology)",
    cutoffs: {
      UR: 836.9300731,
      OBC: 673.3226399,
      SC: 624.4127526,
      ST: 617.1281396,
      EWS: 705.832855,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName:
      "B.A Program (Entrepreneurship and Small Business (ESB) + Mathematics)",
    cutoffs: {
      UR: 722.3775349,
      OBC: 452.4597892,
      SC: 400.8780971,
      ST: null,
      EWS: 399.8921141,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (History + Philosophy)",
    cutoffs: {
      UR: 735.854688,
      OBC: 664.3277127,
      SC: 564.7799807,
      ST: null,
      EWS: 586.9207319,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 768.1976989,
      OBC: 705.2095519,
      SC: 607.4406955,
      ST: 587.2199953,
      EWS: 698.8256212,
      PwBD: 543.9695979,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 737.3585188,
      OBC: 647.3614217,
      SC: 547.4126801,
      ST: 573.9064581,
      EWS: 648.0477716,
      PwBD: null,
    },
  },
  {
    collegeName: "Gargi College (W)",
    programName: "B.A Program (Philosophy + Psychology)",
    cutoffs: {
      UR: 819.9980028,
      OBC: 658.8603069,
      SC: 664.2047935,
      ST: null,
      EWS: 651.3037329,
      PwBD: null,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 864.5004621,
      OBC: 721.9032409,
      SC: 642.6301129,
      ST: 502.8714709,
      EWS: 770.3267612,
      PwBD: 471.154149,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 851.113423,
      OBC: 770.6624674,
      SC: 715.6246694,
      ST: 690.6349734,
      EWS: 777.7978908,
      PwBD: 595.1984874,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 644.3759877,
      OBC: 545.196587,
      SC: 551.7333078,
      ST: 234.3558252,
      EWS: 463.2582828,
      PwBD: 352.328166,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 875.0123017,
      OBC: 832.3329235,
      SC: 777.5884143,
      ST: 779.1791537,
      EWS: 844.6929111,
      PwBD: 620.9043828,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 173.7851023,
      OBC: 436.7035345,
      SC: 305.8340313,
      ST: 272.3541526,
      EWS: 434.5708683,
      PwBD: null,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 899.604521,
      OBC: 828.5794476,
      SC: 764.0232,
      ST: 709.0878191,
      EWS: 827.3642012,
      PwBD: 675.8737746,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 606.2691545,
      OBC: 563.7327591,
      SC: 499.6597089,
      ST: 463.2909572,
      EWS: 541.6024414,
      PwBD: 298.4915025,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 430.012407,
      OBC: 370.4949654,
      SC: 289.3639474,
      ST: 192.3009326,
      EWS: null,
      PwBD: 113.1089288,
    },
  },
  {
    collegeName: "Hansraj College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 490.770343,
      OBC: 361.9448187,
      SC: 328.8123472,
      ST: 203.1273026,
      EWS: 463.5078548,
      PwBD: 111.9934869,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc. (Hons.) Anthropology",
    cutoffs: {
      UR: 588.2390791,
      OBC: 535.996529,
      SC: 483.2461385,
      ST: 441.8810018,
      EWS: 515.5776387,
      PwBD: 268.2946942,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 621.1446785,
      OBC: 561.5057141,
      SC: 483.8675094,
      ST: 456.2821479,
      EWS: 483.4341208,
      PwBD: 241.953905,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 462.0923929,
      OBC: 432.8771872,
      SC: 352.1144898,
      ST: 147.9240634,
      EWS: 447.8674861,
      PwBD: null,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 784.3540376,
      OBC: 688.6638709,
      SC: 638.2804158,
      ST: 487.253636,
      EWS: 741.103028,
      PwBD: 483.1232978,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 415.5627566,
      OBC: 420.4004827,
      SC: 328.0920959,
      ST: 237.863872,
      EWS: 455.2626482,
      PwBD: null,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc. (Hons.) Geology",
    cutoffs: {
      UR: 553.8455601,
      OBC: 492.6890044,
      SC: 422.5458249,
      ST: 397.8933132,
      EWS: 498.1677528,
      PwBD: 155.3232502,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 763.5279307,
      OBC: 650.6505452,
      SC: 572.9585957,
      ST: 457.9933502,
      EWS: 654.4383627,
      PwBD: 365.4774425,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 528.5707723,
      OBC: 457.5894765,
      SC: 377.0676482,
      ST: 220.2381012,
      EWS: 472.8110212,
      PwBD: 92.9186391,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 643.6225721,
      OBC: 502.6326692,
      SC: 430.1338116,
      ST: 486.2714769,
      EWS: 624.2219674,
      PwBD: 413.1150526,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 845.3368883,
      OBC: 776.7122013,
      SC: 718.3356793,
      ST: 697.8138752,
      EWS: 799.5954065,
      PwBD: 567.9695592,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A Program (Commerce + Economics)",
    cutoffs: {
      UR: 872.9954166,
      OBC: 763.053619,
      SC: 709.3880796,
      ST: 665.179249,
      EWS: 827.2962371,
      PwBD: 639.0601335,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 827.4772809,
      OBC: 733.1893119,
      SC: 660.6812711,
      ST: 603.0924548,
      EWS: 750.89539,
      PwBD: 477.6123839,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A Program (Hindi + Physical Education)",
    cutoffs: {
      UR: 689.4377654,
      OBC: 606.7480313,
      SC: 520.3312944,
      ST: 516.1076893,
      EWS: 606.6788704,
      PwBD: 422.3385741,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A Program (Philosophy + Physical Education)",
    cutoffs: {
      UR: 741.6760762,
      OBC: 672.9583849,
      SC: 624.0195747,
      ST: 568.1230897,
      EWS: 630.4790729,
      PwBD: 415.2533516,
    },
  },
  {
    collegeName: "Hansraj College",
    programName: "B.A Program (Sanskrit + Philosophy)",
    cutoffs: {
      UR: 620.1323575,
      OBC: 509.5401018,
      SC: 343.382452,
      ST: 130.4312371,
      EWS: 513.322855,
      PwBD: null,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 885.7628699,
      OBC: 827.5957115,
      SC: 783.1633175,
      ST: 785.0079094,
      EWS: 854.9366646,
      PwBD: 637.5776185,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 888.1655407,
      OBC: 685.7843673,
      SC: 705.9676933,
      ST: 605.993109,
      EWS: 807.9570594,
      PwBD: 586.4270001,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 753.6070734,
      OBC: 689.1431315,
      SC: 662.3108155,
      ST: 446.220277,
      EWS: 625.1960413,
      PwBD: 519.6307644,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 914.3815781,
      OBC: 885.8071783,
      SC: 834.2829836,
      ST: 871.0471651,
      EWS: 883.1421921,
      PwBD: 714.3731458,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 935.3970036,
      OBC: 922.9031365,
      SC: 889.6850432,
      ST: 899.1320305,
      EWS: 920.7809818,
      PwBD: 862.7592682,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 480.3216784,
      OBC: 118.7996143,
      SC: 389.1391629,
      ST: 166.1352255,
      EWS: null,
      PwBD: 282.4895089,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 891.9902671,
      OBC: 843.6481753,
      SC: 777.8429977,
      ST: 789.0005385,
      EWS: 822.6685082,
      PwBD: 623.1920319,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 865.0003412,
      OBC: 789.608079,
      SC: 678.8383176,
      ST: 644.3679134,
      EWS: 781.981531,
      PwBD: 530.254438,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 912.2188167,
      OBC: 843.217532,
      SC: 784.0983895,
      ST: 735.1002248,
      EWS: 871.504484,
      PwBD: 718.8836228,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 547.4435352,
      OBC: 404.6335729,
      SC: 391.0010116,
      ST: 266.5040171,
      EWS: 527.4029732,
      PwBD: 69.0132561,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 495.3369213,
      OBC: 450.4563102,
      SC: 386.1242289,
      ST: 262.8433381,
      EWS: 470.718578,
      PwBD: 176.9823763,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 656.1191562,
      OBC: 586.6985967,
      SC: 523.8811479,
      ST: 522.4556697,
      EWS: 618.5947013,
      PwBD: 415.7008815,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 678.439355,
      OBC: 642.6708861,
      SC: 480.0691673,
      ST: 531.6225762,
      EWS: 645.662632,
      PwBD: 486.790639,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 818.3477146,
      OBC: 709.0147968,
      SC: 631.7420628,
      ST: 562.830222,
      EWS: 711.1572734,
      PwBD: 414.3517475,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.Sc. (Hons.) Statistics",
    cutoffs: {
      UR: 848.633302,
      OBC: 731.665072,
      SC: 620.1348299,
      ST: 467.3719866,
      EWS: 730.4380325,
      PwBD: 310.0457822,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.Sc (Prog.) Physical Science with Electronics",
    cutoffs: {
      UR: 441.916361,
      OBC: 384.3854349,
      SC: 209.492889,
      ST: 180.297392,
      EWS: 385.4027676,
      PwBD: null,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 448.471986,
      OBC: 380.8059829,
      SC: 309.8603335,
      ST: 224.9935894,
      EWS: 373.7867177,
      PwBD: null,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 894.5109581,
      OBC: 837.1791376,
      SC: 789.2595051,
      ST: 885.0596786,
      EWS: 834.6462965,
      PwBD: 777.9586164,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A Program (Hindi + Philosophy)",
    cutoffs: {
      UR: 810.4723565,
      OBC: 739.1335727,
      SC: 711.8383641,
      ST: 554.5265889,
      EWS: 722.1032843,
      PwBD: 586.6408813,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 807.886727,
      OBC: 746.862903,
      SC: 616.4250699,
      ST: 649.7468246,
      EWS: 736.811085,
      PwBD: 550.5743553,
    },
  },
  {
    collegeName: "Hindu College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 936.1827585,
      OBC: 804.9415941,
      SC: 774.5598378,
      ST: 934.1694057,
      EWS: 891.7084782,
      PwBD: 832.9444701,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 760.5497955,
      OBC: 594.4111305,
      SC: 491.0554581,
      ST: 108.4788873,
      EWS: 640.9579419,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 740.1144682,
      OBC: 669.1488782,
      SC: 628.5287024,
      ST: 595.4671929,
      EWS: 684.6574614,
      PwBD: 286.2350337,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 384.8189694,
      OBC: 167.2623097,
      SC: 251.1418699,
      ST: 331.5502179,
      EWS: 165.7601935,
      PwBD: 128.4415493,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 795.7507768,
      OBC: 733.2497307,
      SC: 632.6159072,
      ST: 636.2016025,
      EWS: 718.8038686,
      PwBD: 213.5493571,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 712.2910938,
      OBC: 592.1682493,
      SC: 466.5274114,
      ST: 196.2445921,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 825.6628298,
      OBC: 761.9012684,
      SC: 679.1166706,
      ST: 666.3500259,
      EWS: 766.2022371,
      PwBD: 434.7850628,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 878.0639125,
      OBC: 759.0171823,
      SC: 743.0016169,
      ST: 733.0787523,
      EWS: 790.9630221,
      PwBD: 531.3262125,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 323.4555882,
      OBC: 203.6166789,
      SC: 154.4574077,
      ST: null,
      EWS: 122.4224812,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 824.2999901,
      OBC: 755.9394749,
      SC: 664.5227936,
      ST: 566.3878426,
      EWS: 773.9472627,
      PwBD: 384.1518538,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 676.6250486,
      OBC: 562.7094156,
      SC: 541.3395059,
      ST: 178.8422671,
      EWS: 600.6171846,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 650.057956,
      OBC: 501.5794291,
      SC: 377.3900671,
      ST: 238.940751,
      EWS: 507.4676137,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 814.4258064,
      OBC: 740.7069332,
      SC: 672.0207502,
      ST: 660.3238421,
      EWS: 724.6375245,
      PwBD: 341.2324047,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 774.9382504,
      OBC: 690.8674002,
      SC: 612.632597,
      ST: 604.8195115,
      EWS: 657.5063167,
      PwBD: 369.2943109,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A. (Hons.) Multi Media and Mass Communication",
    cutoffs: {
      UR: 520.6672295,
      OBC: 444.3362706,
      SC: 393.7252501,
      ST: 319.8304834,
      EWS: 431.4687321,
      PwBD: 144.0202324,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 763.477169,
      OBC: 715.3516831,
      SC: 615.212335,
      ST: 626.1022275,
      EWS: null,
      PwBD: 274.9605548,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 783.2494706,
      OBC: 727.8989301,
      SC: 647.0953069,
      ST: 592.4230758,
      EWS: null,
      PwBD: 343.1378633,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 705.5177904,
      OBC: 617.6947386,
      SC: 522.0443056,
      ST: 549.1151906,
      EWS: 625.9409513,
      PwBD: 368.280397,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 732.222965,
      OBC: 677.3767588,
      SC: 503.3805142,
      ST: 457.4839694,
      EWS: 614.5214233,
      PwBD: 216.5807307,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Sanskrit + Philosophy)",
    cutoffs: {
      UR: 471.2114107,
      OBC: 327.37669,
      SC: 301.259388,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 665.7138166,
      OBC: 481.03805,
      SC: 428.3193855,
      ST: 340.3676213,
      EWS: 537.6947645,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 774.8813136,
      OBC: 598.941928,
      SC: 427.8653695,
      ST: 415.3591132,
      EWS: 629.029184,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 800.8606543,
      OBC: 728.1715408,
      SC: 635.5184009,
      ST: 655.8111789,
      EWS: null,
      PwBD: 237.8733756,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (History + Philosophy)",
    cutoffs: {
      UR: 756.901336,
      OBC: 694.3209988,
      SC: 545.5577357,
      ST: 541.4977061,
      EWS: 621.8888362,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 790.2989633,
      OBC: 733.0121195,
      SC: 654.3702875,
      ST: 653.2238745,
      EWS: 741.6300795,
      PwBD: 264.8087384,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Psychology)",
    cutoffs: {
      UR: 796.1991528,
      OBC: 627.3727842,
      SC: 599.7355733,
      ST: 548.0919837,
      EWS: 610.3926551,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 749.5097955,
      OBC: 609.2723808,
      SC: 401.1777357,
      ST: null,
      EWS: 609.5319057,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 544.6186192,
      OBC: 388.9899887,
      SC: 268.3523973,
      ST: null,
      EWS: 310.1226059,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Philosophy + Psychology)",
    cutoffs: {
      UR: 795.9127871,
      OBC: 684.9287221,
      SC: 612.2057628,
      ST: 559.3421086,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 613.0879397,
      OBC: 367.8308876,
      SC: 169.6948707,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Philosophy)",
    cutoffs: {
      UR: 690.2446693,
      OBC: 579.3069733,
      SC: 403.4829294,
      ST: null,
      EWS: 391.7895973,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Hindi)",
    cutoffs: {
      UR: 652.008982,
      OBC: 430.9800281,
      SC: 377.8366003,
      ST: null,
      EWS: 562.5370281,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Commerce + Economics)",
    cutoffs: {
      UR: 828.7007749,
      OBC: 687.0665065,
      SC: 630.714484,
      ST: 503.1065492,
      EWS: null,
      PwBD: 418.3680537,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Geography + English)",
    cutoffs: {
      UR: 775.5393924,
      OBC: 723.3518133,
      SC: 605.9263511,
      ST: 619.5633259,
      EWS: 682.0374189,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Hindi + Geography)",
    cutoffs: {
      UR: 707.2362222,
      OBC: 646.1340065,
      SC: 489.5003503,
      ST: 425.3797259,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Geography + History)",
    cutoffs: {
      UR: 805.12984,
      OBC: 726.1398063,
      SC: null,
      ST: 616.90747,
      EWS: 695.0741874,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Geography + Political Science)",
    cutoffs: {
      UR: 797.9937822,
      OBC: 739.8438073,
      SC: 638.4821498,
      ST: 608.6302836,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Sanskrit + Geography)",
    cutoffs: {
      UR: 512.3119076,
      OBC: 451.1346821,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Sociology)",
    cutoffs: {
      UR: 699.6482176,
      OBC: 583.3139306,
      SC: 511.7942766,
      ST: null,
      EWS: 622.8690964,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (History + Sociology)",
    cutoffs: {
      UR: 773.6991163,
      OBC: 723.3512708,
      SC: 589.8637414,
      ST: null,
      EWS: 657.3986698,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Philosophy + Sociology)",
    cutoffs: {
      UR: 738.7306449,
      OBC: 611.0749203,
      SC: 550.8418388,
      ST: null,
      EWS: 643.808419,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Psychology + Sociology)",
    cutoffs: {
      UR: 834.6185233,
      OBC: 729.3748316,
      SC: 635.4086365,
      ST: null,
      EWS: 659.7209889,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Commerce + Mathematics)",
    cutoffs: {
      UR: 755.3615994,
      OBC: 511.7054741,
      SC: 364.8823903,
      ST: 245.8337084,
      EWS: 560.9590799,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName:
      "B.A Program (English + Human Development and Family Empowerment (HDFE))",
    cutoffs: {
      UR: 693.8729877,
      OBC: 589.8659846,
      SC: 490.2363425,
      ST: 538.6769413,
      EWS: 602.5241004,
      PwBD: 74.4686808,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Hindi + Psychology)",
    cutoffs: {
      UR: 763.5295713,
      OBC: 590.8346931,
      SC: 506.1576756,
      ST: 446.0834931,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Commerce + Psychology)",
    cutoffs: {
      UR: 788.893333,
      OBC: 698.9396646,
      SC: 602.2447516,
      ST: 511.2580918,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Indraprastha College for Women (W)",
    programName: "B.A Program (Commerce + Computer Applications)",
    cutoffs: {
      UR: 739.5981371,
      OBC: 543.4779253,
      SC: 395.9900019,
      ST: 523.0689641,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Institute of Home Economics (W)",
    programName: "B.Sc. (Pass) Home Science",
    cutoffs: {
      UR: 520.9451635,
      OBC: 292.0667617,
      SC: 273.5529913,
      ST: 181.4848284,
      EWS: 225.668718,
      PwBD: null,
    },
  },
  {
    collegeName: "Institute of Home Economics (W)",
    programName: "B.Sc. (Hons.) Home Science",
    cutoffs: {
      UR: 399.6280545,
      OBC: 255.5305478,
      SC: 252.0513301,
      ST: 118.8629536,
      EWS: 169.7563508,
      PwBD: null,
    },
  },
  {
    collegeName: "Institute of Home Economics (W)",
    programName: "B.Sc. (Hons.) Microbiology",
    cutoffs: {
      UR: 481.4178644,
      OBC: 462.0817235,
      SC: 376.5588044,
      ST: 327.7394054,
      EWS: 454.1160101,
      PwBD: 204.943781,
    },
  },
  {
    collegeName: "Institute of Home Economics (W)",
    programName: "B.Sc. (Hons.) Biochemistry",
    cutoffs: {
      UR: 489.5465934,
      OBC: 467.4514148,
      SC: 396.0506737,
      ST: 323.9015525,
      EWS: 456.0840643,
      PwBD: 328.2604378,
    },
  },
  {
    collegeName: "Institute of Home Economics (W)",
    programName: "B.A. (Hons.) Journalism",
    cutoffs: {
      UR: 666.6516733,
      OBC: 536.3085022,
      SC: 454.6125138,
      ST: 395.5454198,
      EWS: 529.2201984,
      PwBD: null,
    },
  },
  {
    collegeName: "Institute of Home Economics (W)",
    programName: "B.Sc. (Hons.) Food Technology",
    cutoffs: {
      UR: 470.5493098,
      OBC: 434.1266546,
      SC: 360.0901092,
      ST: 306.1508189,
      EWS: 429.8602057,
      PwBD: null,
    },
  },
  {
    collegeName: "Institute of Home Economics (W)",
    programName: "Bachelor of Elementary Education",
    cutoffs: {
      UR: 618.1830443,
      OBC: 515.1101619,
      SC: 507.9846865,
      ST: 357.7817414,
      EWS: 468.8374074,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 696.1060115,
      OBC: 519.2538989,
      SC: 412.5450909,
      ST: 108.2092397,
      EWS: 558.2882512,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 735.1517648,
      OBC: 561.664994,
      SC: 469.8720991,
      ST: 212.1941596,
      EWS: 593.7005822,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 671.8336076,
      OBC: 363.3998976,
      SC: 275.8764712,
      ST: null,
      EWS: 372.2258775,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 653.0459094,
      OBC: 483.7964009,
      SC: 477.2611447,
      ST: 241.315679,
      EWS: 460.8504855,
      PwBD: 273.0842425,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 241.1631556,
      OBC: 161.3903167,
      SC: 74.2506661,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 627.801883,
      OBC: 451.8199887,
      SC: 411.8400385,
      ST: 348.3815053,
      EWS: 334.2128127,
      PwBD: 421.6430474,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 489.5350479,
      OBC: 279.6311535,
      SC: 46.2736716,
      ST: 119.9781461,
      EWS: 212.4072894,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 585.1901958,
      OBC: 404.5230529,
      SC: 348.1675566,
      ST: 272.2928762,
      EWS: 372.4097163,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 663.7897484,
      OBC: 546.5887846,
      SC: 471.4548932,
      ST: 320.1960792,
      EWS: 347.537107,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 270.2076463,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 628.4569334,
      OBC: 455.3391568,
      SC: 390.689031,
      ST: 346.570722,
      EWS: 389.9392151,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 669.7933571,
      OBC: 496.8830404,
      SC: 472.5656079,
      ST: 362.5238833,
      EWS: 491.4037366,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 641.7563307,
      OBC: 495.9620102,
      SC: 518.8670061,
      ST: 252.1636179,
      EWS: 457.0968488,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (English + Philosophy)",
    cutoffs: {
      UR: 659.9052523,
      OBC: 506.0014579,
      SC: 428.198374,
      ST: 470.4602235,
      EWS: 442.8214552,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 524.5093246,
      OBC: 384.312028,
      SC: 385.6456096,
      ST: null,
      EWS: 244.1285913,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Hindi + Music)",
    cutoffs: {
      UR: 482.6590325,
      OBC: 324.294936,
      SC: 381.095614,
      ST: 451.4532772,
      EWS: 213.2825337,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 223.1532135,
      OBC: 167.8197171,
      SC: 147.066748,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Sanskrit + HDFE)",
    cutoffs: {
      UR: 339.4689361,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Sanskrit + Music)",
    cutoffs: {
      UR: 316.2299122,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Sanskrit + Philosophy)",
    cutoffs: {
      UR: 358.7714628,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 406.7387344,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 611.0193033,
      OBC: 459.7369433,
      SC: 422.9604159,
      ST: 301.2349588,
      EWS: 358.7846702,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Economics + HDFE)",
    cutoffs: {
      UR: 642.5455607,
      OBC: 383.7013377,
      SC: 334.2216581,
      ST: 197.7705077,
      EWS: 394.354001,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 638.7290241,
      OBC: 356.7899367,
      SC: 213.8425963,
      ST: null,
      EWS: 343.6974971,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 644.8257349,
      OBC: 531.9345484,
      SC: 434.77621,
      ST: 339.7652904,
      EWS: 410.0665333,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (History + Music)",
    cutoffs: {
      UR: 524.3718473,
      OBC: 383.742399,
      SC: 247.0356037,
      ST: null,
      EWS: 342.17743,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (History + Philosophy)",
    cutoffs: {
      UR: 586.8922941,
      OBC: 432.4276543,
      SC: 394.3262909,
      ST: 205.8324805,
      EWS: 420.4493049,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 600.8140599,
      OBC: 450.416791,
      SC: 408.9079563,
      ST: 434.5058785,
      EWS: 328.1420691,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Music + Political Science)",
    cutoffs: {
      UR: 566.4358615,
      OBC: 227.0535648,
      SC: 238.1989652,
      ST: 86.1363752,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 589.9362989,
      OBC: 419.5267197,
      SC: 385.8346869,
      ST: 86.1363752,
      EWS: 325.7462643,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Political Science)",
    cutoffs: {
      UR: 555.0104604,
      OBC: 371.7789115,
      SC: 278.0945481,
      ST: 227.7564148,
      EWS: 324.0157661,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Philosophy)",
    cutoffs: {
      UR: 575.4362767,
      OBC: 414.2355104,
      SC: 332.5652767,
      ST: 146.8990752,
      EWS: 335.7402221,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 551.4080579,
      OBC: 421.0558448,
      SC: 383.5644155,
      ST: 236.1143599,
      EWS: 310.5276539,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (English + Mathematics)",
    cutoffs: {
      UR: 608.0785489,
      OBC: 447.8094968,
      SC: 354.9579633,
      ST: null,
      EWS: 370.1292217,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Economics + Music)",
    cutoffs: {
      UR: 609.7728656,
      OBC: 425.5749964,
      SC: 361.7389932,
      ST: 173.4297351,
      EWS: 330.4863433,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Economics + Philosophy)",
    cutoffs: {
      UR: 621.7920097,
      OBC: 430.2458731,
      SC: 345.3276592,
      ST: 170.4503541,
      EWS: 407.6088852,
      PwBD: null,
    },
  },
  {
    collegeName: "Janki Devi Memorial College (W)",
    programName: "B.A Program (Music + Philosophy)",
    cutoffs: {
      UR: 600.5783296,
      OBC: 390.1029174,
      SC: 315.84933,
      ST: 278.1377618,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 768.0631558,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 462.6873995,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 819.7963245,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 610.7369789,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 346.8613035,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 776.3296785,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 315.2067645,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 835.8885378,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 555.7927136,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 898.8038013,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 619.5570742,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 764.1235398,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 828.2130163,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 848.563444,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 283.3839799,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 661.8419492,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "Bachelor of Elementary Education",
    cutoffs: {
      UR: 673.7876742,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 489.2927,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.Voc. Retail Management and IT",
    cutoffs: {
      UR: 662.4604608,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.Voc. Health Care Management",
    cutoffs: {
      UR: 653.9414746,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (English + French)",
    cutoffs: {
      UR: 626.7319616,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 740.9459065,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (French + Philosophy)",
    cutoffs: {
      UR: 511.7053172,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (Spanish + History)",
    cutoffs: {
      UR: 496.4035161,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName:
      "B.A Program (Spanish + Advertising, Sales Promotion and Sales Management (ASPSM))",
    cutoffs: {
      UR: 490.9581762,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 672.7991461,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 778.6875671,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 770.3287841,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 677.0388596,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (Philosophy + Psychology)",
    cutoffs: {
      UR: 802.4318538,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (Psychology + Sociology)",
    cutoffs: {
      UR: 838.9097008,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 463.4622565,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (Political Science + Sociology)",
    cutoffs: {
      UR: 755.8053612,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 376.5886344,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName:
      "B.A Program (Advertising, Sales Promotion and Sales Management (ASPSM) + Economics)",
    cutoffs: {
      UR: 760.4924548,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 634.61916,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 743.1448611,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (Economics + Human Resource Management (HRM))",
    cutoffs: {
      UR: 759.081941,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (English + Sociology)",
    cutoffs: {
      UR: 721.9811768,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 474.4823681,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (English + Philosophy)",
    cutoffs: {
      UR: 720.6104141,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Jesus & Mary College (W)",
    programName: "B.A Program (Human Resource Management (HRM) + Psychology)",
    cutoffs: {
      UR: 822.2188147,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 390.4815079,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 476.0210179,
      OBC: 436.1281957,
      SC: 357.5762017,
      ST: 265.2277032,
      EWS: 433.4539385,
      PwBD: 218.6084886,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 497.6667703,
      OBC: 467.3470829,
      SC: 392.9413749,
      ST: 343.8113747,
      EWS: 445.8782038,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 701.0997279,
      OBC: 526.8667653,
      SC: 411.761884,
      ST: 249.9860573,
      EWS: 571.0085121,
      PwBD: 372.5269216,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 737.9049712,
      OBC: 615.5012849,
      SC: 516.9103777,
      ST: 401.841361,
      EWS: 633.9569116,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 669.081375,
      OBC: 385.9200449,
      SC: 187.8496057,
      ST: null,
      EWS: 401.1064879,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 655.4886262,
      OBC: 501.7663098,
      SC: 451.8738187,
      ST: 245.6722659,
      EWS: 468.987615,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 225.0710535,
      OBC: 208.3716052,
      SC: 117.1405606,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 630.6272781,
      OBC: 496.6272784,
      SC: 444.5039969,
      ST: 361.5895332,
      EWS: 302.4873264,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A. (Hons.) Journalism",
    cutoffs: {
      UR: 666.544659,
      OBC: 528.583998,
      SC: 459.1277908,
      ST: 247.2582586,
      EWS: 520.0912515,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 661.6305754,
      OBC: 552.8286616,
      SC: 470.2557604,
      ST: 399.9568441,
      EWS: 436.3435243,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 217.5779373,
      OBC: 136.3049432,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 447.2463332,
      OBC: 412.7670811,
      SC: 333.584871,
      ST: 221.8634296,
      EWS: 412.507698,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 287.2475242,
      OBC: 174.5742881,
      SC: 48.6940433,
      ST: null,
      EWS: 104.812571,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 574.1100491,
      OBC: 473.0437687,
      SC: 400.3105992,
      ST: 245.2912705,
      EWS: 515.7382868,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 545.7564212,
      OBC: 402.4822951,
      SC: 296.1480324,
      ST: null,
      EWS: 419.3179863,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 326.6910387,
      OBC: 173.9894017,
      SC: 79.4003569,
      ST: 89.1217739,
      EWS: 160.2835181,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 669.7863246,
      OBC: 581.4526892,
      SC: 473.6977667,
      ST: 499.1720246,
      EWS: 465.8949386,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 339.3692722,
      OBC: 258.3749439,
      SC: 170.8354114,
      ST: 80.6260316,
      EWS: 194.1070259,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Sanskrit + Buddhist Studies)",
    cutoffs: {
      UR: 257.6286467,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 144.8832329,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Sanskrit + Music)",
    cutoffs: {
      UR: 467.645768,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 257.2540228,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Buddhist Studies + Music)",
    cutoffs: {
      UR: 522.525657,
      OBC: 388.4508242,
      SC: 396.923516,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Buddhist Studies + History)",
    cutoffs: {
      UR: 606.0256593,
      OBC: 429.549816,
      SC: 477.9282635,
      ST: null,
      EWS: 342.7971755,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Buddhist Studies + Political Science)",
    cutoffs: {
      UR: 571.8641379,
      OBC: 386.4173862,
      SC: 359.9571288,
      ST: 364.08056,
      EWS: 307.7311675,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 642.4064853,
      OBC: 431.0221827,
      SC: 264.4378369,
      ST: null,
      EWS: 435.6441155,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName:
      "B.A Program (Computer Applications + Entrepreneurship and Small Business (ESB))",
    cutoffs: {
      UR: 590.1428757,
      OBC: 456.06335,
      SC: 362.6902331,
      ST: 326.0766293,
      EWS: 367.7063656,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Computer Applications + Geography)",
    cutoffs: {
      UR: 533.9870513,
      OBC: 374.5515221,
      SC: 313.8980013,
      ST: 361.0488079,
      EWS: 519.8077985,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 608.5212042,
      OBC: 432.4548549,
      SC: 314.7577515,
      ST: null,
      EWS: 461.8049479,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName:
      "B.A Program (Economics + Entrepreneurship and Small Business (ESB))",
    cutoffs: {
      UR: 655.6836204,
      OBC: 491.6708493,
      SC: 460.5245858,
      ST: 281.6653588,
      EWS: 561.3846384,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Economics + Geography)",
    cutoffs: {
      UR: 615.7798367,
      OBC: 490.7552088,
      SC: 390.2497123,
      ST: 479.1320655,
      EWS: 402.6917681,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 619.2074826,
      OBC: 447.101516,
      SC: 383.4893559,
      ST: 279.2984492,
      EWS: 255.1166299,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 661.4004827,
      OBC: 424.4142553,
      SC: 268.2924948,
      ST: null,
      EWS: 369.9611156,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 618.7584816,
      OBC: 481.0519708,
      SC: 395.8386139,
      ST: 383.659306,
      EWS: 400.7295476,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName:
      "B.A Program (Entrepreneurship and Small Business (ESB) + History)",
    cutoffs: {
      UR: 600.8423646,
      OBC: 404.5292668,
      SC: 331.8210841,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName:
      "B.A Program (Entrepreneurship and Small Business (ESB) + Geography)",
    cutoffs: {
      UR: 600.9550976,
      OBC: 456.784351,
      SC: 340.0124067,
      ST: null,
      EWS: 410.417848,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName:
      "B.A Program (Entrepreneurship and Small Business (ESB) + Mathematics)",
    cutoffs: {
      UR: 600.2672955,
      OBC: 368.5808464,
      SC: 236.3399915,
      ST: null,
      EWS: 290.7417875,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName:
      "B.A Program (Entrepreneurship and Small Business (ESB) + Political Science)",
    cutoffs: {
      UR: 618.6800019,
      OBC: 468.5689415,
      SC: 346.9093729,
      ST: 279.2408861,
      EWS: 367.7148895,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Geography + History)",
    cutoffs: {
      UR: 688.5215459,
      OBC: 577.8119068,
      SC: 450.9817561,
      ST: 535.8865591,
      EWS: 496.8870701,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Geography + Mathematics)",
    cutoffs: {
      UR: 570.3908534,
      OBC: 420.4183556,
      SC: 414.7844927,
      ST: 200.7372803,
      EWS: 306.8081505,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Geography + Political Science)",
    cutoffs: {
      UR: 673.2499063,
      OBC: 572.0871819,
      SC: 456.4661361,
      ST: 404.1418435,
      EWS: 547.854135,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (History + Music)",
    cutoffs: {
      UR: 532.8262842,
      OBC: 315.4337453,
      SC: 214.7330688,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 653.1066347,
      OBC: 551.3566031,
      SC: 444.5196837,
      ST: 541.8879419,
      EWS: 347.5416821,
      PwBD: null,
    },
  },
  {
    collegeName: "Kalindi College (W)",
    programName: "B.A Program (Music + Political Science)",
    cutoffs: {
      UR: 528.1840697,
      OBC: 205.4516765,
      SC: 291.4393152,
      ST: 332.0243026,
      EWS: 230.0367067,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 782.9746302,
      OBC: 655.2902367,
      SC: 536.575498,
      ST: 172.1771997,
      EWS: 699.4575271,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 816.1750496,
      OBC: 713.5833132,
      SC: 612.3171174,
      ST: 515.4750637,
      EWS: 748.8435073,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) Journalism",
    cutoffs: {
      UR: 754.3986857,
      OBC: 604.5256957,
      SC: 521.9988774,
      ST: 504.0213467,
      EWS: 614.7838118,
      PwBD: 346.3082122,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 742.6776103,
      OBC: 614.4547005,
      SC: 546.0520737,
      ST: 540.725861,
      EWS: 626.9465871,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 256.0316416,
      OBC: 227.1658396,
      SC: 165.4157732,
      ST: 251.868319,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 745.8455318,
      OBC: 646.1305908,
      SC: 570.2341651,
      ST: 574.1477803,
      EWS: 650.4731591,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 761.9537329,
      OBC: 507.812558,
      SC: 374.562106,
      ST: null,
      EWS: 563.1501422,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 767.2533565,
      OBC: 694.7196381,
      SC: 602.0208394,
      ST: 593.1197224,
      EWS: 677.2556728,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 680.4510408,
      OBC: 480.393856,
      SC: 401.2525409,
      ST: 336.2512381,
      EWS: 452.0901235,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 859.2026533,
      OBC: 718.5964322,
      SC: 701.6253422,
      ST: 517.8221003,
      EWS: 702.4702543,
      PwBD: 491.5890578,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 754.1079689,
      OBC: 665.6786458,
      SC: 566.6684555,
      ST: 587.0589363,
      EWS: 652.3222825,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 595.6612988,
      OBC: 451.4426596,
      SC: 327.0215179,
      ST: 185.2031764,
      EWS: 456.1543153,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 216.6223095,
      OBC: 172.5844575,
      SC: 196.4105325,
      ST: null,
      EWS: 157.3390156,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 728.3682973,
      OBC: 598.7036389,
      SC: 529.2221595,
      ST: 534.5238159,
      EWS: 577.7301381,
      PwBD: 220.5381471,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName:
      "B.A Program (English + Advertising, Sales Promotion and Sales Management (ASPSM))",
    cutoffs: {
      UR: 704.703754,
      OBC: 559.9374003,
      SC: 488.61126,
      ST: 404.70621,
      EWS: 546.5975633,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (English + Psychology)",
    cutoffs: {
      UR: 798.0790216,
      OBC: 648.7223973,
      SC: 624.6395068,
      ST: 633.2649504,
      EWS: 634.9464315,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (Hindi + Sanskrit)",
    cutoffs: {
      UR: 454.0312795,
      OBC: 274.0500084,
      SC: 221.5549016,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (Sanskrit + Physical Education)",
    cutoffs: {
      UR: 289.8423189,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName:
      "B.A Program (Advertising, Sales Promotion and Sales Management (ASPSM) + Economics)",
    cutoffs: {
      UR: 742.793356,
      OBC: 610.3250416,
      SC: 507.8171998,
      ST: 421.3571918,
      EWS: 532.1170771,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 744.9178685,
      OBC: 556.9531323,
      SC: 328.9926399,
      ST: null,
      EWS: 497.1722686,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (Economics + Sociology)",
    cutoffs: {
      UR: 747.5734755,
      OBC: 598.7579357,
      SC: 526.0733617,
      ST: 586.59117,
      EWS: 536.91216,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (Geography + History)",
    cutoffs: {
      UR: 731.8199164,
      OBC: 634.9211556,
      SC: 548.7077347,
      ST: null,
      EWS: 631.92131,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (Geography + Political Science)",
    cutoffs: {
      UR: 747.4968782,
      OBC: 665.7625689,
      SC: 560.9764607,
      ST: 610.4215552,
      EWS: 636.5446423,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (History + Physical Education)",
    cutoffs: {
      UR: 690.7360679,
      OBC: 556.783281,
      SC: 458.9944817,
      ST: null,
      EWS: 529.9515593,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 760.2238393,
      OBC: 639.8492144,
      SC: 575.7720507,
      ST: 557.358826,
      EWS: 685.7389805,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName:
      "B.A Program (Human Resource Management (HRM) + Physical Education)",
    cutoffs: {
      UR: 644.0077957,
      OBC: 485.8077325,
      SC: 416.6258178,
      ST: 347.8999024,
      EWS: 476.7667189,
      PwBD: 202.802911,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (Mathematics + Philosophy)",
    cutoffs: {
      UR: 632.2067742,
      OBC: 364.3001081,
      SC: 311.5765173,
      ST: null,
      EWS: 339.929235,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (Philosophy + Sociology)",
    cutoffs: {
      UR: 691.2140854,
      OBC: 553.9417712,
      SC: 524.6426287,
      ST: 446.6158699,
      EWS: 521.5493035,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (Psychology + Sociology)",
    cutoffs: {
      UR: 831.4543697,
      OBC: 694.5681341,
      SC: 623.0544008,
      ST: 567.6104503,
      EWS: 606.7337975,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName:
      "B.A Program (Advertising, Sales Promotion and Sales Management (ASPSM) + Psychology)",
    cutoffs: {
      UR: 783.885553,
      OBC: 616.9815106,
      SC: 582.5578843,
      ST: 417.4526161,
      EWS: 596.7588768,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName: "B.A Program (Human Resource Management (HRM) + English)",
    cutoffs: {
      UR: 743.7540354,
      OBC: 628.364436,
      SC: 494.8854527,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName:
      "B.A Program (Entrepreneurship and Small Business (ESB) + Political Science)",
    cutoffs: {
      UR: 690.4847851,
      OBC: 567.7336281,
      SC: 526.0331745,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kamala Nehru College (W)",
    programName:
      "B.A Program (Hindi + Entrepreneurship and Small Business (ESB))",
    cutoffs: {
      UR: 582.5727652,
      OBC: 422.0034211,
      SC: 415.5738817,
      ST: 411.8586679,
      EWS: 389.2684826,
      PwBD: null,
    },
  },
  {
    collegeName: "Keshav Mahavidyalaya",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 814.2108992,
      OBC: 636.8722863,
      SC: 617.1863972,
      ST: 562.6239281,
      EWS: 643.1622724,
      PwBD: 423.88332,
    },
  },
  {
    collegeName: "Keshav Mahavidyalaya",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 779.2016802,
      OBC: 627.9464321,
      SC: 528.1170817,
      ST: 194.5159612,
      EWS: 667.9765447,
      PwBD: 350.6247402,
    },
  },
  {
    collegeName: "Keshav Mahavidyalaya",
    programName: "B.Sc. (Prog.) Mathematical Sciences",
    cutoffs: {
      UR: 504.6426023,
      OBC: 358.7562659,
      SC: 247.2086161,
      ST: null,
      EWS: 354.0290758,
      PwBD: null,
    },
  },
  {
    collegeName: "Keshav Mahavidyalaya",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 625.64448,
      OBC: 508.6721144,
      SC: 414.698525,
      ST: 232.3289254,
      EWS: 531.4211536,
      PwBD: 276.5261861,
    },
  },
  {
    collegeName: "Keshav Mahavidyalaya",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 320.2561553,
      OBC: 228.8951454,
      SC: 153.7459555,
      ST: null,
      EWS: 242.6352079,
      PwBD: null,
    },
  },
  {
    collegeName: "Keshav Mahavidyalaya",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 572.4157365,
      OBC: 423.2784762,
      SC: 315.9802323,
      ST: 112.8556607,
      EWS: 434.3580786,
      PwBD: null,
    },
  },
  {
    collegeName: "Keshav Mahavidyalaya",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 317.8606508,
      OBC: 260.6563208,
      SC: 126.9053825,
      ST: 78.8743709,
      EWS: 274.7206824,
      PwBD: null,
    },
  },
  {
    collegeName: "Keshav Mahavidyalaya",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 307.1003208,
      OBC: 224.1159927,
      SC: 159.6384782,
      ST: 55.9174886,
      EWS: 226.9599931,
      PwBD: null,
    },
  },
  {
    collegeName: "Keshav Mahavidyalaya",
    programName: "Bachelor of Management Studies",
    cutoffs: {
      UR: 513.6978443,
      OBC: 394.3036563,
      SC: 337.4815787,
      ST: 162.6492677,
      EWS: 438.7939413,
      PwBD: 228.0023557,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 850.1627,
      OBC: 690.681937,
      SC: 627.3429228,
      ST: 455.6472178,
      EWS: 755.7434858,
      PwBD: 303.6639235,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 828.2753898,
      OBC: 746.969393,
      SC: 694.2663231,
      ST: 705.2569709,
      EWS: 763.7420747,
      PwBD: 532.3518737,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 835.0116034,
      OBC: 826.7353671,
      SC: 764.0036176,
      ST: 766.0509759,
      EWS: 829.2974915,
      PwBD: 590.8121175,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 596.8537708,
      OBC: 487.912565,
      SC: 478.7241582,
      ST: 251.327591,
      EWS: 418.2267557,
      PwBD: 257.7239909,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 854.4787142,
      OBC: 808.2797608,
      SC: 764.6388207,
      ST: 753.5584115,
      EWS: 830.8191222,
      PwBD: 602.0970849,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 909.6912046,
      OBC: 866.7369089,
      SC: 813.4213553,
      ST: 836.6003725,
      EWS: 885.7829131,
      PwBD: 772.9597647,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 201.7524896,
      OBC: 422.0364015,
      SC: 354.2251154,
      ST: null,
      EWS: 395.3726583,
      PwBD: null,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A. (Hons.) Urdu",
    cutoffs: {
      UR: 447.5625939,
      OBC: 249.0757633,
      SC: 190.3484757,
      ST: 325.909162,
      EWS: 111.4814829,
      PwBD: null,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 897.172925,
      OBC: 821.540641,
      SC: 758.3565288,
      ST: 701.372486,
      EWS: 856.3629119,
      PwBD: 638.6319091,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.Com.",
    cutoffs: {
      UR: 883.9989287,
      OBC: 807.9333422,
      SC: 739.7954554,
      ST: 574.1587095,
      EWS: 842.4723475,
      PwBD: 618.6246814,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName:
      "B.Sc Applied Physical Sciences with Analytical Methods in Chemistry & Biochemistry",
    cutoffs: {
      UR: 350.0054757,
      OBC: 236.9033427,
      SC: 215.3725241,
      ST: 105.7871124,
      EWS: 318.2478556,
      PwBD: null,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 602.7911421,
      OBC: 487.136659,
      SC: 468.6303139,
      ST: 447.42641,
      EWS: 468.6132743,
      PwBD: 145.0972028,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 410.1408823,
      OBC: 387.4590189,
      SC: 285.8563066,
      ST: 131.9985338,
      EWS: 402.3800783,
      PwBD: 261.1797814,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 618.0851013,
      OBC: 554.674325,
      SC: 477.0582631,
      ST: 431.1756182,
      EWS: 579.3140365,
      PwBD: 271.4044667,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 764.014438,
      OBC: 626.8244564,
      SC: 446.5820301,
      ST: 419.6873198,
      EWS: 610.4453895,
      PwBD: 237.5113906,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 400.9197948,
      OBC: 387.8731187,
      SC: 287.3320717,
      ST: 171.4158272,
      EWS: 412.9070457,
      PwBD: null,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 354.6383127,
      OBC: 304.7136925,
      SC: 234.4809584,
      ST: 98.2891823,
      EWS: 275.1580304,
      PwBD: null,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 438.0470701,
      OBC: 372.5448478,
      SC: 302.8289753,
      ST: 66.4979937,
      EWS: 422.6019492,
      PwBD: null,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.Sc. (Hons.) Statistics",
    cutoffs: {
      UR: 822.758946,
      OBC: 647.5288157,
      SC: 567.839982,
      ST: 423.2364734,
      EWS: 683.0619917,
      PwBD: 449.6300967,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 634.9975552,
      OBC: 597.7840866,
      SC: 422.1754192,
      ST: 443.9048831,
      EWS: 597.2879902,
      PwBD: 310.44352,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A Program (Bengali + History)",
    cutoffs: {
      UR: 611.6019233,
      OBC: 522.3303377,
      SC: null,
      ST: null,
      EWS: 327.9037256,
      PwBD: null,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A Program (Bengali + Political Science)",
    cutoffs: {
      UR: 628.3628036,
      OBC: 414.9204766,
      SC: 445.4208505,
      ST: null,
      EWS: 418.0410039,
      PwBD: null,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 858.5119362,
      OBC: 814.2580745,
      SC: 746.3270132,
      ST: 741.4164705,
      EWS: 805.0117468,
      PwBD: 678.6645204,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 829.1273528,
      OBC: 788.1967005,
      SC: 716.5235955,
      ST: 688.4357378,
      EWS: 792.6170491,
      PwBD: 750.6672271,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 841.9248996,
      OBC: 809.8309519,
      SC: 700.4160845,
      ST: 696.2326639,
      EWS: 792.1060759,
      PwBD: 530.8838762,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A Program (Economics + Philosophy)",
    cutoffs: {
      UR: 840.4083021,
      OBC: 769.5889917,
      SC: 686.3266351,
      ST: 644.0916386,
      EWS: 807.7269077,
      PwBD: null,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 859.1345613,
      OBC: 815.8726841,
      SC: 717.6594197,
      ST: 780.0013995,
      EWS: 828.7284299,
      PwBD: 585.9128637,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A Program (History + Philosophy)",
    cutoffs: {
      UR: 823.0148092,
      OBC: 764.3082281,
      SC: 699.0939047,
      ST: 711.9791822,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 873.3054168,
      OBC: 843.0097557,
      SC: 784.5884089,
      ST: 759.7392879,
      EWS: 827.5133107,
      PwBD: 714.2811992,
    },
  },
  {
    collegeName: "Kirori Mal College",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 845.2145218,
      OBC: 793.3414574,
      SC: 712.5897903,
      ST: 668.5192374,
      EWS: 780.6096798,
      PwBD: null,
    },
  },
  {
    collegeName: "Lady Irwin College (W)",
    programName: "B.Sc. (Hons.) Home Science",
    cutoffs: {
      UR: 433.2669128,
      OBC: 320.7881225,
      SC: 282.0594366,
      ST: 138.654685,
      EWS: 239.7470425,
      PwBD: null,
    },
  },
  {
    collegeName: "Lady Irwin College (W)",
    programName: "B.Sc. (Pass) Home Science",
    cutoffs: {
      UR: 564.4713658,
      OBC: 376.1615327,
      SC: 346.5498148,
      ST: 273.6536733,
      EWS: 141.9708834,
      PwBD: 198.2277028,
    },
  },
  {
    collegeName: "Lady Irwin College (W)",
    programName: "B.Sc. (Hons.) Food Technology",
    cutoffs: {
      UR: 494.3969203,
      OBC: 469.7429776,
      SC: 422.0408064,
      ST: 333.7804691,
      EWS: 479.1026413,
      PwBD: 257.5382386,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 906.3746135,
      OBC: 831.8215429,
      SC: 764.7982713,
      ST: 707.2917934,
      EWS: 861.820126,
      PwBD: 700.8910061,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 874.3926414,
      OBC: 712.5309611,
      SC: 630.8834578,
      ST: 511.1780155,
      EWS: 760.096247,
      PwBD: 476.5295448,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 856.1854756,
      OBC: 726.9543252,
      SC: 677.5402623,
      ST: 679.2065544,
      EWS: 761.4324969,
      PwBD: 398.3413401,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 579.0456149,
      OBC: 434.7411433,
      SC: 375.755668,
      ST: 302.3337394,
      EWS: 221.9794582,
      PwBD: null,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 867.7909162,
      OBC: 809.2445568,
      SC: 725.024946,
      ST: 737.9884378,
      EWS: 801.3765946,
      PwBD: 376.6712785,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 793.7797114,
      OBC: 670.1572597,
      SC: 609.4742008,
      ST: 566.9583519,
      EWS: 701.6372673,
      PwBD: null,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 915.6986996,
      OBC: 859.2672231,
      SC: 691.0684571,
      ST: 807.7921246,
      EWS: 849.936739,
      PwBD: 685.8123349,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 926.5327051,
      OBC: 833.8149032,
      SC: 831.5066224,
      ST: 780.9786063,
      EWS: 855.093609,
      PwBD: 751.8150671,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 281.4332555,
      OBC: 159.0868533,
      SC: 167.5967823,
      ST: null,
      EWS: 174.9673288,
      PwBD: null,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 849.9606965,
      OBC: 758.2544502,
      SC: 667.39451,
      ST: 671.8835169,
      EWS: 737.7393958,
      PwBD: 316.4240832,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A. (Hons.) Journalism",
    cutoffs: {
      UR: 876.7870859,
      OBC: 751.4419778,
      SC: 719.198113,
      ST: 650.0500349,
      EWS: 772.7958119,
      PwBD: 759.0818286,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 779.2426215,
      OBC: 578.4887137,
      SC: 423.5907786,
      ST: 407.9939089,
      EWS: null,
      PwBD: 145.0112849,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.Sc. (Hons.) Statistics",
    cutoffs: {
      UR: 827.7201297,
      OBC: 660.1020282,
      SC: 569.4165968,
      ST: 370.7683774,
      EWS: 674.2398276,
      PwBD: 191.9676165,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "Bachelor of Elementary Education",
    cutoffs: {
      UR: 733.3989375,
      OBC: 622.1554651,
      SC: 618.3939779,
      ST: 535.4386315,
      EWS: 605.0991722,
      PwBD: 490.445157,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 863.6424903,
      OBC: 678.5754916,
      SC: 631.8727534,
      ST: 293.0796049,
      EWS: 800.4055355,
      PwBD: null,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 830.4532401,
      OBC: 654.1827989,
      SC: 631.6452848,
      ST: 437.8691095,
      EWS: 724.2118535,
      PwBD: null,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 883.1680879,
      OBC: 710.0779104,
      SC: 732.3123991,
      ST: 842.8952307,
      EWS: 798.8130609,
      PwBD: null,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 890.335407,
      OBC: 745.9040466,
      SC: 628.7050973,
      ST: 575.2927839,
      EWS: 844.1469815,
      PwBD: null,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 897.1965581,
      OBC: 826.0074599,
      SC: 790.6565364,
      ST: 676.1894029,
      EWS: 840.4611824,
      PwBD: 742.0555955,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 888.2542763,
      OBC: 852.4819448,
      SC: 788.9985801,
      ST: 731.2676715,
      EWS: 813.2975757,
      PwBD: 729.5965495,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A Program (History + Sociology)",
    cutoffs: {
      UR: 846.7561765,
      OBC: 777.6404036,
      SC: 669.9931345,
      ST: 692.9588959,
      EWS: 761.8607713,
      PwBD: 660.2885188,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A Program (Political Science + Psychology)",
    cutoffs: {
      UR: 886.1884534,
      OBC: 819.2464156,
      SC: 754.46756,
      ST: 700.3393726,
      EWS: 872.2055519,
      PwBD: null,
    },
  },
  {
    collegeName: "Lady Shri Ram College for Women (W)",
    programName: "B.A Program (Psychology + Sociology)",
    cutoffs: {
      UR: 874.8219718,
      OBC: 744.4259866,
      SC: 740.6058751,
      ST: 732.2907078,
      EWS: 852.7596279,
      PwBD: 625.7066883,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 677.5659529,
      OBC: 383.1322142,
      SC: 190.2417492,
      ST: 278.0750763,
      EWS: 389.7343808,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 649.713649,
      OBC: 484.929813,
      SC: 474.3446819,
      ST: 245.5056069,
      EWS: 462.5248015,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 227.2559501,
      OBC: 181.1120932,
      SC: 189.9123698,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 628.4677885,
      OBC: 484.1501254,
      SC: 427.5746185,
      ST: 352.272836,
      EWS: 272.2910809,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 509.4875829,
      OBC: 379.6000534,
      SC: 252.1959422,
      ST: 95.3112752,
      EWS: 431.6096997,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 572.6795888,
      OBC: 388.2768323,
      SC: 344.8832905,
      ST: 208.9482081,
      EWS: 312.0388673,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 668.85255,
      OBC: 536.0051022,
      SC: 504.3303434,
      ST: 315.3805706,
      EWS: 155.6244717,
      PwBD: 465.9317763,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 178.4411777,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 702.7311102,
      OBC: 522.4337072,
      SC: 402.6665256,
      ST: 400.6614127,
      EWS: 582.5130647,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A. (Hons.) Business Economics",
    cutoffs: {
      UR: 409.0119856,
      OBC: 263.4952631,
      SC: 182.2538299,
      ST: null,
      EWS: 280.6212797,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 751.8710412,
      OBC: 594.0735655,
      SC: 506.7781174,
      ST: 185.6312484,
      EWS: 624.1512687,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 643.9949032,
      OBC: 461.3880187,
      SC: 416.2165367,
      ST: 356.8351929,
      EWS: 473.6037173,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 515.5862203,
      OBC: 370.274047,
      SC: 362.2986722,
      ST: 206.9810573,
      EWS: 205.0569511,
      PwBD: 236.7413727,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (Punjabi + Political Science)",
    cutoffs: {
      UR: 181.6094679,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName:
      "B.A Program (Advertising, Sales Promotion and Sales Management (ASPSM) + Economics)",
    cutoffs: {
      UR: 648.9659275,
      OBC: 455.2965202,
      SC: 376.7395772,
      ST: 271.9252559,
      EWS: 444.973095,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (Food Technology (FT) + Political Science)",
    cutoffs: {
      UR: 548.8976837,
      OBC: 384.178283,
      SC: 335.8686072,
      ST: 364.0227135,
      EWS: 447.6310203,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (History + Music)",
    cutoffs: {
      UR: 460.4560914,
      OBC: 237.5966043,
      SC: 219.7270921,
      ST: 285.3604817,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 593.6743216,
      OBC: 445.1454643,
      SC: 408.509757,
      ST: 130.5351123,
      EWS: 336.2833711,
      PwBD: 177.4539307,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 562.8587996,
      OBC: 378.8887511,
      SC: 327.1318743,
      ST: 203.5984811,
      EWS: 192.4039903,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (Philosophy + Sociology)",
    cutoffs: {
      UR: 579.7210188,
      OBC: 418.0014625,
      SC: 351.8418388,
      ST: 152.70686,
      EWS: 251.3357821,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 609.3623214,
      OBC: 352.4015024,
      SC: 188.0772232,
      ST: null,
      EWS: 373.0196139,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName:
      "B.A Program (Advertising, Sales Promotion and Sales Management (ASPSM) + Psychology)",
    cutoffs: {
      UR: 720.043824,
      OBC: 524.4736093,
      SC: 449.2832761,
      ST: 422.6994745,
      EWS: 540.1406421,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (Physical Education + Psychology)",
    cutoffs: {
      UR: 680.06074,
      OBC: 497.2485435,
      SC: 483.3295848,
      ST: 418.3322933,
      EWS: 491.7813715,
      PwBD: 602.8550381,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 627.9622954,
      OBC: 465.7189893,
      SC: 397.1053099,
      ST: 400.700627,
      EWS: 221.4564931,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 789.5718524,
      OBC: 607.7721041,
      SC: 584.0724964,
      ST: 512.5667411,
      EWS: 557.1809896,
      PwBD: 377.2139854,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.Sc. (Hons.) Home Science",
    cutoffs: {
      UR: 398.6014194,
      OBC: 249.5281295,
      SC: 251.4922705,
      ST: 208.2895648,
      EWS: 230.642151,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 566.3204449,
      OBC: 392.4478179,
      SC: 140.0069493,
      ST: null,
      EWS: 426.8648585,
      PwBD: null,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (Apparel Design & Construction + Philosophy)",
    cutoffs: {
      UR: 585.2576391,
      OBC: 398.4014345,
      SC: 382.6752471,
      ST: 328.3497139,
      EWS: 204.908,
      PwBD: 377.7307035,
    },
  },
  {
    collegeName: "Lakshmibai College (W)",
    programName: "B.A Program (Sanskrit + Sociology)",
    cutoffs: {
      UR: 182.9795807,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 677.5551857,
      OBC: 533.488078,
      SC: 483.0462644,
      ST: 438.2593389,
      EWS: 506.0722127,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 356.3156821,
      OBC: 116.6342515,
      SC: 170.7520443,
      ST: 276.7648266,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A. (Hons.) Journalism",
    cutoffs: {
      UR: 689.6364531,
      OBC: 577.6671787,
      SC: 526.8877861,
      ST: 388.3127308,
      EWS: 602.968202,
      PwBD: 313.0296162,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 715.976257,
      OBC: 606.394635,
      SC: 554.1911823,
      ST: 509.1756053,
      EWS: 599.4461796,
      PwBD: 284.8822996,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 767.6616941,
      OBC: 622.6638773,
      SC: 532.9158958,
      ST: 265.5405687,
      EWS: 664.1756867,
      PwBD: 246.575924,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.Sc. (Prog.) Mathematical Sciences",
    cutoffs: {
      UR: 500.246912,
      OBC: 357.6764284,
      SC: 212.6396489,
      ST: null,
      EWS: 291.8552935,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 309.9787388,
      OBC: 231.6273379,
      SC: 152.1902583,
      ST: 55.7471612,
      EWS: 204.1066446,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 334.7713626,
      OBC: 241.9025757,
      SC: 156.3980008,
      ST: 146.5942589,
      EWS: 238.6687471,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 282.630105,
      OBC: 224.6573489,
      SC: 85.1502304,
      ST: 88.0120306,
      EWS: 176.9823245,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A. (Hons.) Business Economics",
    cutoffs: {
      UR: 436.4559812,
      OBC: 293.4417977,
      SC: 222.1615247,
      ST: 214.1373487,
      EWS: 311.0383738,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 700.6718619,
      OBC: 589.5147461,
      SC: 535.4739574,
      ST: 541.0631092,
      EWS: 535.4898233,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 661.9265176,
      OBC: 560.7480767,
      SC: 540.3797099,
      ST: 512.4184125,
      EWS: 514.3936231,
      PwBD: 238.7665927,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (English + Mathematics)",
    cutoffs: {
      UR: 644.90542,
      OBC: 486.4161066,
      SC: 396.5361655,
      ST: 222.1425519,
      EWS: 562.1169899,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (Hindi + Economics)",
    cutoffs: {
      UR: 586.2268863,
      OBC: 460.905663,
      SC: 418.1820227,
      ST: 213.8408932,
      EWS: 382.276041,
      PwBD: 470.6643359,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 561.7347091,
      OBC: 450.1943872,
      SC: 397.8475033,
      ST: 260.2986336,
      EWS: 478.6436214,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (Hindi + Mathematics)",
    cutoffs: {
      UR: 523.6478208,
      OBC: 294.0759611,
      SC: 321.860978,
      ST: null,
      EWS: 266.9110589,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 572.8083992,
      OBC: 458.0444765,
      SC: 500.732233,
      ST: 244.1821207,
      EWS: 424.3772552,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (Economics + OMSP)",
    cutoffs: {
      UR: 663.1310964,
      OBC: 476.9723633,
      SC: 421.3011932,
      ST: 202.4911088,
      EWS: 467.3636041,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (History + OMSP)",
    cutoffs: {
      UR: 589.9563788,
      OBC: 438.2264151,
      SC: 414.4845367,
      ST: 301.3071361,
      EWS: 457.6694457,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (Mathematics + OMSP)",
    cutoffs: {
      UR: 605.3945298,
      OBC: 379.6073592,
      SC: 284.646814,
      ST: null,
      EWS: 327.8985697,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName:
      "B.A Program (Office Management & Secretarial Practice (OMSP) + Political Science)",
    cutoffs: {
      UR: 616.3882621,
      OBC: 519.7520039,
      SC: 419.3996123,
      ST: 250.4910407,
      EWS: 433.4299396,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 691.0075473,
      OBC: 617.8146137,
      SC: 578.1024871,
      ST: 492.4376928,
      EWS: 524.4445543,
      PwBD: 256.507447,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 650.7775985,
      OBC: 510.0342683,
      SC: 433.7941482,
      ST: 401.1614859,
      EWS: 500.3219888,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (Computer Applications + History)",
    cutoffs: {
      UR: 588.6759625,
      OBC: 473.3027239,
      SC: 359.5735259,
      ST: 251.3534705,
      EWS: 390.7766302,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 671.9132248,
      OBC: 488.404574,
      SC: 472.8092056,
      ST: 246.8779441,
      EWS: 479.2038775,
      PwBD: null,
    },
  },
  {
    collegeName: "Maharaja Agrasen College",
    programName: "B.A Program (Computer Applications + Political Science)",
    cutoffs: {
      UR: 605.2780929,
      OBC: 470.8996461,
      SC: 385.8311964,
      ST: 341.3995883,
      EWS: 456.0837504,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 767.1977965,
      OBC: 535.4201209,
      SC: 412.0862745,
      ST: null,
      EWS: 579.4586335,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 747.4855387,
      OBC: 621.1514167,
      SC: 569.2865214,
      ST: 565.3737204,
      EWS: 599.6080924,
      PwBD: 451.7691432,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 297.699639,
      OBC: 157.6874049,
      SC: 167.0904695,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 752.4334905,
      OBC: 659.1724299,
      SC: 588.5377828,
      ST: 563.8913947,
      EWS: null,
      PwBD: 321.4116338,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 773.2530647,
      OBC: 695.8179745,
      SC: 606.6181847,
      ST: 580.0108557,
      EWS: 707.0519248,
      PwBD: 339.4504851,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 294.6982615,
      OBC: 152.7934575,
      SC: 197.8322222,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 726.5530755,
      OBC: 605.5299245,
      SC: 525.7009387,
      ST: 555.717769,
      EWS: 574.156463,
      PwBD: 395.0015372,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 787.0528769,
      OBC: 661.531363,
      SC: 553.2018097,
      ST: 355.7436529,
      EWS: 714.3653292,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 823.6443896,
      OBC: 717.6650283,
      SC: 610.4923476,
      ST: 508.2150963,
      EWS: 744.414204,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 480.4620727,
      OBC: 428.7978325,
      SC: 350.1003285,
      ST: 299.2653186,
      EWS: 446.2089705,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 339.7560535,
      OBC: 266.4239338,
      SC: 176.0427189,
      ST: null,
      EWS: 285.2405657,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 293.4120032,
      OBC: 222.1533863,
      SC: 124.4397739,
      ST: null,
      EWS: 96.0208983,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 527.309028,
      OBC: 451.8509249,
      SC: 382.3730584,
      ST: 333.2728943,
      EWS: 468.9697217,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 383.7505451,
      OBC: 311.1394578,
      SC: 205.6944015,
      ST: 87.8129909,
      EWS: 326.252873,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 624.0055184,
      OBC: 443.7929788,
      SC: 243.7759892,
      ST: 112.2853334,
      EWS: 478.5378827,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 372.9589863,
      OBC: 289.8871882,
      SC: 196.8757203,
      ST: 63.9624959,
      EWS: 323.2732855,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 558.6338655,
      OBC: 497.1033392,
      SC: 428.4058367,
      ST: 389.1948521,
      EWS: 499.4459758,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 766.3857973,
      OBC: 636.0525702,
      SC: 545.7416084,
      ST: 559.0033069,
      EWS: 659.3555408,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (English + Sociology)",
    cutoffs: {
      UR: 711.1037869,
      OBC: 590.8649322,
      SC: 517.2628461,
      ST: 543.9311899,
      EWS: 579.4121204,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 637.6534774,
      OBC: 516.1136951,
      SC: 454.3994877,
      ST: 381.7824148,
      EWS: 507.7511788,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 632.1052543,
      OBC: 503.4361244,
      SC: 469.464114,
      ST: 361.7187855,
      EWS: 474.1460103,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (Punjabi + History)",
    cutoffs: {
      UR: 336.0450487,
      OBC: 297.0971473,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (Punjabi + Political Science)",
    cutoffs: {
      UR: 446.6826731,
      OBC: 341.305728,
      SC: 149.2454755,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 490.469234,
      OBC: 288.4453732,
      SC: 91.0714891,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 461.1632151,
      OBC: 265.3628464,
      SC: 212.7259529,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 724.9631544,
      OBC: 496.6913228,
      SC: 398.2435319,
      ST: 224.8602279,
      EWS: 475.0724612,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 648.7006379,
      OBC: 464.202084,
      SC: 382.5101081,
      ST: 480.5005884,
      EWS: 502.8098264,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 749.7482625,
      OBC: 574.7650161,
      SC: 373.2218579,
      ST: 296.2708509,
      EWS: 598.3493088,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 745.0146313,
      OBC: 656.8971837,
      SC: 567.7039167,
      ST: 568.6385796,
      EWS: 685.0164069,
      PwBD: null,
    },
  },
  {
    collegeName: "Maitreyi College (W)",
    programName: "B.A Program (Political Science + Sociology)",
    cutoffs: {
      UR: 725.3270192,
      OBC: 626.9382846,
      SC: 544.5173869,
      ST: 559.1727289,
      EWS: 588.5274467,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 658.40542,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 366.0196092,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 65.3899221,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 543.4303354,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 531.5826311,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 578.0918451,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 770.6324087,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 423.88332,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A. (Hons.) Punjabi",
    cutoffs: {
      UR: 384.4566261,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 204.9171242,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 670.8665979,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 708.158293,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 436.2976227,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 524.8303592,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.Sc. (Hons.) Statistics",
    cutoffs: {
      UR: 557.5523438,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "Bachelor of Elementary Education",
    cutoffs: {
      UR: 587.9703573,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 226.6331502,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (Punjabi + Political Science)",
    cutoffs: {
      UR: 221.6479797,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 566.5260863,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 444.6976019,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 606.7476033,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 569.0352569,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (Economics + Psychology)",
    cutoffs: {
      UR: 707.0996331,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 558.8058613,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (Music + Political Science)",
    cutoffs: {
      UR: 486.3325332,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 549.077666,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (Philosophy + Psychology)",
    cutoffs: {
      UR: 740.3180273,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 356.0895112,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 553.7148904,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName:
      "B.A Program (Office Management & Secretarial Practice (OMSP) + English)",
    cutoffs: {
      UR: 572.4485815,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName:
      "B.A Program (Economics + Entrepreneurship and Small Business (ESB))",
    cutoffs: {
      UR: 639.7262249,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName:
      "B.A Program (Computer Applications + Entrepreneurship and Small Business (ESB))",
    cutoffs: {
      UR: 570.8500785,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 625.0988185,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Mata Sundri College for Women (W)",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 658.4908721,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 264.7087599,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 863.0249541,
      OBC: 765.66332,
      SC: 718.4189497,
      ST: 681.5788386,
      EWS: 781.1165183,
      PwBD: 447.316504,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 601.999483,
      OBC: 463.6138295,
      SC: 399.0132825,
      ST: 166.1149867,
      EWS: 400.4698387,
      PwBD: 203.3088761,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 850.3074641,
      OBC: 701.8419877,
      SC: 615.8663302,
      ST: 467.2380986,
      EWS: 687.9162663,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 894.636024,
      OBC: 849.2886707,
      SC: 638.8743797,
      ST: 796.6526042,
      EWS: 839.1443415,
      PwBD: 692.1138086,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 798.1590955,
      OBC: 687.8293547,
      SC: 602.2881695,
      ST: 579.0839506,
      EWS: 687.2117801,
      PwBD: 459.1503803,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 259.6525234,
      OBC: 196.0927772,
      SC: 173.6630177,
      ST: null,
      EWS: 203.8332604,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 889.062185,
      OBC: 839.5556365,
      SC: 592.6752229,
      ST: 776.0993313,
      EWS: 845.1359511,
      PwBD: 422.9428737,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 841.5003969,
      OBC: 772.236575,
      SC: 666.6372155,
      ST: 682.2406391,
      EWS: 747.6104823,
      PwBD: 423.7315697,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 925.9798244,
      OBC: 889.1424772,
      SC: 838.260506,
      ST: 838.0721064,
      EWS: 878.3143728,
      PwBD: 786.2421971,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A. (Hons.) Bengali",
    cutoffs: {
      UR: 432.8688417,
      OBC: 297.7824123,
      SC: 250.6816368,
      ST: null,
      EWS: 258.660171,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 581.4506042,
      OBC: 524.5072279,
      SC: 526.1095963,
      ST: 466.6170067,
      EWS: 594.9922656,
      PwBD: 472.9435912,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 396.6788555,
      OBC: 370.4005238,
      SC: 275.7632668,
      ST: 177.2525617,
      EWS: 421.6135858,
      PwBD: 220.3176523,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 503.6651358,
      OBC: 407.0818242,
      SC: 284.1408949,
      ST: 176.453626,
      EWS: null,
      PwBD: 154.8742435,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 495.3115235,
      OBC: 421.6023888,
      SC: 315.0210061,
      ST: 185.4234174,
      EWS: 447.200682,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 634.1643927,
      OBC: 587.0938152,
      SC: 508.2206442,
      ST: 492.0611146,
      EWS: 595.4845665,
      PwBD: 222.693557,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 660.6505151,
      OBC: 617.2386946,
      SC: 556.2597516,
      ST: 492.1293543,
      EWS: 611.9338763,
      PwBD: 347.0431747,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 712.4131624,
      OBC: 611.4167514,
      SC: 507.8695123,
      ST: 484.1802148,
      EWS: 623.2494259,
      PwBD: 201.4610129,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "Bachelor of Elementary Education",
    cutoffs: {
      UR: 738.2828893,
      OBC: 624.9172861,
      SC: 637.7237955,
      ST: 483.7606461,
      EWS: 613.3253753,
      PwBD: 591.0896948,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Bengali + Political Science)",
    cutoffs: {
      UR: 587.3500047,
      OBC: 337.1872168,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 831.1712421,
      OBC: 773.0481701,
      SC: 707.0743758,
      ST: null,
      EWS: 838.530558,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 855.0829394,
      OBC: 768.0608191,
      SC: 783.0765309,
      ST: null,
      EWS: 725.4023052,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 883.9187141,
      OBC: 778.6865421,
      SC: 723.7837531,
      ST: null,
      EWS: 805.0364888,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 807.0481959,
      OBC: 706.9155217,
      SC: 703.4789552,
      ST: null,
      EWS: 718.6852981,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 849.6132566,
      OBC: 734.4262925,
      SC: 710.5259992,
      ST: null,
      EWS: 724.3760494,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Sanskrit + Geography)",
    cutoffs: {
      UR: 690.0385476,
      OBC: 623.6964742,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 729.4043773,
      OBC: 559.156621,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 759.6677021,
      OBC: 579.0399544,
      SC: 424.5195464,
      ST: 277.729955,
      EWS: 602.0477891,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Economics + Geography)",
    cutoffs: {
      UR: 845.5312715,
      OBC: 810.5763003,
      SC: 809.9537325,
      ST: 673.3623735,
      EWS: 727.5280903,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 861.0644942,
      OBC: 789.5971883,
      SC: 752.1373697,
      ST: 683.5792243,
      EWS: 787.0083355,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 855.9451129,
      OBC: 683.6676753,
      SC: 582.5125212,
      ST: 570.0553692,
      EWS: 747.6889884,
      PwBD: 261.2173535,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 885.5353743,
      OBC: 809.117956,
      SC: 777.7646697,
      ST: 668.4520216,
      EWS: 807.9039134,
      PwBD: 566.4461088,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Geography + History)",
    cutoffs: {
      UR: 851.9309394,
      OBC: 814.0251023,
      SC: 751.7708265,
      ST: 731.9009743,
      EWS: 799.950093,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Geography + Mathematics)",
    cutoffs: {
      UR: 794.1891184,
      OBC: 661.263142,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Geography + Political Science)",
    cutoffs: {
      UR: 907.935014,
      OBC: 839.7823218,
      SC: 787.9840036,
      ST: 799.2279409,
      EWS: 814.6460956,
      PwBD: 341.556022,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (History + Philosophy)",
    cutoffs: {
      UR: 830.2481984,
      OBC: 763.7259732,
      SC: 664.6302558,
      ST: null,
      EWS: 819.6179805,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (History + Physical Education)",
    cutoffs: {
      UR: 768.5468725,
      OBC: 698.7218117,
      SC: 659.0835002,
      ST: 560.6549805,
      EWS: 667.1941851,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 891.7178474,
      OBC: 832.0572109,
      SC: 815.8057277,
      ST: 751.8290587,
      EWS: 825.4808799,
      PwBD: 723.2889255,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (History + Sociology)",
    cutoffs: {
      UR: 839.9481496,
      OBC: 806.2752206,
      SC: 727.5739261,
      ST: null,
      EWS: 733.4081161,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 856.6181719,
      OBC: 799.0814891,
      SC: 675.6948033,
      ST: 699.292536,
      EWS: 732.5908469,
      PwBD: 297.8065252,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Physical Education + Political Science)",
    cutoffs: {
      UR: 747.296886,
      OBC: 732.0407838,
      SC: 661.1934576,
      ST: 728.8644808,
      EWS: 678.1385051,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Political Science + Sociology)",
    cutoffs: {
      UR: 880.2454464,
      OBC: 840.9260794,
      SC: 733.5412265,
      ST: null,
      EWS: 797.8831345,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Tamil + Political Science)",
    cutoffs: {
      UR: 665.8430162,
      OBC: 537.8415655,
      SC: 485.8401812,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Punjabi + History)",
    cutoffs: {
      UR: 706.6911234,
      OBC: 564.96506,
      SC: 618.0191313,
      ST: null,
      EWS: 401.2812529,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Bengali + Geography)",
    cutoffs: {
      UR: 585.7829554,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (English + Philosophy)",
    cutoffs: {
      UR: 812.7263322,
      OBC: 772.4693262,
      SC: 672.3976088,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Geography + English)",
    cutoffs: {
      UR: 841.1065255,
      OBC: 780.7318292,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Miranda House (W)",
    programName: "B.A Program (Geography + Sociology)",
    cutoffs: {
      UR: 839.8735946,
      OBC: 794.9899153,
      SC: 717.5576257,
      ST: null,
      EWS: 609.4817467,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.Com.",
    cutoffs: {
      UR: 778.8529229,
      OBC: 660.3046703,
      SC: 547.6435739,
      ST: 387.554734,
      EWS: 703.8773705,
      PwBD: 606.0298819,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 803.5606847,
      OBC: 702.7728401,
      SC: 607.9000673,
      ST: 462.4005669,
      EWS: 739.2852888,
      PwBD: 443.3733318,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 246.9449753,
      OBC: 215.4503302,
      SC: 110.3497768,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 333.8697372,
      OBC: 259.1055078,
      SC: 179.6915498,
      ST: 97.6025414,
      EWS: 245.436823,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 370.8389821,
      OBC: 277.3933787,
      SC: 209.0015263,
      ST: 155.5359951,
      EWS: 285.13652,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 569.8104736,
      OBC: 450.7636597,
      SC: 346.0615419,
      ST: 114.6487183,
      EWS: 447.4253184,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 710.3649601,
      OBC: 602.6987175,
      SC: 547.627019,
      ST: 517.3424651,
      EWS: 544.6199585,
      PwBD: 234.083976,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 358.6353455,
      OBC: 118.767059,
      SC: 272.7582914,
      ST: null,
      EWS: 276.4983073,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 755.7216459,
      OBC: 544.6520569,
      SC: 455.5372914,
      ST: 155.3539815,
      EWS: 567.0058115,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 767.2350582,
      OBC: 704.1472247,
      SC: 637.8646868,
      ST: 621.130731,
      EWS: 680.2983197,
      PwBD: 304.7433272,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 743.2057116,
      OBC: 635.555161,
      SC: 569.6637995,
      ST: 517.5552101,
      EWS: 603.1718026,
      PwBD: 174.0421801,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 340.7965542,
      OBC: 159.231666,
      SC: 163.2757841,
      ST: null,
      EWS: 159.2618017,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 374.5099275,
      OBC: 288.5251971,
      SC: 229.3071934,
      ST: 28.613639,
      EWS: 312.0977891,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 710.8883552,
      OBC: 619.5534267,
      SC: 606.5085255,
      ST: 562.0865863,
      EWS: 560.0819364,
      PwBD: 233.5883428,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 687.3883893,
      OBC: 581.3136299,
      SC: 536.3073455,
      ST: 483.21933,
      EWS: 564.7729731,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (English + Mathematics)",
    cutoffs: {
      UR: 675.5966465,
      OBC: 495.9830635,
      SC: 358.8414321,
      ST: 340.4172653,
      EWS: 487.5452801,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 678.3110811,
      OBC: 576.4218581,
      SC: 487.6170948,
      ST: 520.9730114,
      EWS: 543.3078548,
      PwBD: 182.9848447,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 697.3358068,
      OBC: 575.6022111,
      SC: 483.924562,
      ST: 493.8627528,
      EWS: 588.0926391,
      PwBD: 340.5003316,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 675.2855962,
      OBC: 544.9962281,
      SC: 481.524164,
      ST: 450.4681356,
      EWS: 528.9058885,
      PwBD: 119.537214,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 708.2394075,
      OBC: 475.2183984,
      SC: 309.3103593,
      ST: 219.7799941,
      EWS: 569.1224094,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 741.7882209,
      OBC: 596.6932855,
      SC: 516.472009,
      ST: 511.3647958,
      EWS: 629.7301731,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 606.5293199,
      OBC: 513.4451109,
      SC: 441.9811775,
      ST: 312.7211189,
      EWS: 246.9400808,
      PwBD: 225.503266,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 587.2289931,
      OBC: 497.4784891,
      SC: 428.5369261,
      ST: 272.5347319,
      EWS: 439.7598886,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 446.2588988,
      OBC: 244.9661256,
      SC: 208.9458929,
      ST: null,
      EWS: 270.5215186,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 394.0663228,
      OBC: 145.9231832,
      SC: 134.4004939,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 608.1221091,
      OBC: 459.4038892,
      SC: 425.5316032,
      ST: 406.3504375,
      EWS: 429.2086428,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 295.3950743,
      OBC: 136.1213176,
      SC: 114.7383613,
      ST: 183.1420287,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 570.6827693,
      OBC: 433.3477156,
      SC: 394.0035641,
      ST: 341.0172786,
      EWS: 348.4557513,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 611.6360571,
      OBC: 490.4792184,
      SC: 440.6921602,
      ST: 445.9012154,
      EWS: 386.4074899,
      PwBD: 302.7134939,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.Com.",
    cutoffs: {
      UR: 686.6348065,
      OBC: 534.1292075,
      SC: 434.9294694,
      ST: 174.6509677,
      EWS: 564.834493,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 717.2618946,
      OBC: 577.1004011,
      SC: 474.2477406,
      ST: 102.9894211,
      EWS: 625.5351592,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 623.9413012,
      OBC: 442.143872,
      SC: 348.8512399,
      ST: 190.8810835,
      EWS: 446.9241492,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 574.7847265,
      OBC: 448.5765402,
      SC: 397.369358,
      ST: 404.2260839,
      EWS: 115.9029116,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (English + Mathematics)",
    cutoffs: {
      UR: 573.8388713,
      OBC: 418.7336964,
      SC: 259.3203536,
      ST: 216.4524275,
      EWS: 386.5056769,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 560.6288019,
      OBC: 409.7935968,
      SC: 373.2464384,
      ST: 363.2105353,
      EWS: 279.992024,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 520.0105495,
      OBC: 388.3603812,
      SC: 377.0274123,
      ST: 163.5822524,
      EWS: 323.9701552,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (Hindi + Physical Education)",
    cutoffs: {
      UR: 519.5979388,
      OBC: 399.4593315,
      SC: 378.9822786,
      ST: 245.3140157,
      EWS: 257.6304481,
      PwBD: 310.3328355,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 521.2680255,
      OBC: 385.4548038,
      SC: 365.3344303,
      ST: 514.3220617,
      EWS: 313.098526,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 608.1945685,
      OBC: 389.9734047,
      SC: 222.8440871,
      ST: null,
      EWS: 333.5561039,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 569.2042239,
      OBC: 399.166024,
      SC: 343.6274716,
      ST: 256.8104507,
      EWS: 346.2562234,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 546.5435352,
      OBC: 400.5753193,
      SC: 354.9533949,
      ST: 231.3538824,
      EWS: 289.8944475,
      PwBD: 231.1719025,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (Physical Education + Political Science)",
    cutoffs: {
      UR: 561.8690591,
      OBC: 423.451157,
      SC: 428.8464257,
      ST: null,
      EWS: 350.5597207,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 294.4737102,
      OBC: 155.4139673,
      SC: 185.7009129,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 282.8670143,
      OBC: 113.0260197,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Motilal Nehru College (Evening)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 573.0260269,
      OBC: 434.8169935,
      SC: 380.0883193,
      ST: 293.8173426,
      EWS: 442.3297121,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 710.2343358,
      OBC: 447.427539,
      SC: 337.454225,
      ST: null,
      EWS: 458.3165406,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 646.6789726,
      OBC: 482.7096592,
      SC: 453.5089454,
      ST: 354.6562127,
      EWS: 457.7251363,
      PwBD: 278.4578382,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 295.4819375,
      OBC: 87.0202906,
      SC: 102.4172697,
      ST: null,
      EWS: 248.7981049,
      PwBD: 261.4782373,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 636.3372191,
      OBC: 503.867463,
      SC: 454.2998578,
      ST: 442.9154875,
      EWS: 331.6680278,
      PwBD: 310.1700413,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 675.8385949,
      OBC: 580.6595119,
      SC: 512.2613472,
      ST: 493.362655,
      EWS: 376.0522715,
      PwBD: 248.2977662,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 368.5883327,
      OBC: 144.7977511,
      SC: 288.3764414,
      ST: null,
      EWS: 177.7340972,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.Com.",
    cutoffs: {
      UR: 713.7303569,
      OBC: 554.3627507,
      SC: 468.7877144,
      ST: 195.1830151,
      EWS: 593.1944957,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 752.6055615,
      OBC: 615.4694626,
      SC: 523.9650109,
      ST: 259.2287775,
      EWS: 653.7327091,
      PwBD: 352.7903807,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 574.9877336,
      OBC: 493.7898097,
      SC: 410.0737252,
      ST: 294.1280591,
      EWS: 511.2040897,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 549.7329307,
      OBC: 429.9711432,
      SC: 304.7384487,
      ST: 303.0247779,
      EWS: 435.6666127,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.Sc. (Hons.) Statistics",
    cutoffs: {
      UR: 688.1528858,
      OBC: 482.7944331,
      SC: 378.5396743,
      ST: 176.9696448,
      EWS: 517.7682642,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.Sc. (Prog.) Mathematical Sciences",
    cutoffs: {
      UR: 491.8817351,
      OBC: 358.5147882,
      SC: 258.7863794,
      ST: 322.7047943,
      EWS: 334.2620794,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 634.7904641,
      OBC: 513.3549912,
      SC: 516.8691458,
      ST: 470.5470856,
      EWS: 454.7117376,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 645.5576148,
      OBC: 529.4320267,
      SC: 513.9790623,
      ST: 488.7915393,
      EWS: 541.2821107,
      PwBD: 153.802448,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 571.6215072,
      OBC: 443.8167843,
      SC: 407.5708761,
      ST: 235.9989112,
      EWS: 399.8263061,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 575.6821082,
      OBC: 430.9242425,
      SC: 431.4235557,
      ST: 298.5207551,
      EWS: 359.7976279,
      PwBD: 299.8340449,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 434.9660257,
      OBC: 100.9021045,
      SC: 151.9430903,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 327.8788398,
      OBC: 257.6064367,
      SC: 259.8102992,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (Accounting and Finance + Economics)",
    cutoffs: {
      UR: 734.2878449,
      OBC: 606.7894737,
      SC: 591.5331872,
      ST: 566.3855803,
      EWS: 567.9972801,
      PwBD: 208.2566982,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 666.82529,
      OBC: 506.7160933,
      SC: 410.9515268,
      ST: null,
      EWS: 472.9960193,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 630.85872,
      OBC: 516.8414896,
      SC: 405.3818849,
      ST: null,
      EWS: 481.5655444,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName:
      "B.A Program (Economics + Entrepreneurship and Small Business (ESB))",
    cutoffs: {
      UR: 683.373614,
      OBC: 531.7664941,
      SC: 541.8134384,
      ST: 412.5199744,
      EWS: 567.080432,
      PwBD: 334.6265869,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 658.7358926,
      OBC: 452.19444,
      SC: 286.3904722,
      ST: null,
      EWS: 439.7211306,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 649.3367309,
      OBC: 499.6798864,
      SC: 442.0919199,
      ST: 146.7938745,
      EWS: 415.8746919,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 609.3235716,
      OBC: 469.0587501,
      SC: 441.8221544,
      ST: 407.3639036,
      EWS: 154.1192392,
      PwBD: 159.2042032,
    },
  },
  {
    collegeName: "P.G.D.A.V. College",
    programName: "B.A Program (Physical Education + Political Science)",
    cutoffs: {
      UR: 618.7622256,
      OBC: 493.7235009,
      SC: 472.2932769,
      ST: 465.8768706,
      EWS: 493.5125995,
      PwBD: 191.8746588,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.Com.",
    cutoffs: {
      UR: 648.490196,
      OBC: 477.8914999,
      SC: 360.5658523,
      ST: 322.8517787,
      EWS: 500.0380195,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 685.5677189,
      OBC: 531.183382,
      SC: 436.4298641,
      ST: 258.1201243,
      EWS: 572.3061618,
      PwBD: 379.6341418,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 257.7410235,
      OBC: 173.7050948,
      SC: 77.3750438,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 574.0296713,
      OBC: 445.9889908,
      SC: 397.5347932,
      ST: 376.5142546,
      EWS: 172.0093208,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 517.8831545,
      OBC: 397.8154229,
      SC: 249.6093947,
      ST: null,
      EWS: 379.7398702,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 331.542073,
      OBC: 91.7540957,
      SC: 157.5924525,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 629.1684116,
      OBC: 435.3266765,
      SC: 385.6271432,
      ST: 161.3353894,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 555.6622371,
      OBC: 415.6577433,
      SC: 371.4114747,
      ST: 175.9986323,
      EWS: 312.5542864,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (English + Mathematics)",
    cutoffs: {
      UR: 568.7313915,
      OBC: 457.9777444,
      SC: 247.4215882,
      ST: 499.0709843,
      EWS: 406.8153401,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 560.0848342,
      OBC: 415.3481625,
      SC: 379.079506,
      ST: 339.6651621,
      EWS: 340.5472085,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 510.9163813,
      OBC: 373.1270875,
      SC: 336.3593982,
      ST: null,
      EWS: 264.6904428,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 497.2911619,
      OBC: 373.6679067,
      SC: 343.5279323,
      ST: 119.5467268,
      EWS: 273.168857,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (Commerce + Economics)",
    cutoffs: {
      UR: 643.0315773,
      OBC: 466.401017,
      SC: 376.1675957,
      ST: 270.9306729,
      EWS: 487.3501036,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 552.4294269,
      OBC: 403.3698681,
      SC: 364.7586159,
      ST: 259.8021129,
      EWS: 392.5950008,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 588.0347707,
      OBC: 352.4474815,
      SC: 221.5216024,
      ST: null,
      EWS: 310.7727796,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 549.7750479,
      OBC: 383.5283417,
      SC: 331.491318,
      ST: 195.8320611,
      EWS: 325.5548953,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 535.8092917,
      OBC: 390.927595,
      SC: 346.0699572,
      ST: 229.7046831,
      EWS: 80.7638079,
      PwBD: null,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (Physical Education + History)",
    cutoffs: {
      UR: 539.8762498,
      OBC: 411.850656,
      SC: 390.9268839,
      ST: 444.0909273,
      EWS: 350.8711722,
      PwBD: 400.9494587,
    },
  },
  {
    collegeName: "P.G.D.A.V. College (Evening)",
    programName: "B.A Program (Physical Education + Political Science)",
    cutoffs: {
      UR: 540.8019689,
      OBC: 408.6296774,
      SC: 386.7272184,
      ST: 279.4779017,
      EWS: 335.4200933,
      PwBD: 254.4544135,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 646.6640684,
      OBC: 492.6726963,
      SC: 461.9700141,
      ST: 413.5666858,
      EWS: 480.3262137,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 302.6227372,
      OBC: 112.4741972,
      SC: 104.2183087,
      ST: 257.5566627,
      EWS: 224.7321223,
      PwBD: 270.8614571,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 270.2134108,
      OBC: 134.7808731,
      SC: 112.6199565,
      ST: null,
      EWS: 301.7983353,
      PwBD: 260.4942343,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 632.4560894,
      OBC: 515.7815671,
      SC: 450.4424901,
      ST: 413.4491162,
      EWS: 258.7913369,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 699.6071494,
      OBC: 441.1460405,
      SC: 360.1569099,
      ST: 204.8077878,
      EWS: 456.5547644,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 684.1735252,
      OBC: 584.4431139,
      SC: 573.0161583,
      ST: 526.3392166,
      EWS: 386.7826019,
      PwBD: 316.4240832,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 760.4415885,
      OBC: 633.3460346,
      SC: 534.3366797,
      ST: 332.7286554,
      EWS: 678.5317452,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 325.4768204,
      OBC: 255.3446553,
      SC: 168.7821568,
      ST: 243.603381,
      EWS: 250.6526895,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 312.5259841,
      OBC: 207.7291264,
      SC: 162.9839806,
      ST: null,
      EWS: 238.3177066,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 307.6904291,
      OBC: 254.9746961,
      SC: 43.5974012,
      ST: 53.3875114,
      EWS: 194.0671873,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 525.589653,
      OBC: 406.5856963,
      SC: 295.8937097,
      ST: 249.3007075,
      EWS: 410.8309939,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 245.7256091,
      OBC: 133.5037072,
      SC: 96.2999416,
      ST: null,
      EWS: 172.2939511,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 293.945154,
      OBC: 219.9694583,
      SC: 146.0542077,
      ST: 210.5045793,
      EWS: 223.064185,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.Sc (Prog.) Physical Science with Electronics",
    cutoffs: {
      UR: 226.0907256,
      OBC: 158.1997465,
      SC: 36.1543827,
      ST: null,
      EWS: 151.8489786,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName:
      "B.Sc (Prog.) Applied Physical Sciences with Industrial Chemistry",
    cutoffs: {
      UR: 191.694411,
      OBC: 112.9753735,
      SC: 81.9157596,
      ST: null,
      EWS: 166.3477845,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 634.2991083,
      OBC: 543.97794,
      SC: 526.1746603,
      ST: 412.0313805,
      EWS: 439.5646724,
      PwBD: 303.7844728,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (English + Linguistics)",
    cutoffs: {
      UR: 625.5479031,
      OBC: 478.9222115,
      SC: 453.1638829,
      ST: 449.1504488,
      EWS: 442.7914011,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 552.2472507,
      OBC: 440.6079083,
      SC: 433.2968854,
      ST: 330.9293005,
      EWS: 350.6160525,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 553.8923368,
      OBC: 437.7720822,
      SC: 410.9006899,
      ST: 279.6899867,
      EWS: 153.6580663,
      PwBD: 181.8066447,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 325.1432396,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 392.4951987,
      OBC: null,
      SC: 360.2828733,
      ST: null,
      EWS: 359.1060484,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 626.807456,
      OBC: 487.009846,
      SC: 430.6272535,
      ST: 391.6248804,
      EWS: 418.2296802,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 645.817945,
      OBC: 396.50756,
      SC: 274.2958375,
      ST: null,
      EWS: 284.1073441,
      PwBD: null,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 641.362969,
      OBC: 482.2470413,
      SC: 429.2633068,
      ST: 392.0956414,
      EWS: 424.4652745,
      PwBD: 457.180251,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 609.2101544,
      OBC: 482.1028057,
      SC: 444.3087728,
      ST: 405.4457191,
      EWS: null,
      PwBD: 223.9571107,
    },
  },
  {
    collegeName: "Rajdhani College",
    programName: "B.A Program (Linguistics + Political Science)",
    cutoffs: {
      UR: 582.3678597,
      OBC: 434.8215827,
      SC: 402.0524601,
      ST: 212.8033545,
      EWS: 357.1257759,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 667.3822072,
      OBC: 529.3494896,
      SC: 481.9131216,
      ST: 458.2409001,
      EWS: 511.7525581,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 276.91249,
      OBC: 71.2459643,
      SC: 92.7978845,
      ST: null,
      EWS: 158.098489,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.A. (Hons.) Hindi Patrakarita",
    cutoffs: {
      UR: 523.7630774,
      OBC: 423.2631348,
      SC: 339.3450446,
      ST: null,
      EWS: 411.3665002,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 670.4886783,
      OBC: 548.4997839,
      SC: 475.504013,
      ST: 451.6224847,
      EWS: 504.0730695,
      PwBD: 372.5176892,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 691.0693693,
      OBC: 643.0799773,
      SC: 559.6793267,
      ST: 533.7147345,
      EWS: 593.1713734,
      PwBD: 173.3921592,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.Com.",
    cutoffs: {
      UR: 774.7900407,
      OBC: 646.5074496,
      SC: 542.0772427,
      ST: 344.9684527,
      EWS: 697.9589593,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 795.2746897,
      OBC: 686.9166505,
      SC: 593.5622683,
      ST: 435.0832741,
      EWS: 727.5936819,
      PwBD: 438.2098491,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 609.1670938,
      OBC: 504.7056027,
      SC: 415.8490292,
      ST: 176.10456,
      EWS: 447.7299253,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.Sc. (Hons.) Geology",
    cutoffs: {
      UR: 459.4187557,
      OBC: 443.0422703,
      SC: 289.4036311,
      ST: 219.286163,
      EWS: 434.8515161,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.Sc. (Hons.) Microbiology",
    cutoffs: {
      UR: 577.1891469,
      OBC: 516.3945384,
      SC: 439.1467169,
      ST: 374.5230556,
      EWS: 500.4399282,
      PwBD: 225.474698,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.Sc. (Hons.) Statistics",
    cutoffs: {
      UR: 712.452189,
      OBC: 514.1581908,
      SC: 389.5294637,
      ST: 231.4958323,
      EWS: 562.2260634,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 561.0245987,
      OBC: 431.3537231,
      SC: 322.2717839,
      ST: 224.4818793,
      EWS: 428.6451429,
      PwBD: 342.990485,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "Bachelor of Management Studies",
    cutoffs: {
      UR: 452.2593857,
      OBC: 346.1584074,
      SC: 287.7691419,
      ST: 204.4302275,
      EWS: 370.3569091,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 676.2256309,
      OBC: 466.0545853,
      SC: 391.2926061,
      ST: 181.061758,
      EWS: 476.6961314,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 682.5150662,
      OBC: 442.6939087,
      SC: 268.6226551,
      ST: null,
      EWS: 435.5521671,
      PwBD: null,
    },
  },
  {
    collegeName: "Ram Lal Anand College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 661.7474872,
      OBC: 547.571669,
      SC: 477.0567489,
      ST: 475.5148519,
      EWS: 504.3431604,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 785.2621634,
      OBC: 654.9798515,
      SC: 564.266794,
      ST: 415.013269,
      EWS: 693.752325,
      PwBD: 510.5052416,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.Com.",
    cutoffs: {
      UR: 764.8334963,
      OBC: 618.8268927,
      SC: 529.0564874,
      ST: 364.5513718,
      EWS: 662.1873113,
      PwBD: 442.357422,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 664.3235451,
      OBC: 527.1985549,
      SC: 485.4718767,
      ST: 485.2152404,
      EWS: 499.8504873,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 314.4357681,
      OBC: 163.2357391,
      SC: 150.888068,
      ST: null,
      EWS: 291.16892,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 729.6712826,
      OBC: 657.051628,
      SC: 584.156498,
      ST: 518.3697508,
      EWS: 607.49999,
      PwBD: 461.4309052,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.Sc. (Hons.) Statistics",
    cutoffs: {
      UR: 708.2836569,
      OBC: 504.3172042,
      SC: 385.4304264,
      ST: 276.3095695,
      EWS: 572.8877092,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 604.9556854,
      OBC: 455.4812376,
      SC: 355.1313067,
      ST: 247.2137666,
      EWS: 469.3006308,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 624.9999774,
      OBC: 540.3040309,
      SC: 440.0955124,
      ST: 345.9068534,
      EWS: 576.4113531,
      PwBD: 224.2473032,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A. (Hons.) Applied Psychology",
    cutoffs: {
      UR: 812.4819502,
      OBC: 630.2168832,
      SC: 595.1748066,
      ST: 545.3333644,
      EWS: 573.5155904,
      PwBD: 332.6495115,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 638.9858427,
      OBC: 458.5993897,
      SC: 408.7353833,
      ST: 207.9368562,
      EWS: 447.3031041,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 743.5414364,
      OBC: 497.0341001,
      SC: 408.9479077,
      ST: 91.7113827,
      EWS: 540.6719238,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "Bachelor of Management Studies",
    cutoffs: {
      UR: 483.6642712,
      OBC: 353.5359976,
      SC: 299.5710383,
      ST: 150.1611353,
      EWS: 412.4996799,
      PwBD: 142.8693277,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.Voc.. Banking, Financial Services and Insurance",
    cutoffs: {
      UR: 728.9710484,
      OBC: 599.0707974,
      SC: 513.4641847,
      ST: 414.3276759,
      EWS: 596.9416537,
      PwBD: 179.0360369,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.Voc. Software Development",
    cutoffs: {
      UR: 599.2477838,
      OBC: 496.7044857,
      SC: 390.2364807,
      ST: 326.8938549,
      EWS: 445.6938407,
      PwBD: 110.2145546,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A Program (Accounting and Finance + Economics)",
    cutoffs: {
      UR: 771.1770396,
      OBC: 644.6036032,
      SC: 582.0649825,
      ST: null,
      EWS: 666.6322706,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName:
      "B.A Program (Economics + Entrepreneurship and Small Business (ESB))",
    cutoffs: {
      UR: 749.4393984,
      OBC: 591.367277,
      SC: 549.3280518,
      ST: 510.5963447,
      EWS: 645.7615058,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A Program (History + Philosophy)",
    cutoffs: {
      UR: 637.7372514,
      OBC: 522.1690855,
      SC: 434.8129669,
      ST: 454.6683919,
      EWS: 454.0702233,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 699.3224569,
      OBC: 625.73941,
      SC: 542.1750312,
      ST: 566.2883573,
      EWS: 639.0162552,
      PwBD: 433.4991123,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 674.901248,
      OBC: 560.6705351,
      SC: 530.6398399,
      ST: 439.3757216,
      EWS: 491.511336,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A Program (Political Science + Psychology)",
    cutoffs: {
      UR: 771.3012364,
      OBC: 622.2041116,
      SC: 580.8759329,
      ST: 546.94354,
      EWS: 594.0784831,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A Program (Accounting and Finance + Mathematics)",
    cutoffs: {
      UR: 740.5105509,
      OBC: 540.3732392,
      SC: 454.8668623,
      ST: null,
      EWS: 556.613887,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.Sc. (Hons.) Environmental Science",
    cutoffs: {
      UR: 452.2178596,
      OBC: 400.9693485,
      SC: 311.2967083,
      ST: 324.9856537,
      EWS: 360.6817797,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A Program (Economics + Psychology)",
    cutoffs: {
      UR: 752.6970768,
      OBC: 619.0591675,
      SC: 568.6493829,
      ST: 506.2033573,
      EWS: 579.9878307,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 582.6193727,
      OBC: 460.0103064,
      SC: 456.3432385,
      ST: 385.064825,
      EWS: 410.3788923,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 609.7214895,
      OBC: 481.3894395,
      SC: 448.5836405,
      ST: 283.94683,
      EWS: 423.8374068,
      PwBD: 230.2967972,
    },
  },
  {
    collegeName: "Ramanujan College",
    programName:
      "B.A Program (Entrepreneurship and Small Business (ESB) + Mathematics)",
    cutoffs: {
      UR: 672.429249,
      OBC: 473.0959336,
      SC: 398.2016467,
      ST: 312.4314516,
      EWS: 476.0841928,
      PwBD: 253.4305306,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 821.6818909,
      OBC: 726.3913429,
      SC: 683.4447344,
      ST: 660.8838473,
      EWS: 746.876922,
      PwBD: 478.2160783,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 527.7811415,
      OBC: 430.7358257,
      SC: 411.1181232,
      ST: 202.0353969,
      EWS: 235.8614758,
      PwBD: 193.6492162,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 358.3075696,
      OBC: 399.1714443,
      SC: 271.139196,
      ST: 262.7127187,
      EWS: 381.0929779,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 830.1537757,
      OBC: 676.4272528,
      SC: 608.6862041,
      ST: 441.3014329,
      EWS: 735.7200155,
      PwBD: 272.5398087,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 846.3177416,
      OBC: 798.0550904,
      SC: 729.9863347,
      ST: 618.6193714,
      EWS: 807.1779889,
      PwBD: 543.8043128,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 894.9456824,
      OBC: 851.8985496,
      SC: 787.3322405,
      ST: 803.1123668,
      EWS: 847.601847,
      PwBD: 733.4092473,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Com.",
    cutoffs: {
      UR: 872.9660002,
      OBC: 799.8865696,
      SC: 727.7590918,
      ST: 651.7979646,
      EWS: 834.7884791,
      PwBD: 565.8747955,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 889.3870694,
      OBC: 813.2727194,
      SC: 745.2073985,
      ST: 670.1841371,
      EWS: 849.0374843,
      PwBD: 624.1711429,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Sc (Prog.) Physical Science with Electronics",
    cutoffs: {
      UR: 362.5667205,
      OBC: 298.4586071,
      SC: 205.5248206,
      ST: 98.9798068,
      EWS: 304.4389701,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 332.2872057,
      OBC: 297.7068125,
      SC: 159.4622668,
      ST: 60.4857821,
      EWS: 246.5582008,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 579.3412034,
      OBC: 509.2990382,
      SC: 431.4072813,
      ST: 374.5659627,
      EWS: 547.3948564,
      PwBD: 222.4899627,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 467.0350097,
      OBC: 395.8463431,
      SC: 287.6502489,
      ST: 162.9800688,
      EWS: 408.9199344,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 444.1871662,
      OBC: 388.2195518,
      SC: 250.0226422,
      ST: 162.7192544,
      EWS: 389.262256,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 727.3795935,
      OBC: 610.3779909,
      SC: 505.1423492,
      ST: 339.5993065,
      EWS: 593.5021406,
      PwBD: 278.3175321,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Sc. (Hons.) Statistics",
    cutoffs: {
      UR: 772.7453598,
      OBC: 620.5036273,
      SC: 517.5002241,
      ST: 352.7815301,
      EWS: 676.7951508,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 589.8114657,
      OBC: 480.9285185,
      SC: 412.919053,
      ST: 433.9694542,
      EWS: 549.6592653,
      PwBD: 220.6290245,
    },
  },
  {
    collegeName: "Ramjas College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 547.1988953,
      OBC: 586.0231018,
      SC: 504.6975695,
      ST: 454.7145958,
      EWS: 586.3329302,
      PwBD: 69.8982327,
    },
  },
  {
    collegeName: "Ramjas College",
    programName:
      "B.A Program (Sanskrit + Any one out of these (English/Hindi/History/Pol. Science/Economics/Mathematics/Philosophy))",
    cutoffs: {
      UR: 652.8231836,
      OBC: 592.1092806,
      SC: 603.8500632,
      ST: 426.6545621,
      EWS: 434.6691971,
      PwBD: null,
    },
  },
  {
    collegeName: "Ramjas College",
    programName:
      "B.A Program (Philosophy + Any one out of these (English/Hindi/History/Pol. Science/Economics/Mathematics/Sanskrit))",
    cutoffs: {
      UR: 818.2939023,
      OBC: 748.4792785,
      SC: 667.8267848,
      ST: 663.1577284,
      EWS: 737.9460058,
      PwBD: 509.8340819,
    },
  },
  {
    collegeName: "Ramjas College",
    programName:
      "B.A Program (Any two discipline from these (English/Hindi/History/Pol. Science/Economics/Mathematics))",
    cutoffs: {
      UR: 825.1129093,
      OBC: 769.5000041,
      SC: 719.424613,
      ST: 687.6512693,
      EWS: 791.6869593,
      PwBD: 638.8615807,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 532.7252542,
      OBC: 404.7822083,
      SC: 307.4267768,
      ST: 237.1007364,
      EWS: 372.7268907,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 696.6343841,
      OBC: 440.5614989,
      SC: 334.4549208,
      ST: 280.3739049,
      EWS: 443.4627151,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 647.2096056,
      OBC: 500.2840561,
      SC: 453.5285264,
      ST: 371.7281599,
      EWS: 468.7153588,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 339.4549755,
      OBC: 161.3711639,
      SC: 212.0278263,
      ST: 248.9975887,
      EWS: 236.8830407,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 623.3242615,
      OBC: 492.494361,
      SC: 440.1356027,
      ST: 407.920907,
      EWS: 370.6162523,
      PwBD: 326.0722955,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 689.0105453,
      OBC: 588.8586499,
      SC: 537.9709345,
      ST: 499.3371001,
      EWS: 589.8471627,
      PwBD: 473.0100971,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 339.7834155,
      OBC: 77.2088494,
      SC: 142.4569441,
      ST: null,
      EWS: 154.0903207,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A. (Hons.) Urdu",
    cutoffs: {
      UR: 325.2568477,
      OBC: 90.8560755,
      SC: 165.3656501,
      ST: 138.3119794,
      EWS: 37.4201663,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.Com.",
    cutoffs: {
      UR: 734.8812043,
      OBC: 575.0259724,
      SC: 477.6163193,
      ST: 208.2152379,
      EWS: 624.4637908,
      PwBD: 205.5259502,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 763.6866539,
      OBC: 635.4879126,
      SC: 533.6915324,
      ST: 273.0233849,
      EWS: 656.219314,
      PwBD: 224.6857803,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 545.6769573,
      OBC: 433.7700761,
      SC: 399.9142692,
      ST: 252.0328298,
      EWS: 338.1680272,
      PwBD: 347.6955291,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 624.6054257,
      OBC: 525.0496952,
      SC: 475.3564271,
      ST: 436.926292,
      EWS: 467.8602723,
      PwBD: 415.2287647,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 553.2908529,
      OBC: 427.1977839,
      SC: 433.2700971,
      ST: 218.6368969,
      EWS: 391.9408418,
      PwBD: 354.9851572,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 612.9649011,
      OBC: 492.9650032,
      SC: 457.8611322,
      ST: 428.1545687,
      EWS: 398.5395797,
      PwBD: 157.1053435,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 635.0822654,
      OBC: 515.3017403,
      SC: 498.0716192,
      ST: 556.2733015,
      EWS: 498.8661165,
      PwBD: 204.9941227,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 609.2109645,
      OBC: 479.6400785,
      SC: 438.6500574,
      ST: 396.9980638,
      EWS: 423.6337636,
      PwBD: 351.2093577,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 616.6242525,
      OBC: 476.4937431,
      SC: 451.8483809,
      ST: 404.6654094,
      EWS: 419.6770263,
      PwBD: 338.0170335,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 643.5474779,
      OBC: 425.8465224,
      SC: 277.5276571,
      ST: null,
      EWS: 272.9093377,
      PwBD: 226.8863185,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (Economics + OMSP)",
    cutoffs: {
      UR: 619.0517357,
      OBC: 458.6089223,
      SC: 361.6420575,
      ST: 365.2390345,
      EWS: 426.6730851,
      PwBD: 341.2319176,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (Mathematics + OMSP)",
    cutoffs: {
      UR: 553.6971233,
      OBC: 338.9152877,
      SC: 259.7549029,
      ST: null,
      EWS: 300.3140667,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (Mathematics + Political Science)",
    cutoffs: {
      UR: 527.388328,
      OBC: 383.1959409,
      SC: 265.4544852,
      ST: 151.8256991,
      EWS: 410.7874068,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (History + Mathematics)",
    cutoffs: {
      UR: 519.6357033,
      OBC: 385.0396237,
      SC: 300.8745103,
      ST: 312.184236,
      EWS: 338.2311169,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 354.6723354,
      OBC: 190.4714341,
      SC: 214.4068379,
      ST: null,
      EWS: 221.4240524,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 350.0944826,
      OBC: 282.01072,
      SC: 202.1329714,
      ST: null,
      EWS: 303.6524264,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 668.7013392,
      OBC: 505.7174975,
      SC: 445.0347622,
      ST: 344.8250631,
      EWS: 508.1756361,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 627.6988644,
      OBC: 359.3619479,
      SC: 248.6693655,
      ST: null,
      EWS: 298.9647587,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 593.2484453,
      OBC: 431.3844592,
      SC: 383.3103188,
      ST: 97.1002666,
      EWS: 408.7548419,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 225.8904685,
      OBC: 175.789362,
      SC: 138.6695179,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 556.6041881,
      OBC: 418.6942508,
      SC: 386.560917,
      ST: 299.2714893,
      EWS: 298.8322791,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 573.2554751,
      OBC: 441.5083184,
      SC: 406.5269753,
      ST: 374.4504813,
      EWS: 347.4857798,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.Com.",
    cutoffs: {
      UR: 659.8421193,
      OBC: 482.9207405,
      SC: 361.1618746,
      ST: 431.9157862,
      EWS: 518.2821948,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 693.45671,
      OBC: 535.1980878,
      SC: 413.1136108,
      ST: 202.9359856,
      EWS: 568.4474455,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 623.4714318,
      OBC: 433.8994044,
      SC: 370.0385325,
      ST: 354.7547524,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 561.0374492,
      OBC: 442.7646449,
      SC: 377.3574841,
      ST: 350.3615741,
      EWS: 405.8515343,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 565.9078016,
      OBC: 451.4367785,
      SC: 393.6984184,
      ST: 402.0003443,
      EWS: 375.4105444,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Hindi + Buddhist Studies)",
    cutoffs: {
      UR: 521.2249308,
      OBC: 359.5210604,
      SC: 322.2142314,
      ST: null,
      EWS: 287.6976789,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 505.4296487,
      OBC: 381.7021015,
      SC: 339.2672393,
      ST: 200.7607345,
      EWS: 286.4962075,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Accounting and Finance + Economics)",
    cutoffs: {
      UR: 678.3667755,
      OBC: 525.5858008,
      SC: 455.0409007,
      ST: 393.9114364,
      EWS: 495.8454268,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Buddhist Studies + Political Science)",
    cutoffs: {
      UR: 579.9187466,
      OBC: 421.7767224,
      SC: 370.607133,
      ST: 298.0262097,
      EWS: 442.2876959,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 583.2252237,
      OBC: 347.8515575,
      SC: 208.9154491,
      ST: 372.0593792,
      EWS: 282.0552521,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Economics + OMSP)",
    cutoffs: {
      UR: 588.9982122,
      OBC: 411.5208117,
      SC: 326.1442764,
      ST: null,
      EWS: 394.8725267,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 541.4897891,
      OBC: 378.3855058,
      SC: 325.5807534,
      ST: 128.9043561,
      EWS: 332.6816504,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (History + Mathematics)",
    cutoffs: {
      UR: 508.0761309,
      OBC: 342.7650831,
      SC: 215.9980135,
      ST: null,
      EWS: 266.9110589,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Political Science + Mathematics)",
    cutoffs: {
      UR: 518.1007781,
      OBC: 363.2485059,
      SC: 228.3138271,
      ST: null,
      EWS: 407.4208752,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 538.4988126,
      OBC: 380.2461877,
      SC: 337.3332967,
      ST: 97.3342387,
      EWS: 205.0569511,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 501.1296804,
      OBC: 370.6098996,
      SC: 333.9567438,
      ST: 158.3598389,
      EWS: 322.2252843,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (Buddhist Studies + Economics)",
    cutoffs: {
      UR: 601.3039162,
      OBC: 461.2169651,
      SC: 387.5090595,
      ST: 221.8825065,
      EWS: 461.7936954,
      PwBD: null,
    },
  },
  {
    collegeName: "Satyawati College (Evening)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 534.1832164,
      OBC: 392.5064946,
      SC: 353.1055332,
      ST: 319.4544812,
      EWS: 306.5770197,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 834.603218,
      OBC: 750.8243722,
      SC: 668.0676122,
      ST: 561.0480302,
      EWS: null,
      PwBD: 148.3164511,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.Com.",
    cutoffs: {
      UR: 809.608382,
      OBC: 731.5150403,
      SC: 641.1905386,
      ST: 421.2029117,
      EWS: 775.4491411,
      PwBD: 317.8025144,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 791.7437926,
      OBC: 612.3389763,
      SC: 545.4008056,
      ST: 155.3539815,
      EWS: 670.9869137,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 761.7340248,
      OBC: 690.5565554,
      SC: 623.5763757,
      ST: 615.2546705,
      EWS: 711.0338696,
      PwBD: 324.0327497,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 791.0693274,
      OBC: 736.2174575,
      SC: 666.4394379,
      ST: 672.3101558,
      EWS: 739.0179734,
      PwBD: 386.5683651,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 782.0841582,
      OBC: 717.3924494,
      SC: 644.7137963,
      ST: 648.2156237,
      EWS: 722.9928037,
      PwBD: 374.6165581,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 350.5435207,
      OBC: 235.5982087,
      SC: 251.8939979,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 732.7792729,
      OBC: 622.5200155,
      SC: 585.6402157,
      ST: 551.231132,
      EWS: 634.9632928,
      PwBD: 397.558711,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 606.1742029,
      OBC: 491.1270949,
      SC: 312.7178091,
      ST: 247.9152674,
      EWS: 529.550626,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 755.0212828,
      OBC: 560.1412143,
      SC: 380.5983851,
      ST: 239.7650128,
      EWS: 655.6398802,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A Program (Geography + Political Science)",
    cutoffs: {
      UR: 762.3717639,
      OBC: 696.0279308,
      SC: 586.3573172,
      ST: 635.1374978,
      EWS: 686.0029319,
      PwBD: 659.6347765,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 772.6290128,
      OBC: 689.9142132,
      SC: 622.9827493,
      ST: 607.3380538,
      EWS: 692.1956102,
      PwBD: 426.2966342,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A Program (Hindi + Geography)",
    cutoffs: {
      UR: 625.1651401,
      OBC: 569.2339364,
      SC: 494.4529945,
      ST: 355.908677,
      EWS: 625.0505876,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 736.1437841,
      OBC: 659.1398126,
      SC: 569.9615337,
      ST: 551.8794539,
      EWS: 654.8411342,
      PwBD: 101.2750487,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 717.4606993,
      OBC: 691.6657156,
      SC: 591.1392096,
      ST: 499.5466139,
      EWS: 717.3909879,
      PwBD: 220.2164931,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 621.7525857,
      OBC: 523.1207154,
      SC: 469.8881926,
      ST: 442.3324458,
      EWS: 434.0359608,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 642.0986322,
      OBC: 528.8579724,
      SC: 444.5008508,
      ST: 465.6490575,
      EWS: 457.417347,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.Com.",
    cutoffs: {
      UR: 722.357053,
      OBC: 582.8545596,
      SC: 453.1273365,
      ST: 176.3391428,
      EWS: 632.9958748,
      PwBD: 608.7619848,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 766.8760399,
      OBC: 687.8582573,
      SC: 594.9629681,
      ST: 479.8033471,
      EWS: 728.7774329,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 666.0416308,
      OBC: 486.8485924,
      SC: 405.4434829,
      ST: 311.738654,
      EWS: 520.9442746,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.A Program (Economics + Geography)",
    cutoffs: {
      UR: 615.9590777,
      OBC: 480.2388956,
      SC: 414.5083431,
      ST: 433.3630561,
      EWS: 780.8769432,
      PwBD: 394.3024216,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 619.8021181,
      OBC: 470.0743486,
      SC: 400.6148475,
      ST: 328.0206889,
      EWS: 305.9045751,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 635.1789291,
      OBC: 522.5000623,
      SC: 417.1531585,
      ST: 332.3293187,
      EWS: 453.4509584,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.A Program (Geography + History)",
    cutoffs: {
      UR: 599.2280359,
      OBC: 509.7475412,
      SC: 480.6897801,
      ST: 469.0130441,
      EWS: 420.1081976,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.A Program (Geography + Political Science)",
    cutoffs: {
      UR: 602.0740644,
      OBC: 512.6030455,
      SC: 444.4856589,
      ST: 516.4800967,
      EWS: 458.1009436,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Bhagat Singh College (Evening)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 591.4262204,
      OBC: 460.3087609,
      SC: 401.8761388,
      ST: 346.2595678,
      EWS: 367.7768715,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 270.5255508,
      OBC: 144.1187308,
      SC: 54.6377131,
      ST: null,
      EWS: 125.6719801,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Instrumentation",
    cutoffs: {
      UR: 193.7593832,
      OBC: 59.3815963,
      SC: 47.5891375,
      ST: null,
      EWS: 159.4206395,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Food Technology",
    cutoffs: {
      UR: 514.5162884,
      OBC: 441.9809162,
      SC: 367.5997277,
      ST: 312.2092022,
      EWS: 440.2570873,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 598.5433676,
      OBC: 481.0154826,
      SC: 297.7565726,
      ST: 88.8783503,
      EWS: 427.8276614,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Biomedical Science",
    cutoffs: {
      UR: 523.8130407,
      OBC: 477.8194535,
      SC: 414.0575805,
      ST: 350.2280686,
      EWS: 492.069498,
      PwBD: 136.31042,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 276.3198906,
      OBC: 144.0143774,
      SC: 128.8266475,
      ST: null,
      EWS: 107.3393559,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 533.1786511,
      OBC: 364.5664362,
      SC: 270.741947,
      ST: null,
      EWS: 440.2550817,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 328.6124646,
      OBC: 248.0007914,
      SC: 158.1761064,
      ST: 82.6137118,
      EWS: 235.3518764,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 784.8566974,
      OBC: 602.1533355,
      SC: 602.2640111,
      ST: 503.9900893,
      EWS: 568.6136271,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Statistics",
    cutoffs: {
      UR: 655.5356786,
      OBC: 443.8817145,
      SC: 343.0837373,
      ST: 146.1852359,
      EWS: 499.3818806,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Microbiology",
    cutoffs: {
      UR: 557.1899565,
      OBC: 474.3936989,
      SC: 396.2258743,
      ST: 332.502552,
      EWS: 477.9051099,
      PwBD: 286.9700295,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName:
      "Bachelor of Business Administration (Financial Investment Analysis)",
    cutoffs: {
      UR: 443.2713789,
      OBC: 358.8343906,
      SC: 305.2300558,
      ST: 112.2312648,
      EWS: 371.4587272,
      PwBD: 284.878882,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "Bachelor of Management Studies",
    cutoffs: {
      UR: 428.0605668,
      OBC: 334.2414748,
      SC: 282.9228568,
      ST: 123.303727,
      EWS: 352.241561,
      PwBD: 357.1897455,
    },
  },
  {
    collegeName: "Shaheed Rajguru College of Applied Sciences for Women (W)",
    programName: "B.Sc. (Hons.) Biochemistry",
    cutoffs: {
      UR: 504.297185,
      OBC: 466.5378119,
      SC: 381.6411676,
      ST: 316.38937,
      EWS: 393.0650168,
      PwBD: null,
    },
  },
  {
    collegeName: "Shaheed Sukhdev College Business Studies",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 761.2212666,
      OBC: 632.298833,
      SC: 566.4978168,
      ST: 324.1302679,
      EWS: 690.9061733,
      PwBD: 224.2473032,
    },
  },
  {
    collegeName: "Shaheed Sukhdev College Business Studies",
    programName: "Bachelor of Management Studies",
    cutoffs: {
      UR: 554.9995191,
      OBC: 436.1153624,
      SC: 378.8527709,
      ST: 264.3901534,
      EWS: 484.2878358,
      PwBD: 353.4399063,
    },
  },
  {
    collegeName: "Shaheed Sukhdev College Business Studies",
    programName:
      "Bachelor of Business Administration (Financial Investment Analysis)",
    cutoffs: {
      UR: 577.2048687,
      OBC: 470.3525885,
      SC: 396.4176702,
      ST: 312.8541803,
      EWS: 522.0328726,
      PwBD: 378.4217437,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 725.3233387,
      OBC: 455.8389493,
      SC: 364.9041252,
      ST: 159.8894025,
      EWS: 481.3977413,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 661.2170478,
      OBC: 519.9965363,
      SC: 468.050563,
      ST: 461.1861904,
      EWS: 485.5329686,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 695.3320009,
      OBC: 610.8716098,
      SC: 533.1715191,
      ST: 551.9568985,
      EWS: 513.7938959,
      PwBD: 294.4846003,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 299.2040018,
      OBC: 146.8188473,
      SC: 122.3886129,
      ST: null,
      EWS: 249.2521615,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 648.120373,
      OBC: 544.4998756,
      SC: 477.0884406,
      ST: 280.2765337,
      EWS: 467.68459,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 679.3624692,
      OBC: 620.1814192,
      SC: 597.0209353,
      ST: 570.6955275,
      EWS: 574.3335517,
      PwBD: 205.4439835,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 341.8807153,
      OBC: 99.9770765,
      SC: 160.0981837,
      ST: null,
      EWS: 176.4937694,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.Com.",
    cutoffs: {
      UR: 750.4251109,
      OBC: 602.9481146,
      SC: 515.9861883,
      ST: 244.1243503,
      EWS: 641.5885157,
      PwBD: 531.8286948,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 772.5748756,
      OBC: 647.7921436,
      SC: 560.9689996,
      ST: 430.4330448,
      EWS: 669.9332449,
      PwBD: 416.8524369,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 470.55584,
      OBC: 414.7367097,
      SC: 309.2684163,
      ST: 217.098193,
      EWS: 413.6084501,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 295.1374231,
      OBC: 222.0222302,
      SC: 148.0990589,
      ST: 80.9638614,
      EWS: 223.0993147,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 255.306065,
      OBC: 187.958117,
      SC: 122.0990081,
      ST: null,
      EWS: 201.5348571,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.Sc. (Hons.) Biochemistry",
    cutoffs: {
      UR: 574.6532579,
      OBC: 504.1354484,
      SC: 428.395658,
      ST: 377.3514902,
      EWS: 495.3230133,
      PwBD: 107.9628215,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 504.7416933,
      OBC: 439.7221123,
      SC: 332.2236764,
      ST: 314.9394823,
      EWS: 423.1426607,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 334.4835066,
      OBC: 277.6956154,
      SC: 168.051539,
      ST: 117.8105726,
      EWS: 301.499002,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 539.6499843,
      OBC: 410.7618062,
      SC: 294.3258431,
      ST: 113.9372301,
      EWS: 387.2400354,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 337.9872537,
      OBC: 255.3144343,
      SC: 117.9148244,
      ST: 11.929582,
      EWS: 242.0547072,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 531.9565773,
      OBC: 462.7148427,
      SC: 394.085688,
      ST: 342.147345,
      EWS: 454.0200584,
      PwBD: 296.6260865,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A. (Hons.) Business Economics",
    cutoffs: {
      UR: 425.7062509,
      OBC: 289.700053,
      SC: 201.2728293,
      ST: null,
      EWS: 303.1513227,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 628.4677454,
      OBC: 510.5350036,
      SC: 444.8534797,
      ST: 420.2220026,
      EWS: 446.7999384,
      PwBD: 171.6787373,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A Program (English + Sociology)",
    cutoffs: {
      UR: 660.7272261,
      OBC: 536.9819255,
      SC: 498.0944979,
      ST: 541.9383827,
      EWS: 459.2542929,
      PwBD: 239.9440512,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A Program (Geography + History)",
    cutoffs: {
      UR: 636.8544041,
      OBC: 531.3171192,
      SC: 490.8736684,
      ST: 521.0073829,
      EWS: 498.5309065,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 562.9847006,
      OBC: 439.4531817,
      SC: 387.9138548,
      ST: 390.8721652,
      EWS: 151.0362926,
      PwBD: 287.7225032,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A Program (Geography + Political Science)",
    cutoffs: {
      UR: 667.0951283,
      OBC: 565.1976022,
      SC: 543.3393915,
      ST: 534.9673164,
      EWS: 517.3117898,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 574.8553691,
      OBC: 442.4334738,
      SC: 492.9151923,
      ST: 220.8673419,
      EWS: 180.2014664,
      PwBD: 228.4946651,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 653.3110407,
      OBC: 517.5513012,
      SC: 458.1264519,
      ST: 430.3436663,
      EWS: 550.9499392,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A Program (Hindi + Geography)",
    cutoffs: {
      UR: 571.3451072,
      OBC: 494.8709302,
      SC: 446.891674,
      ST: 224.8921695,
      EWS: 136.11022,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A Program (Economics + Geography)",
    cutoffs: {
      UR: 660.6636436,
      OBC: 568.1345592,
      SC: 488.8454591,
      ST: 495.902238,
      EWS: 536.8953714,
      PwBD: null,
    },
  },
  {
    collegeName: "Shivaji College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 687.4079666,
      OBC: 526.7279461,
      SC: 478.0959371,
      ST: 410.7675903,
      EWS: 545.5838861,
      PwBD: null,
    },
  },
  {
    collegeName: "Shri Ram College of Commerce",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 917.4305733,
      OBC: 849.420209,
      SC: 776.8558529,
      ST: 715.1288939,
      EWS: 874.1215703,
      PwBD: 726.8842867,
    },
  },
  {
    collegeName: "Shri Ram College of Commerce",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 908.9028325,
      OBC: 802.255158,
      SC: 722.7448906,
      ST: 609.9305017,
      EWS: 824.3039519,
      PwBD: 610.2727581,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 671.2185635,
      OBC: 395.2176791,
      SC: 306.201128,
      ST: 282.4237935,
      EWS: 382.2807123,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 628.7033492,
      OBC: 469.9402721,
      SC: 433.8796207,
      ST: 289.3162288,
      EWS: 451.3136349,
      PwBD: 435.6237353,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 309.1984296,
      OBC: 148.5328412,
      SC: 128.1225516,
      ST: null,
      EWS: null,
      PwBD: 250.6418818,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 621.173742,
      OBC: 495.8895523,
      SC: 451.1741215,
      ST: 376.2728364,
      EWS: 186.7210809,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 646.6519169,
      OBC: 581.7043542,
      SC: 518.825494,
      ST: 533.8366079,
      EWS: 499.9206188,
      PwBD: 154.7020682,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.Com.",
    cutoffs: {
      UR: 706.4693439,
      OBC: 548.4529954,
      SC: 450.3599091,
      ST: 223.3914148,
      EWS: 585.5814968,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 731.617637,
      OBC: 587.0032949,
      SC: 499.5006794,
      ST: 239.3770816,
      EWS: 608.5006545,
      PwBD: 367.5172374,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.Sc (Prog.) Physical Science with Electronics",
    cutoffs: {
      UR: 215.9496934,
      OBC: 126.8766332,
      SC: 26.9637124,
      ST: 112.2584078,
      EWS: 41.666654,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 195.6974946,
      OBC: 99.7881213,
      SC: 68.8004872,
      ST: null,
      EWS: 104.3839054,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 293.1987248,
      OBC: 205.1596906,
      SC: 153.7312044,
      ST: 19.2584624,
      EWS: 199.9169897,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 340.0651504,
      OBC: 281.3094269,
      SC: 126.9513974,
      ST: null,
      EWS: 268.3976672,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 524.7399443,
      OBC: 415.8459159,
      SC: 301.1037432,
      ST: 177.39105,
      EWS: 405.8082261,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A Program (Economics + OMSP)",
    cutoffs: {
      UR: 617.7742351,
      OBC: 442.9860395,
      SC: 376.251952,
      ST: 205.1037411,
      EWS: 427.1111049,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 664.4040821,
      OBC: 504.8182517,
      SC: 443.6297528,
      ST: 413.65746,
      EWS: 530.7733223,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 627.8169572,
      OBC: 516.1977121,
      SC: 495.5699363,
      ST: 534.8011158,
      EWS: 483.9331044,
      PwBD: 309.3908932,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 614.0500317,
      OBC: 469.562878,
      SC: 429.6899418,
      ST: 362.8266204,
      EWS: 368.4615832,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 603.7805407,
      OBC: 462.1833519,
      SC: 430.9563288,
      ST: 442.8304531,
      EWS: 352.3028001,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 536.3451222,
      OBC: 420.5084786,
      SC: 383.5595987,
      ST: 353.2869438,
      EWS: 389.5163205,
      PwBD: 299.8870281,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.Com.",
    cutoffs: {
      UR: 642.7733352,
      OBC: 467.8127255,
      SC: 351.3500388,
      ST: null,
      EWS: 493.5117331,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 682.3760735,
      OBC: 524.0602907,
      SC: 429.7057424,
      ST: 134.2666653,
      EWS: 551.5300041,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 614.7962091,
      OBC: 339.8346068,
      SC: 147.733358,
      ST: null,
      EWS: 182.582409,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 215.3397441,
      OBC: 108.4140088,
      SC: 221.0245691,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 569.7381186,
      OBC: 435.8754415,
      SC: 389.5330867,
      ST: 356.5702245,
      EWS: 214.6866006,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 622.0627556,
      OBC: 428.82495,
      SC: 368.6495916,
      ST: 288.3107153,
      EWS: 465.1762284,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 533.7855061,
      OBC: 395.2281147,
      SC: 341.7523996,
      ST: 315.2305453,
      EWS: 297.3319631,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 580.1522809,
      OBC: 464.2767848,
      SC: 384.7627909,
      ST: 228.033071,
      EWS: 438.0549397,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 583.1059246,
      OBC: 365.0500144,
      SC: 216.3765331,
      ST: null,
      EWS: 297.306792,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (History + Mathematics)",
    cutoffs: {
      UR: 499.9899346,
      OBC: 342.6897923,
      SC: 240.3930813,
      ST: 339.4957423,
      EWS: 278.0719975,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (English + Computer Applications)",
    cutoffs: {
      UR: 577.490761,
      OBC: 454.6682011,
      SC: 409.8209575,
      ST: 257.4711244,
      EWS: 267.8903351,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 550.7595136,
      OBC: 413.0256499,
      SC: 389.1090741,
      ST: 348.6901472,
      EWS: 291.4627163,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (Hindi + Computer Applications)",
    cutoffs: {
      UR: 499.6011904,
      OBC: 346.2437445,
      SC: 263.1734175,
      ST: null,
      EWS: 226.6917265,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (Hindi + Economics)",
    cutoffs: {
      UR: 534.3845536,
      OBC: 376.3317507,
      SC: 315.9319384,
      ST: 254.9925883,
      EWS: 314.7251677,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 494.2192728,
      OBC: 360.6517961,
      SC: 331.2037225,
      ST: null,
      EWS: 191.5622127,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (Computer Applications + Political Science)",
    cutoffs: {
      UR: 554.1707877,
      OBC: 397.2755539,
      SC: 303.0731719,
      ST: 102.5920285,
      EWS: 368.4336892,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyam Lal College (Evening)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 552.3379932,
      OBC: 385.3598263,
      SC: 337.7210716,
      ST: 242.3978744,
      EWS: 291.6131998,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A. (Hons.) Applied Psychology",
    cutoffs: {
      UR: 758.7453498,
      OBC: 559.9979159,
      SC: 518.2380496,
      ST: 465.1192647,
      EWS: 513.4827605,
      PwBD: 494.4113935,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 642.2040066,
      OBC: 318.6194623,
      SC: 171.1495332,
      ST: null,
      EWS: 148.0090824,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 646.1607811,
      OBC: 477.5064968,
      SC: 455.0726341,
      ST: 128.5236472,
      EWS: 450.3446481,
      PwBD: 315.8452531,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 228.5458,
      OBC: null,
      SC: 191.4319168,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 613.3715587,
      OBC: 455.62467,
      SC: 437.441659,
      ST: 324.9842417,
      EWS: 325.7641832,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 622.2888344,
      OBC: 493.5244505,
      SC: 425.9484325,
      ST: 427.13171,
      EWS: 390.9664047,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 486.9658098,
      OBC: 275.835463,
      SC: 243.5977,
      ST: 225.7621568,
      EWS: 214.4734316,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 560.4703842,
      OBC: 386.1978701,
      SC: 319.0650127,
      ST: 229.7181753,
      EWS: 322.5233427,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 642.9261828,
      OBC: 510.4540121,
      SC: 446.9896631,
      ST: 362.9826452,
      EWS: 340.6268679,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 161.2746445,
      OBC: 137.9655266,
      SC: 105.5584344,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 711.4523667,
      OBC: 538.1609278,
      SC: 451.1538965,
      ST: 291.1086646,
      EWS: 567.6392925,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 669.3297991,
      OBC: 487.06102,
      SC: 380.1343121,
      ST: 220.178244,
      EWS: 511.9660432,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 549.8296384,
      OBC: 466.1549317,
      SC: 384.0024846,
      ST: 179.2723479,
      EWS: 434.6836757,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "Bachelor of Elementary Education",
    cutoffs: {
      UR: 618.5899182,
      OBC: 527.9907437,
      SC: 518.0407669,
      ST: 241.3820653,
      EWS: 453.1377102,
      PwBD: 198.8837481,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Hindi + Geography)",
    cutoffs: {
      UR: 563.0458545,
      OBC: 497.6101381,
      SC: 423.7273428,
      ST: null,
      EWS: 318.47467,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 512.7909172,
      OBC: 372.8463112,
      SC: 361.5548625,
      ST: null,
      EWS: 215.8133076,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Hindi + Philosophy)",
    cutoffs: {
      UR: 533.2864069,
      OBC: 353.9278799,
      SC: 328.0681452,
      ST: 321.1247395,
      EWS: 208.6834981,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 522.1188787,
      OBC: 382.029278,
      SC: 373.7989643,
      ST: null,
      EWS: 229.5699981,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 181.2147276,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Sanskrit + Music)",
    cutoffs: { UR: null, OBC: null, SC: null, ST: null, EWS: null, PwBD: null },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 242.8763188,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 604.2902858,
      OBC: 363.1960452,
      SC: 146.3684966,
      ST: null,
      EWS: 380.1757771,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Computer Applications + Geography)",
    cutoffs: {
      UR: 532.3422769,
      OBC: 263.7291183,
      SC: 267.8548175,
      ST: null,
      EWS: 252.1645323,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 562.1549417,
      OBC: 432.8915051,
      SC: 218.6934089,
      ST: 145.1565497,
      EWS: 397.2856107,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Economics + Food Technology)",
    cutoffs: {
      UR: 586.6505543,
      OBC: 435.6616391,
      SC: 342.2184344,
      ST: null,
      EWS: 458.6466892,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Economics + Geography)",
    cutoffs: {
      UR: 601.8147488,
      OBC: 483.9856138,
      SC: 377.0788621,
      ST: 360.3059139,
      EWS: 375.8655916,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 597.0446622,
      OBC: 459.8387695,
      SC: 462.9529704,
      ST: 367.852772,
      EWS: 297.3879123,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 616.9029056,
      OBC: 268.708814,
      SC: 201.3866728,
      ST: null,
      EWS: 274.3800999,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Economics + Philosophy)",
    cutoffs: {
      UR: 584.9696361,
      OBC: 388.1749336,
      SC: 304.7869377,
      ST: null,
      EWS: 245.7189581,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 601.1459421,
      OBC: 423.3204507,
      SC: 357.7489505,
      ST: 146.7938745,
      EWS: 298.0444896,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Economics + Sociology)",
    cutoffs: {
      UR: 597.7833877,
      OBC: 427.4091517,
      SC: 359.0851577,
      ST: 138.6965111,
      EWS: 332.2585661,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Food Technology (FT) + History)",
    cutoffs: {
      UR: 520.6377064,
      OBC: 383.2254847,
      SC: 330.177008,
      ST: 247.8675836,
      EWS: 297.4867885,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Geography + History)",
    cutoffs: {
      UR: 626.7621296,
      OBC: 514.5324797,
      SC: 427.3799842,
      ST: 494.2822399,
      EWS: 476.7139516,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Geography + Mathematics)",
    cutoffs: {
      UR: 529.8381195,
      OBC: 341.3625696,
      SC: 251.6110984,
      ST: null,
      EWS: 233.0000692,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Geography + Political Science)",
    cutoffs: {
      UR: 634.3394667,
      OBC: 526.0170954,
      SC: 484.7452566,
      ST: 464.0681632,
      EWS: 414.8870215,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (History + Music)",
    cutoffs: {
      UR: 472.7168529,
      OBC: 227.0535648,
      SC: 217.0035321,
      ST: null,
      EWS: 171.1395499,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (History + Philosophy)",
    cutoffs: {
      UR: 575.0646227,
      OBC: 422.7590785,
      SC: 384.0924616,
      ST: 232.3030668,
      EWS: 226.7791685,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 602.2596445,
      OBC: 441.2264998,
      SC: 412.1980924,
      ST: 328.3142053,
      EWS: 308.8252132,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (History + Sociology)",
    cutoffs: {
      UR: 590.4639499,
      OBC: 462.2745081,
      SC: 389.9242653,
      ST: 413.4510256,
      EWS: 264.385132,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Political Science)",
    cutoffs: {
      UR: 524.4021584,
      OBC: 325.224556,
      SC: 268.7682055,
      ST: 260.5492665,
      EWS: 394.6366113,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName:
      "B.A Program (Human Development and Family Empowerment (HDFE) + Sociology)",
    cutoffs: {
      UR: 545.9271513,
      OBC: 334.4971184,
      SC: 292.0814269,
      ST: null,
      EWS: 440.6444291,
      PwBD: 216.8543642,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Music + Political Science)",
    cutoffs: {
      UR: 470.8729616,
      OBC: 213.1413274,
      SC: 177.4554924,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 576.5044575,
      OBC: 406.2160939,
      SC: 408.3066735,
      ST: 361.2883767,
      EWS: 290.9751911,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Sanskrit + Philosophy)",
    cutoffs: {
      UR: 263.023004,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Shyama Prasad Mukherji College For Women (W)",
    programName: "B.A Program (Hindi + Sociology)",
    cutoffs: {
      UR: 563.502101,
      OBC: 398.9966685,
      SC: 430.1310781,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 659.5286836,
      OBC: 513.4622522,
      SC: 464.4742528,
      ST: 437.8887726,
      EWS: 500.6516745,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 271.0176168,
      OBC: 154.0281068,
      SC: 74.2255981,
      ST: null,
      EWS: 187.3911599,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 704.8777672,
      OBC: 616.423269,
      SC: 546.8540786,
      ST: 548.531133,
      EWS: 568.4456006,
      PwBD: 325.7529743,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.Com.",
    cutoffs: {
      UR: 754.0023219,
      OBC: 612.2409215,
      SC: 502.7764696,
      ST: 205.5058992,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 787.7812285,
      OBC: 674.4856458,
      SC: 579.1940477,
      ST: 382.5219393,
      EWS: 704.3162737,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 486.3922567,
      OBC: 400.4561265,
      SC: 333.596257,
      ST: 236.300784,
      EWS: 409.9501399,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 313.778149,
      OBC: 234.3005184,
      SC: 53.8896157,
      ST: 40.9409113,
      EWS: 234.1109081,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 208.4890402,
      OBC: 102.7234708,
      SC: 68.0739002,
      ST: null,
      EWS: 77.5781691,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.A Program (Sanskrit + Economics)",
    cutoffs: {
      UR: 482.9487289,
      OBC: 310.9630674,
      SC: null,
      ST: null,
      EWS: 282.0523551,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 291.6851903,
      OBC: 133.8888673,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 384.9347277,
      OBC: 127.6855237,
      SC: 154.3420401,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.A Program (Commerce + Economics)",
    cutoffs: {
      UR: 706.7708528,
      OBC: 534.9323044,
      SC: 458.2941842,
      ST: 269.8069589,
      EWS: 566.0612593,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 621.1729836,
      OBC: 462.9174688,
      SC: 406.6987305,
      ST: 350.0462352,
      EWS: 397.3208865,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 628.0831605,
      OBC: 464.5775036,
      SC: 427.7588452,
      ST: 394.0404095,
      EWS: 450.6700436,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 606.99049,
      OBC: 483.1760249,
      SC: 418.1114594,
      ST: 388.9063463,
      EWS: 203.9172073,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 596.6163705,
      OBC: 426.5124507,
      SC: 380.4839538,
      ST: 326.9984717,
      EWS: 398.0926512,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 635.6488021,
      OBC: 342.9363749,
      SC: 232.7065447,
      ST: null,
      EWS: 333.3637016,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.Com.",
    cutoffs: {
      UR: 652.4633474,
      OBC: 475.0682174,
      SC: 355.9974453,
      ST: 257.5378758,
      EWS: 503.3753713,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 691.1509058,
      OBC: 542.8213499,
      SC: 433.6632155,
      ST: 331.3930092,
      EWS: 592.328529,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 202.9213383,
      OBC: 165.7410697,
      SC: 254.1229875,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A. (Hons.) Applied Psychology",
    cutoffs: {
      UR: 731.0672182,
      OBC: 549.2807133,
      SC: 494.6022551,
      ST: 427.4096293,
      EWS: 444.9507568,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 553.9515936,
      OBC: 413.71419,
      SC: 371.5746925,
      ST: 381.4810542,
      EWS: 207.4774379,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 547.0063855,
      OBC: 379.5010477,
      SC: 326.1217575,
      ST: 223.3592159,
      EWS: 324.1852636,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 543.1618594,
      OBC: 385.936805,
      SC: 335.0169704,
      ST: 249.0879085,
      EWS: 335.8992044,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (Economics + Music)",
    cutoffs: {
      UR: 641.0681157,
      OBC: 478.3869512,
      SC: 378.2868767,
      ST: 335.1837147,
      EWS: 335.1031241,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 564.4572666,
      OBC: 459.6856773,
      SC: 382.5787468,
      ST: 439.3250855,
      EWS: 244.6524212,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (English + Sanskrit)",
    cutoffs: {
      UR: 485.4698712,
      OBC: 281.4485213,
      SC: 225.4842789,
      ST: null,
      EWS: 237.0470341,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 496.4835085,
      OBC: 356.5940435,
      SC: 330.0418206,
      ST: null,
      EWS: 259.8895699,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 497.2618171,
      OBC: 362.9966601,
      SC: 332.2907592,
      ST: 149.4968551,
      EWS: 269.2085957,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (Hindi + Music)",
    cutoffs: {
      UR: 612.6222239,
      OBC: 410.1883369,
      SC: 407.7932852,
      ST: 228.0913995,
      EWS: 274.6523468,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (Hindi + Sanskrit)",
    cutoffs: {
      UR: 434.6826251,
      OBC: 173.2397911,
      SC: 225.0272269,
      ST: null,
      EWS: 227.4259477,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (Hindi + Physical Education)",
    cutoffs: {
      UR: 511.6963301,
      OBC: 391.7346935,
      SC: 362.3112996,
      ST: null,
      EWS: 377.1070619,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 535.8175929,
      OBC: 393.9352251,
      SC: 342.0559174,
      ST: 320.6644569,
      EWS: 131.9151245,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (History + Physical Education)",
    cutoffs: {
      UR: 535.5716199,
      OBC: 405.9234772,
      SC: 425.8222729,
      ST: 421.6116552,
      EWS: 324.1360769,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (History + Music)",
    cutoffs: {
      UR: 536.8453208,
      OBC: 433.7579368,
      SC: 411.9913327,
      ST: 314.9467566,
      EWS: 297.8414287,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (English + Music)",
    cutoffs: {
      UR: 644.1680889,
      OBC: 494.1677876,
      SC: 481.195017,
      ST: 301.4778249,
      EWS: 425.7525651,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (English + Physical Education)",
    cutoffs: {
      UR: 582.2669472,
      OBC: 519.2772362,
      SC: 478.0964281,
      ST: 432.9063825,
      EWS: 437.8517932,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (Economics + Sanskrit)",
    cutoffs: {
      UR: 522.4752923,
      OBC: 217.0585207,
      SC: 320.0655185,
      ST: null,
      EWS: 238.6046932,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (Economics + Physical Education)",
    cutoffs: {
      UR: 600.2915514,
      OBC: 469.9906593,
      SC: 459.517079,
      ST: 285.4653571,
      EWS: 417.4743068,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Aurobindo College (Evening)",
    programName: "B.A Program (History + Sanskrit)",
    cutoffs: {
      UR: 404.5941377,
      OBC: 177.429788,
      SC: 282.40334,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Gobind Singh College of Commerce",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 860.4803068,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 451.447563,
    },
  },
  {
    collegeName: "Sri Guru Gobind Singh College of Commerce",
    programName: "B.Com.",
    cutoffs: {
      UR: 842.7418525,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 321.7444823,
    },
  },
  {
    collegeName: "Sri Guru Gobind Singh College of Commerce",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 806.3901992,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Gobind Singh College of Commerce",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 642.4849615,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 223.4881666,
    },
  },
  {
    collegeName: "Sri Guru Gobind Singh College of Commerce",
    programName: "B.A. (Hons.) Business Economics",
    cutoffs: {
      UR: 511.5607359,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 195.9861844,
    },
  },
  {
    collegeName: "Sri Guru Gobind Singh College of Commerce",
    programName: "Bachelor of Management Studies",
    cutoffs: {
      UR: 538.2360934,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 280.8409881,
    },
  },
  {
    collegeName: "Sri Guru Gobind Singh College of Commerce",
    programName: "B.A. (Hons.) Punjabi",
    cutoffs: {
      UR: 153.405099,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 586.5788189,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 784.0773968,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 661.8100592,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 347.7723334,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 312.8042095,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A. (Hons.) Punjabi",
    cutoffs: {
      UR: 428.7557352,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 679.5666628,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 201.3301826,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 715.0577075,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A. (Hons.) Hindi Patrakarita",
    cutoffs: {
      UR: 315.93252,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 362.5834572,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.Com.",
    cutoffs: {
      UR: 718.3741502,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 200.6212497,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A. (Hons.) Business Economics",
    cutoffs: {
      UR: 435.5621045,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 510.0487562,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 694.2550692,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 688.1075454,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 409.2037648,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A Program (Punjabi + Economics)",
    cutoffs: {
      UR: 472.0943587,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A Program (Punjabi + History)",
    cutoffs: {
      UR: 336.5404072,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 665.8007069,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 251.4824782,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 649.1656938,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 351.2472121,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A Program (Punjabi + Political Science)",
    cutoffs: {
      UR: 365.4007599,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 655.5765489,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 292.0745624,
    },
  },
  {
    collegeName: "Sri Guru Nanak Dev Khalsa College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 682.506651,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 744.2079967,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 446.4060757,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 381.8734385,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 175.1055452,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A. (Hons.) Punjabi",
    cutoffs: {
      UR: 189.0328225,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 144.7231893,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Sc. (Hons.) Computer Science",
    cutoffs: {
      UR: 704.6619261,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 220.9604313,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 823.1386267,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 806.7009839,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 579.0032522,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 855.276484,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 648.7689942,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 852.0423109,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 559.4080475,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Com.",
    cutoffs: {
      UR: 855.6876072,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 523.0072903,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 492.5251975,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 373.3067792,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 425.495357,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 673.2117933,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 328.9024484,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 517.8477795,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 174.3294008,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 236.0877048,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 426.9747272,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A. (Hons.) Business Economics",
    cutoffs: {
      UR: 499.7900255,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 263.4536124,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 555.4420585,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 153.8101728,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 807.6362644,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 418.6688903,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 826.276542,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A Program (Economics + Music)",
    cutoffs: {
      UR: 799.0732001,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 815.5963411,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 444.4518021,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A Program (History + Music)",
    cutoffs: {
      UR: 721.8403848,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 812.0280624,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: 623.2207915,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A Program (Mathematics + Music)",
    cutoffs: {
      UR: 672.0508353,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Guru Tegh Bahadur Khalsa College",
    programName: "B.A Program (Mathematics + Political Science)",
    cutoffs: {
      UR: 781.9023773,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Com.",
    cutoffs: {
      UR: 867.1498789,
      OBC: 790.8675104,
      SC: 717.7613138,
      ST: 640.3259713,
      EWS: 824.2333567,
      PwBD: 543.0986128,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 879.6441187,
      OBC: 805.3673431,
      SC: 727.4312349,
      ST: 660.3737733,
      EWS: 826.7883825,
      PwBD: 585.4308181,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 816.2592809,
      OBC: 712.5766221,
      SC: 663.3144302,
      ST: 624.3419624,
      EWS: 738.7742111,
      PwBD: 473.1476772,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 454.936089,
      OBC: 369.6740614,
      SC: 359.3980653,
      ST: 261.0404096,
      EWS: 173.9801669,
      PwBD: 279.2373341,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 228.0062347,
      OBC: 332.6364111,
      SC: 200.4940679,
      ST: 253.8324682,
      EWS: 304.3679567,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 831.2700843,
      OBC: 671.1751361,
      SC: 605.5589997,
      ST: 399.785118,
      EWS: 719.7551267,
      PwBD: 505.5102185,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 830.927953,
      OBC: 774.0696162,
      SC: 704.3504968,
      ST: 707.3550675,
      EWS: 796.4298554,
      PwBD: 543.0876492,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 875.0768343,
      OBC: 836.0191866,
      SC: 759.2198439,
      ST: 753.3846531,
      EWS: 830.1149771,
      PwBD: 729.7192378,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A. (Hons.) Sociology",
    cutoffs: {
      UR: 808.9428297,
      OBC: 731.2297924,
      SC: 630.9508638,
      ST: 633.3126913,
      EWS: 724.6461743,
      PwBD: 521.9217534,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 540.4310953,
      OBC: 507.9805644,
      SC: 408.4897652,
      ST: 342.3391485,
      EWS: 465.3808121,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 459.9986259,
      OBC: 368.9186114,
      SC: 288.7369263,
      ST: 166.23616,
      EWS: 404.6652863,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 436.7141792,
      OBC: 373.0564397,
      SC: 272.3957306,
      ST: 59.9490623,
      EWS: 359.040128,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 520.3365033,
      OBC: 465.7749919,
      SC: 435.7619211,
      ST: 416.0636903,
      EWS: 542.1594334,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 576.9996898,
      OBC: 574.3002423,
      SC: 500.4114198,
      ST: 434.3914847,
      EWS: null,
      PwBD: 248.9643234,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Sc. (Hons.) Biological Science",
    cutoffs: {
      UR: 558.0177755,
      OBC: 519.0243861,
      SC: 438.1847865,
      ST: 420.9923253,
      EWS: 535.2817269,
      PwBD: 134.565873,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Sc. (Hons.) Biochemistry",
    cutoffs: {
      UR: 623.8098095,
      OBC: 587.2391957,
      SC: 500.1597787,
      ST: 411.6610018,
      EWS: 577.9857618,
      PwBD: 419.6330618,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 373.8652276,
      OBC: 313.4507969,
      SC: 182.6646439,
      ST: 139.5525973,
      EWS: 361.6240157,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 712.7102627,
      OBC: 571.4718781,
      SC: 471.6655852,
      ST: 189.732332,
      EWS: 598.8619152,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.Sc. (Hons.) Statistics",
    cutoffs: {
      UR: 806.7343972,
      OBC: 615.6383154,
      SC: 526.9928901,
      ST: 404.4966577,
      EWS: 663.8214854,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 832.2440879,
      OBC: 731.7028006,
      SC: 722.9179154,
      ST: 721.6027253,
      EWS: 773.9781625,
      PwBD: 628.6769944,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A Program (Tamil + Political Science/History)",
    cutoffs: {
      UR: 460.778829,
      OBC: 399.0130666,
      SC: 165.6803383,
      ST: null,
      EWS: 324.8431528,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A Program (Hindi + History/Sociology)",
    cutoffs: {
      UR: 780.2297084,
      OBC: 698.2529912,
      SC: 663.508465,
      ST: 563.5128957,
      EWS: 692.3735542,
      PwBD: 470.2376397,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A Program (Sanskrit +Sociology/History)",
    cutoffs: {
      UR: 605.8628816,
      OBC: 492.6849498,
      SC: 309.2225802,
      ST: 356.5973641,
      EWS: 477.9022351,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A Program (English + Sociology/Economics)",
    cutoffs: {
      UR: 823.7006746,
      OBC: 683.1238319,
      SC: 660.9710826,
      ST: 665.082258,
      EWS: 770.2148169,
      PwBD: 671.8615812,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A Program (Economics + Mathematics/Statistics/Sociology)",
    cutoffs: {
      UR: 816.4482676,
      OBC: 698.7379706,
      SC: 669.6434187,
      ST: 626.9868736,
      EWS: 714.7832633,
      PwBD: null,
    },
  },
  {
    collegeName: "Sri Venkateswara College",
    programName: "B.A Program (Telegu + Political Science/History)",
    cutoffs: {
      UR: 545.3358616,
      OBC: 436.5101208,
      SC: 240.6739756,
      ST: 347.123438,
      EWS: 504.5920051,
      PwBD: null,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 926.9288845,
      OBC: null,
      SC: 819.7463565,
      ST: 852.5191587,
      EWS: null,
      PwBD: 739.7538259,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 904.6216142,
      OBC: null,
      SC: 726.2703661,
      ST: 741.5417062,
      EWS: null,
      PwBD: 637.9490296,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 918.7180959,
      OBC: null,
      SC: 844.4037083,
      ST: 890.5619824,
      EWS: null,
      PwBD: 854.4857911,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 906.743835,
      OBC: null,
      SC: 787.98542,
      ST: 737.4256445,
      EWS: null,
      PwBD: 665.3892507,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 694.41179,
      OBC: null,
      SC: 668.8346023,
      ST: 598.6426871,
      EWS: null,
      PwBD: 655.9877497,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 807.3221953,
      OBC: null,
      SC: 651.897836,
      ST: 706.7955674,
      EWS: null,
      PwBD: 391.0499651,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 522.1927387,
      OBC: null,
      SC: 486.4898159,
      ST: 418.6426844,
      EWS: null,
      PwBD: 124.0041337,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 550.6452034,
      OBC: null,
      SC: 286.4630769,
      ST: 356.8354325,
      EWS: null,
      PwBD: 151.6557262,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 487.3686726,
      OBC: null,
      SC: 376.2821982,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName:
      "B.Sc (Prog.) Physical Science with Computer Science/ Informatics Practices",
    cutoffs: {
      UR: 442.5546293,
      OBC: null,
      SC: 403.0071813,
      ST: 244.1844521,
      EWS: null,
      PwBD: 119.075471,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName:
      "B.A. Program (Urdu + Any other discipline subject from (Economics/History/Political Science/Philosophy))",
    cutoffs: {
      UR: 726.1926635,
      OBC: null,
      SC: null,
      ST: 587.8343077,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "St. Stephen's College",
    programName:
      "B.A. Program (Any two discipline out of these (Economics/English/History/Political Science/Philosophy))",
    cutoffs: {
      UR: 912.5744652,
      OBC: null,
      SC: 826.9340686,
      ST: null,
      EWS: null,
      PwBD: 839.1807657,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 443.0399019,
      OBC: 398.6694849,
      SC: 297.0227914,
      ST: 194.7311571,
      EWS: 407.5161058,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 619.0128365,
      OBC: 454.4711709,
      SC: 414.8605525,
      ST: 160.2806618,
      EWS: 439.9993402,
      PwBD: 229.4203219,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A. (Hons.) Geography",
    cutoffs: {
      UR: 611.8649866,
      OBC: 492.1199945,
      SC: 423.8651118,
      ST: 476.9230548,
      EWS: 412.8012679,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 253.0228662,
      OBC: 118.796219,
      SC: 99.9229247,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 591.3144004,
      OBC: 445.6710316,
      SC: 410.9335433,
      ST: 208.4520886,
      EWS: 313.9929753,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.Com.",
    cutoffs: {
      UR: 663.4768175,
      OBC: 498.2620858,
      SC: 397.6450054,
      ST: 153.5043047,
      EWS: 550.5452545,
      PwBD: 210.139472,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 712.0865653,
      OBC: 568.9031473,
      SC: 465.4572252,
      ST: 159.6072014,
      EWS: 619.7652969,
      PwBD: 246.575924,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.Sc. (Prog.) Applied Life Science",
    cutoffs: {
      UR: 447.400457,
      OBC: 414.2238271,
      SC: 286.0406106,
      ST: 201.5721977,
      EWS: 420.101939,
      PwBD: 125.6593889,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 457.1336923,
      OBC: 405.9148116,
      SC: 345.7652267,
      ST: 270.1329953,
      EWS: 422.098042,
      PwBD: 67.394321,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.Sc. (Hons.) Microbiology",
    cutoffs: {
      UR: 495.1367781,
      OBC: 480.8053307,
      SC: 371.7803285,
      ST: 363.6503902,
      EWS: 478.545514,
      PwBD: 242.5350634,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.Sc. (Hons.) Physics",
    cutoffs: {
      UR: 323.6777508,
      OBC: 237.4066126,
      SC: 135.3082707,
      ST: 55.187911,
      EWS: 257.4853388,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 322.055339,
      OBC: 252.2106178,
      SC: 106.6068828,
      ST: 133.2538784,
      EWS: 238.1379485,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 486.3941124,
      OBC: 437.5585356,
      SC: 328.128971,
      ST: 276.9759369,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 185.5393746,
      OBC: 96.3602527,
      SC: 49.1080327,
      ST: null,
      EWS: 165.5089295,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 572.0457705,
      OBC: 416.130468,
      SC: 371.6386074,
      ST: 265.9823764,
      EWS: 381.6077412,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 523.3336678,
      OBC: 396.3568376,
      SC: 397.8655885,
      ST: 275.5489913,
      EWS: 277.5905967,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 623.2219815,
      OBC: 557.1049745,
      SC: 484.8733375,
      ST: 468.0097868,
      EWS: 461.7935105,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 568.8613796,
      OBC: 428.9260752,
      SC: 394.8456192,
      ST: 200.6678331,
      EWS: 346.5818099,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 554.2606704,
      OBC: 406.5746711,
      SC: 348.5804949,
      ST: 243.5578489,
      EWS: 351.851438,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 605.0395932,
      OBC: 469.1137624,
      SC: 449.7244664,
      ST: null,
      EWS: 377.1960944,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName:
      "B.A Program (Office Management & Secretarial Practice (OMSP) + Political Science)",
    cutoffs: {
      UR: 583.232057,
      OBC: 424.6168215,
      SC: 471.8497367,
      ST: 327.3331232,
      EWS: 409.4734889,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (History + OMSP)",
    cutoffs: {
      UR: 551.514347,
      OBC: 412.3375575,
      SC: 365.2571996,
      ST: 186.9620979,
      EWS: 261.2396345,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (Mathematics + OMSP)",
    cutoffs: {
      UR: 549.3452979,
      OBC: 326.7508501,
      SC: 217.7951371,
      ST: null,
      EWS: 298.2138444,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (Sanskrit + OMSP)",
    cutoffs: {
      UR: 263.02469,
      OBC: 290.2644265,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (Sanskrit + Economics)",
    cutoffs: {
      UR: 424.490352,
      OBC: 184.6997735,
      SC: 211.3679334,
      ST: null,
      EWS: 415.8075969,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 311.5893425,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 612.7273619,
      OBC: 366.3066007,
      SC: 227.0974988,
      ST: null,
      EWS: 323.6251399,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 640.9816866,
      OBC: 465.6382513,
      SC: 364.7865316,
      ST: 201.0132263,
      EWS: 441.5493951,
      PwBD: null,
    },
  },
  {
    collegeName: "Swami Shardhanand College",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 603.0715875,
      OBC: 471.0886043,
      SC: 382.3126511,
      ST: 282.9687397,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.Com.",
    cutoffs: {
      UR: 684.9152896,
      OBC: 508.8771211,
      SC: 400.239898,
      ST: 225.1308577,
      EWS: 531.5067808,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 722.2729908,
      OBC: 582.1333144,
      SC: 466.6771093,
      ST: 179.6984701,
      EWS: 600.2450962,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A. (Hons.) Applied Psychology",
    cutoffs: {
      UR: 758.0889835,
      OBC: 555.3635449,
      SC: 508.8284601,
      ST: 419.2760971,
      EWS: 539.2207027,
      PwBD: 384.5915493,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 645.6915153,
      OBC: 472.638637,
      SC: 451.4163408,
      ST: 457.3806986,
      EWS: 427.5158139,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 213.2788823,
      OBC: 132.1205302,
      SC: 253.9315684,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 219.5751058,
      OBC: 81.8222035,
      SC: 291.1811478,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 614.8343348,
      OBC: 444.4696101,
      SC: 408.7806921,
      ST: 175.7325852,
      EWS: 318.0901975,
      PwBD: 466.6520832,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 661.5497655,
      OBC: 533.5432746,
      SC: 538.5582323,
      ST: 271.6284422,
      EWS: 312.4827684,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 499.559993,
      OBC: 281.1362858,
      SC: 227.3708856,
      ST: 263.7545321,
      EWS: 371.3204196,
      PwBD: 354.6178614,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (English + Computer Applications)",
    cutoffs: {
      UR: 588.5268607,
      OBC: 463.2380657,
      SC: 413.3052453,
      ST: 257.5051344,
      EWS: 473.3563548,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (English + French)",
    cutoffs: {
      UR: 586.4673972,
      OBC: 383.3899419,
      SC: 390.3006786,
      ST: 279.2693433,
      EWS: 373.7000009,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (English + Food Technology)",
    cutoffs: {
      UR: 656.7453679,
      OBC: 552.3882655,
      SC: 562.2636772,
      ST: 306.9016409,
      EWS: 465.8032707,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (French + Economics)",
    cutoffs: {
      UR: 523.3998003,
      OBC: 294.0245206,
      SC: 357.3492319,
      ST: null,
      EWS: 441.7191215,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 198.8526291,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (Computer Applications + Economics)",
    cutoffs: {
      UR: 630.8328169,
      OBC: 378.6544649,
      SC: 217.2669865,
      ST: null,
      EWS: 487.2060978,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (Computer Applications + Mathematics)",
    cutoffs: {
      UR: 555.6112727,
      OBC: 411.6296933,
      SC: 404.1825883,
      ST: 144.3603369,
      EWS: 412.5891887,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (Computer Applications + Political Science)",
    cutoffs: {
      UR: 553.1807859,
      OBC: 364.2533716,
      SC: 243.7905548,
      ST: null,
      EWS: 275.4022776,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 640.9049499,
      OBC: 346.6409279,
      SC: 206.5872076,
      ST: null,
      EWS: 331.6190239,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 647.6882076,
      OBC: 450.5901627,
      SC: 414.7427183,
      ST: 382.3039727,
      EWS: 475.70292,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (Food Technology (FT) + History)",
    cutoffs: {
      UR: 537.3261493,
      OBC: 407.3717851,
      SC: 340.0883112,
      ST: null,
      EWS: 396.3904153,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (Food Technology (FT) + Political Science)",
    cutoffs: {
      UR: 567.8650958,
      OBC: 456.7559225,
      SC: 331.5963535,
      ST: 173.1746942,
      EWS: 188.7399588,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (History + Music)",
    cutoffs: {
      UR: 472.2738652,
      OBC: 338.467634,
      SC: 180.7891733,
      ST: null,
      EWS: null,
      PwBD: 271.2872476,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 618.9356104,
      OBC: 473.4324003,
      SC: 431.166872,
      ST: 337.9318735,
      EWS: 418.1373543,
      PwBD: 367.1522043,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.A Program (Sanskrit + Music)",
    cutoffs: {
      UR: 239.5098836,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Vivekananda College (W)",
    programName: "B.Sc. (Hons.) Home Science",
    cutoffs: {
      UR: 395.8462704,
      OBC: 275.1205182,
      SC: 261.7078391,
      ST: 176.1583828,
      EWS: 242.3547338,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) Arabic",
    cutoffs: {
      UR: 523.5459067,
      OBC: 359.9885431,
      SC: 270.7387872,
      ST: null,
      EWS: 321.994698,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) Bengali",
    cutoffs: {
      UR: 198.3003423,
      OBC: 271.4708813,
      SC: 223.8823761,
      ST: 175.7325852,
      EWS: 140.9057316,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) Economics",
    cutoffs: {
      UR: 700.5961188,
      OBC: 464.3467218,
      SC: 332.0191506,
      ST: 235.3228477,
      EWS: 464.1321186,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 670.3393777,
      OBC: 506.1998323,
      SC: 468.6135966,
      ST: 508.2076408,
      EWS: 493.2179269,
      PwBD: 164.4673868,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 387.0630235,
      OBC: 186.0190075,
      SC: 262.62178,
      ST: null,
      EWS: 155.3065073,
      PwBD: 334.2878318,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 689.9892379,
      OBC: 549.0131738,
      SC: 556.1404009,
      ST: 489.6566285,
      EWS: 381.1200963,
      PwBD: 308.1278018,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) Persian",
    cutoffs: {
      UR: 490.7517024,
      OBC: 329.8609901,
      SC: 287.0548409,
      ST: 200.6706916,
      EWS: 249.4554263,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) Philosophy",
    cutoffs: {
      UR: 629.4514484,
      OBC: 451.2964987,
      SC: 398.6106907,
      ST: 259.1419819,
      EWS: 385.5976182,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 692.6276604,
      OBC: 592.1265287,
      SC: 522.0461803,
      ST: 512.8608825,
      EWS: 535.0815508,
      PwBD: 339.2591837,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) Psychology",
    cutoffs: {
      UR: 778.0594346,
      OBC: 638.7897998,
      SC: 583.4534528,
      ST: 607.5348504,
      EWS: 589.4372671,
      PwBD: 349.6289242,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 394.7465087,
      OBC: 86.1738135,
      SC: 170.5131313,
      ST: null,
      EWS: 206.0711383,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A. (Hons.) Urdu",
    cutoffs: {
      UR: 111.2921784,
      OBC: 151.8817124,
      SC: 97.9344714,
      ST: null,
      EWS: 111.3299417,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.Com.",
    cutoffs: {
      UR: 723.0579801,
      OBC: 571.6932098,
      SC: 481.4199595,
      ST: 282.4237935,
      EWS: 618.5526192,
      PwBD: 529.807618,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 735.3089148,
      OBC: 602.5570529,
      SC: 508.7756047,
      ST: 397.7252001,
      EWS: 644.9475506,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.Sc (Prog.) Physical Science with Chemistry",
    cutoffs: {
      UR: 239.3228218,
      OBC: 116.415057,
      SC: 22.2786899,
      ST: 203.1327897,
      EWS: 202.5026606,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.Sc. (Prog.) Life Science",
    cutoffs: {
      UR: 446.1385489,
      OBC: 405.7148859,
      SC: 330.9753111,
      ST: 206.3979516,
      EWS: 366.2150752,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.Sc. (Hons.) Botany",
    cutoffs: {
      UR: 460.4952957,
      OBC: 424.8510931,
      SC: 350.0269239,
      ST: 321.9015144,
      EWS: 415.7687912,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.Sc. (Hons.) Chemistry",
    cutoffs: {
      UR: 327.5214178,
      OBC: 255.6573843,
      SC: 125.786486,
      ST: 76.34813,
      EWS: 263.0115279,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.Sc. (Hons.) Electronics",
    cutoffs: {
      UR: 316.2597947,
      OBC: 213.3082863,
      SC: 31.1756246,
      ST: 77.4573923,
      EWS: 242.0547072,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.Sc. (Hons.) Mathematics",
    cutoffs: {
      UR: 532.4032448,
      OBC: 421.6161436,
      SC: 287.5779257,
      ST: 125.8687218,
      EWS: 380.6184793,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.Sc. (Hons.) Zoology",
    cutoffs: {
      UR: 468.5423361,
      OBC: 459.0114488,
      SC: 382.3372653,
      ST: 357.0255421,
      EWS: 432.6691166,
      PwBD: 102.4635417,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Arabic + Economics)",
    cutoffs: {
      UR: 484.5740261,
      OBC: 235.9234584,
      SC: 263.0234571,
      ST: null,
      EWS: 284.454109,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Arabic + History)",
    cutoffs: {
      UR: 436.4408237,
      OBC: 367.7287299,
      SC: null,
      ST: null,
      EWS: 273.8934513,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Arabic + Political Science)",
    cutoffs: {
      UR: 400.2021983,
      OBC: 219.513919,
      SC: 200.0374123,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Bengali + Economics)",
    cutoffs: {
      UR: 462.3038985,
      OBC: null,
      SC: 142.6061621,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Bengali + History)",
    cutoffs: {
      UR: 250.4070862,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Bengali + Political Science)",
    cutoffs: {
      UR: 241.9124264,
      OBC: null,
      SC: 122.15618,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 693.3752684,
      OBC: 517.7527946,
      SC: 481.9463456,
      ST: null,
      EWS: 532.1637211,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 653.9376307,
      OBC: 561.5973997,
      SC: 487.9004537,
      ST: 448.9635321,
      EWS: 465.8317049,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (English + Mathematics)",
    cutoffs: {
      UR: 640.8256522,
      OBC: 491.5855436,
      SC: 351.7528247,
      ST: null,
      EWS: 438.8878663,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 660.5327318,
      OBC: 570.4677667,
      SC: 509.7878805,
      ST: 566.2321681,
      EWS: 556.280258,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Hindi + Economics)",
    cutoffs: {
      UR: 577.2868131,
      OBC: 444.0198794,
      SC: 426.0761016,
      ST: 244.4412627,
      EWS: 376.072302,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 561.0029156,
      OBC: 445.9008015,
      SC: 416.0623364,
      ST: 312.1740069,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 579.4020396,
      OBC: 452.1619783,
      SC: 438.3291836,
      ST: 174.520514,
      EWS: 374.1688331,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Persian + Economics)",
    cutoffs: {
      UR: 360.8265514,
      OBC: 282.3903961,
      SC: 224.6875295,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Persian + History)",
    cutoffs: {
      UR: 264.7319161,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Persian + Political Science)",
    cutoffs: {
      UR: 128.8693763,
      OBC: 204.7007571,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Sanskrit + Economics)",
    cutoffs: {
      UR: 399.7431351,
      OBC: 289.6340751,
      SC: 324.1761364,
      ST: null,
      EWS: 222.2803464,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 341.6524707,
      OBC: 311.5637179,
      SC: 204.951055,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 321.7072596,
      OBC: 213.0862633,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Urdu + Economics)",
    cutoffs: {
      UR: 505.4356843,
      OBC: 356.6634139,
      SC: null,
      ST: 343.5257653,
      EWS: 194.6390761,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Urdu + History)",
    cutoffs: {
      UR: 441.5598456,
      OBC: 247.9418151,
      SC: null,
      ST: 289.8023469,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Urdu + Political Science)",
    cutoffs: {
      UR: 498.1899777,
      OBC: 289.9676145,
      SC: null,
      ST: 222.0863663,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Economics + Human Resource Management (HRM))",
    cutoffs: {
      UR: 677.7189606,
      OBC: 508.0183386,
      SC: 457.4744386,
      ST: 315.1693846,
      EWS: 515.2472112,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 646.4400352,
      OBC: 466.2586699,
      SC: 411.2461563,
      ST: 302.2104181,
      EWS: 194.6390761,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 657.2005342,
      OBC: 543.9969572,
      SC: 503.8067234,
      ST: 521.5522793,
      EWS: 471.5585439,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (History + Philosophy)",
    cutoffs: {
      UR: 630.6717468,
      OBC: 452.340018,
      SC: 425.6137404,
      ST: 392.3288572,
      EWS: 378.3979797,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 626.6990617,
      OBC: 507.6845807,
      SC: 465.8159703,
      ST: 502.925864,
      EWS: 486.5631118,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Human Resource Management (HRM) + Psychology)",
    cutoffs: {
      UR: 747.1057365,
      OBC: 554.7752621,
      SC: 580.3269955,
      ST: 494.4011313,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Mathematics + Philosophy)",
    cutoffs: {
      UR: 591.4206708,
      OBC: 457.3383123,
      SC: 389.9921561,
      ST: null,
      EWS: 426.6002047,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Mathematics + Psychology)",
    cutoffs: {
      UR: 673.4532385,
      OBC: 490.7193449,
      SC: 451.9237921,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College",
    programName: "B.A Program (Philosophy + Psychology)",
    cutoffs: {
      UR: 743.9802112,
      OBC: 575.2486216,
      SC: 575.3751592,
      ST: 507.2868652,
      EWS: 474.3059313,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A. (Hons.) English",
    cutoffs: {
      UR: 591.4534394,
      OBC: 431.8628499,
      SC: 376.5188196,
      ST: 392.3328633,
      EWS: 400.5900079,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A. (Hons.) Hindi",
    cutoffs: {
      UR: 389.6558066,
      OBC: 200.4484385,
      SC: 276.7423433,
      ST: null,
      EWS: 190.2138809,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A. (Hons.) History",
    cutoffs: {
      UR: 553.2450346,
      OBC: 417.2319407,
      SC: 380.2604199,
      ST: 305.869642,
      EWS: 313.7183623,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A. (Hons.) Persian",
    cutoffs: {
      UR: 463.2928844,
      OBC: 291.7692704,
      SC: 215.2179426,
      ST: null,
      EWS: 235.027927,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A. (Hons.) Political Science",
    cutoffs: {
      UR: 580.0497959,
      OBC: 463.2588435,
      SC: 397.4877458,
      ST: 360.9691543,
      EWS: 347.4857798,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A. (Hons.) Sanskrit",
    cutoffs: {
      UR: 394.2529003,
      OBC: 146.8299323,
      SC: 92.3718522,
      ST: null,
      EWS: 171.0084007,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A. (Hons.) Urdu",
    cutoffs: {
      UR: 256.6209046,
      OBC: 231.8430662,
      SC: 145.6961959,
      ST: null,
      EWS: 183.0537893,
      PwBD: 509.9665025,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.Com. (Hons.)",
    cutoffs: {
      UR: 683.3849118,
      OBC: 525.3797394,
      SC: 425.4883012,
      ST: 115.5307079,
      EWS: 563.1961709,
      PwBD: 291.2755146,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.Com.",
    cutoffs: {
      UR: 646.4675002,
      OBC: 484.4834768,
      SC: 361.9590135,
      ST: 136.8064841,
      EWS: 502.7363472,
      PwBD: 330.1381891,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Arabic + Economics)",
    cutoffs: {
      UR: 473.9133431,
      OBC: 280.4819251,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Arabic + History)",
    cutoffs: {
      UR: 369.4203288,
      OBC: 121.3083857,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Arabic + Political Science)",
    cutoffs: {
      UR: 435.8610567,
      OBC: 343.7683045,
      SC: null,
      ST: null,
      EWS: 341.1921436,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Bengali + Economics)",
    cutoffs: {
      UR: 362.9173681,
      OBC: 309.7201599,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Bengali + History)",
    cutoffs: {
      UR: 124.739447,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Bengali + Political Science)",
    cutoffs: {
      UR: 226.0826963,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (English + Economics)",
    cutoffs: {
      UR: 636.1850792,
      OBC: 468.2202724,
      SC: 361.5677449,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (English + History)",
    cutoffs: {
      UR: 585.2496662,
      OBC: 480.5301883,
      SC: 498.928474,
      ST: 331.6884385,
      EWS: null,
      PwBD: 394.4204065,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (English + Political Science)",
    cutoffs: {
      UR: 625.52991,
      OBC: 576.4651908,
      SC: null,
      ST: null,
      EWS: 484.9003243,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Hindi + Economics)",
    cutoffs: {
      UR: 549.0902839,
      OBC: 414.6031655,
      SC: 342.9379019,
      ST: null,
      EWS: 318.8744487,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Hindi + History)",
    cutoffs: {
      UR: 524.9783803,
      OBC: 409.0424519,
      SC: 338.7369372,
      ST: null,
      EWS: 259.6085532,
      PwBD: 229.6265176,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Hindi + Political Science)",
    cutoffs: {
      UR: 527.6960586,
      OBC: 421.0598189,
      SC: 400.4171824,
      ST: null,
      EWS: 246.5197025,
      PwBD: 138.3164205,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Persian + Economics)",
    cutoffs: {
      UR: 333.0213511,
      OBC: null,
      SC: 184.2820589,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Persian + History)",
    cutoffs: {
      UR: 241.1259552,
      OBC: null,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Persian + Political Science)",
    cutoffs: {
      UR: 112.3727617,
      OBC: 306.0408769,
      SC: null,
      ST: null,
      EWS: 301.8148937,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Sanskrit + Economics)",
    cutoffs: {
      UR: 395.9010243,
      OBC: 229.6357076,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Sanskrit + History)",
    cutoffs: {
      UR: 296.9226405,
      OBC: null,
      SC: null,
      ST: null,
      EWS: 175.2453801,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Sanskrit + Political Science)",
    cutoffs: {
      UR: 359.0589592,
      OBC: 170.7506191,
      SC: 212.6480511,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Urdu + Economics)",
    cutoffs: {
      UR: 482.8977625,
      OBC: 311.3413417,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Urdu + History)",
    cutoffs: {
      UR: 392.9014071,
      OBC: 232.1944737,
      SC: null,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Urdu + Political Science)",
    cutoffs: {
      UR: 496.5239931,
      OBC: 375.258836,
      SC: null,
      ST: 144.8950076,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Economics + History)",
    cutoffs: {
      UR: 551.5522031,
      OBC: 391.4788417,
      SC: 353.6923459,
      ST: 321.055704,
      EWS: 377.1794813,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Economics + Human Resource Management (HRM))",
    cutoffs: {
      UR: 637.9425359,
      OBC: 473.9271883,
      SC: 375.0581039,
      ST: 178.8979561,
      EWS: 502.8112315,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Economics + Mathematics)",
    cutoffs: {
      UR: 602.0580787,
      OBC: 378.4783099,
      SC: 225.1906827,
      ST: null,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Economics + Philosophy)",
    cutoffs: {
      UR: 638.7769134,
      OBC: 506.7176495,
      SC: 348.9200905,
      ST: 305.9912633,
      EWS: 463.1853103,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Economics + Political Science)",
    cutoffs: {
      UR: 559.1209126,
      OBC: 383.4773128,
      SC: 342.6878081,
      ST: 299.0089086,
      EWS: 500.7956856,
      PwBD: 214.0620919,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (History + Political Science)",
    cutoffs: {
      UR: 552.7288149,
      OBC: 442.7621493,
      SC: 424.7776325,
      ST: 354.1949732,
      EWS: 375.2936741,
      PwBD: 178.0912368,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Philosophy + Political Science)",
    cutoffs: {
      UR: 615.3357939,
      OBC: 395.3513664,
      SC: 423.5980087,
      ST: 366.6241764,
      EWS: null,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (English + Philosophy)",
    cutoffs: {
      UR: 699.8504113,
      OBC: 506.9291173,
      SC: 444.7278731,
      ST: null,
      EWS: 421.3544841,
      PwBD: null,
    },
  },
  {
    collegeName: "Zakir Husain Delhi College (Evening)",
    programName: "B.A Program (Banking and Insurance + Economics)",
    cutoffs: {
      UR: 657.2702551,
      OBC: 507.4645441,
      SC: 482.0463829,
      ST: 336.3837395,
      EWS: 507.9283601,
      PwBD: 419.736109,
    },
  },
];

export const northCampusCollegesList = [
  "Shri Ram College of Commerce",
  "Hindu College",
  "St. Stephen's College",
  "Hansraj College",
  "Miranda House (W)",
  "Kirori Mal College",
  "Daulat Ram College (W)",
  "Ramjas College",
  "Sri Guru Tegh Bahadur Khalsa College",
];

export const topCollegesList = [
  "Shaheed Sukhdev College Business Studies",
  "Shri Ram College of Commerce",
  "Hindu College",
  "Lady Shri Ram College for Women (W)",
  "St. Stephen's College",
  "Hansraj College",
  "Miranda House (W)",
  "Ramjas College",
  "Kirori Mal College",
  "Sri Guru Gobind Singh College of Commerce",
  "Sri Venkateswara College",
];

/**
 * Get all colleges offering a specific program.
 */
export function getCollegesForProgram(programName) {
  return collegeData[programName] || [];
}

/**
 * Get cutoff for a specific college-program combination.
 */
export function getCutoffForCollegeProgram(collegeName, programName) {
  const entry = cutoffData.find(
    (e) => e.collegeName === collegeName && e.programName === programName
  );
  return entry ? entry.cutoffs : null;
}

/**
 * Get all programs offered by a specific college (reverse lookup).
 */
export function getAllProgramsForCollege(collegeName) {
  const programs = [];
  for (const [programName, colleges] of Object.entries(collegeData)) {
    const college = colleges.find((c) => c.name === collegeName);
    if (college) {
      const cutoffs = getCutoffForCollegeProgram(collegeName, programName);
      programs.push({
        programName,
        seats: college.seats,
        cutoffs,
      });
    }
  }
  return programs;
}

/**
 * Get all unique college names.
 */
export function getAllCollegeNames() {
  const names = new Set();
  for (const colleges of Object.values(collegeData)) {
    colleges.forEach((c) => names.add(c.name));
  }
  return Array.from(names).sort();
}
